import React, { useState, useRef, Children, lazy, Component } from 'react';
import { motion, useInView, AnimatePresence } from 'framer-motion';
import { LinkIcon, InfoIcon, PlaneTakeoffIcon, MapIcon, ChevronDownIcon, MapPinIcon, PhoneIcon, MailIcon, ClipboardListIcon, XIcon, AlertTriangleIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { ConsulateMap } from './ConsulateMap';
export interface Consulate {
  name: string;
  nameEs?: string;
  address: string;
  phone: string;
  email?: string;
  isEmbassy?: boolean;
  facebook?: string;
  lat: number;
  lng: number;
}
interface ConsularTip {
  icon: ComponentType<{
    className?: string;
  }>;
  titleKey: string;
  descriptionKey: string;
  link?: {
    label: string;
    url: string;
  };
  links?: {
    label: string;
    labelEs?: string;
    url: string;
    info?: string;
  }[];
  consulates?: Consulate[];
  gradient: string;
  borderColor: string;
  accentColor: string;
  flag?: string;
}
export const tips: ConsularTip[] = [{
  icon: ClipboardListIcon,
  titleKey: 'consular.card4.title',
  descriptionKey: 'consular.card4.description',
  links: [{
    label: 'Consular Fees',
    labelEs: 'Aranceles Consulares',
    url: '#',
    info: 'fees'
  }, {
    label: 'Consular Appointments Guide',
    labelEs: 'Guía de Citas Consulares',
    url: '#',
    info: 'appointments'
  }, {
    label: 'Consular Appointment Guide',
    labelEs: 'Guía de Citas Consulares',
    url: '#',
    info: 'la-appointments'
  }, {
    label: 'DNI Locator Search',
    labelEs: 'Búsqueda de Entrega de DNI',
    url: 'https://entregadni.rnp.hn/dni/#/',
    info: 'dni-locator'
  }, {
    label: 'ICE Detainee Locator',
    labelEs: 'Localizador de Detenidos por ICE',
    url: '#',
    info: 'detainee-locator'
  }, {
    label: 'Immigrant Protection Services',
    labelEs: 'Servicio de Protección al Migrante',
    url: '#',
    info: 'migrant-protection'
  }, {
    label: 'Repatriation Services',
    labelEs: 'Servicios de Repatriación',
    url: '#',
    info: 'repatriation'
  }, {
    label: 'Consular Service Complaint',
    labelEs: 'Queja de Servicio Consular',
    url: '#',
    info: 'complaint'
  }, {
    label: 'Positive Consular Experience',
    labelEs: 'Experiencia Consular Positiva',
    url: '#',
    info: 'positive-feedback'
  }, {
    label: 'Invite an Official to Event',
    labelEs: 'Invitar a un Oficial a un Evento',
    url: '#',
    info: 'invite-official'
  }],
  gradient: 'from-haa-skyblue to-haa-midblue',
  borderColor: 'border-haa-skyblue',
  accentColor: 'text-haa-skyblue'
}, {
  icon: MapIcon,
  titleKey: 'consular.card2.title',
  descriptionKey: 'consular.card2.description',
  consulates: [{
    name: 'Embassy of Honduras',
    nameEs: 'Embajada de Honduras',
    address: '1220 19th St NW #320, Washington D.C., 20036',
    phone: '470-751-9077',
    email: 'embassy@hondurasemb.org',
    isEmbassy: true,
    lat: 38.9065,
    lng: -77.0434
  }, {
    name: 'Consulate of Atlanta',
    nameEs: 'Consulado de Atlanta',
    address: '6755 Peachtree Industrial Blvd, Atlanta, GA 30360',
    phone: '470-751-9077',
    facebook: 'https://www.facebook.com/CGHONDURASATLANTA/',
    lat: 33.8977,
    lng: -84.2755
  }, {
    name: 'Consulate of Aurora',
    nameEs: 'Consulado de Aurora',
    address: '14707 E 2nd Ave, Aurora, CO 80011',
    phone: '470-751-9077',
    facebook: 'https://www.facebook.com/p/Consulado-de-Honduras-en-Aurora-Colorado-61567222863854/',
    lat: 39.722,
    lng: -104.813
  }, {
    name: 'Consulate of Boston',
    nameEs: 'Consulado de Boston',
    address: '90 Everett Ave, Chelsea, MA 02150',
    phone: '617-466-0658',
    facebook: 'https://www.facebook.com/consuladohnbos/',
    lat: 42.3918,
    lng: -71.0328
  }, {
    name: 'Consulate of Charlotte',
    nameEs: 'Consulado de Charlotte',
    address: '5820 E W.T Harris Blvd, Suite 3118-G/J, Charlotte, NC 28215',
    phone: '470-751-9077',
    facebook: 'https://www.facebook.com/ConsuladodeHondurasenCharlotte/',
    lat: 35.2175,
    lng: -80.754
  }, {
    name: 'Consulate of Chicago',
    nameEs: 'Consulado de Chicago',
    address: '812 W Van Buren St STE. 1FL, Chicago, IL 60607',
    phone: '470-751-9077',
    facebook: 'https://www.facebook.com/ConsuladoGeneraldeHondurasChicago/',
    lat: 41.8764,
    lng: -87.6475
  }, {
    name: 'Consulate of Dallas',
    nameEs: 'Consulado de Dallas',
    address: '2520 W Irving Blvd #400, Irving, TX 75061',
    phone: '470-751-9077',
    lat: 32.814,
    lng: -96.97
  }, {
    name: 'Consulate of Houston',
    nameEs: 'Consulado de Houston',
    address: '3100 Wilcrest Dr Suite 110, Houston, TX 77042',
    phone: '470-751-9077',
    facebook: 'https://www.facebook.com/p/Consulado-General-de-Honduras-en-Houston-100087005227895/',
    lat: 29.735,
    lng: -95.56
  }, {
    name: 'Consulate of Kansas',
    nameEs: 'Consulado de Kansas',
    address: '6310 Lamar Ave, Overland Park, KS 66202',
    phone: '470-751-9077',
    facebook: 'https://www.facebook.com/profile.php?id=61587955349837',
    lat: 38.99,
    lng: -94.665
  }, {
    name: 'Consulate of Los Angeles',
    nameEs: 'Consulado de Los Ángeles',
    address: '3550 Wilshire Blvd, Suite# 916, Los Angeles, CA 90010',
    phone: '470-751-9077',
    facebook: 'https://www.facebook.com/consuladohnla/?locale=es_LA',
    lat: 34.0615,
    lng: -118.309
  }, {
    name: 'Consulate of McAllen',
    nameEs: 'Consulado de McAllen',
    address: '1209 Galveston Ave, McAllen, TX 78501',
    phone: '956-627-1179',
    facebook: 'https://www.facebook.com/p/Consulado-de-Honduras-en-McAllen-Texas-100064322366806/',
    lat: 26.2034,
    lng: -98.23
  }, {
    name: 'Consulate of Miami',
    nameEs: 'Consulado de Miami',
    address: '777 NW 72nd Avenue, Suite 3318, Miami, FL 33126',
    phone: '470-751-9077',
    facebook: 'https://www.facebook.com/consuladohn/?locale=es_LA',
    lat: 25.782,
    lng: -80.318
  }, {
    name: 'Consulate of New Orleans',
    nameEs: 'Consulado de Nueva Orleans',
    address: '1250 Poydras St Suite #100, New Orleans, LA 70113',
    phone: '470-751-9077',
    facebook: 'https://www.facebook.com/consuladonolahn/?locale=es_LA',
    lat: 29.948,
    lng: -90.075
  }, {
    name: 'Consulate of New York',
    nameEs: 'Consulado de Nueva York',
    address: '120 W 23rd St, New York, NY 10011',
    phone: '470-751-9077',
    facebook: 'https://www.facebook.com/Consuladohnny/',
    lat: 40.7425,
    lng: -73.994
  }, {
    name: 'Consulate of Oakland',
    nameEs: 'Consulado de Oakland',
    address: '500 12th St Suite 330, Oakland, CA 94612',
    phone: '510-338-3010',
    facebook: 'https://www.facebook.com/p/Consulado-de-Honduras-en-San-Francisco-61557000012971/',
    lat: 37.8044,
    lng: -122.2712
  }, {
    name: 'Consulate of Phoenix',
    nameEs: 'Consulado de Phoenix',
    address: '3724 N 3rd St STE 300 3rd Floor, Phoenix, AZ 85012',
    phone: '480-361-4095',
    facebook: 'https://www.facebook.com/profile.php?id=61568642711170',
    lat: 33.48,
    lng: -112.07
  }, {
    name: 'Consulate of Pittsburgh',
    nameEs: 'Consulado de Pittsburgh',
    address: '309 Smithfield St 3rd floor, Pittsburgh, PA 15222',
    phone: '412-291-8935',
    facebook: 'https://www.facebook.com/p/Pittsburgh-Consulado-General-de-Honduras-en-Pittsburgh-61564929864650/',
    lat: 40.438,
    lng: -80.0
  }, {
    name: 'Consulate of Seattle',
    nameEs: 'Consulado de Seattle',
    address: '1107 SW Grady Way, Suite 100, Renton, WA 98057',
    phone: '470-751-9077',
    facebook: 'https://www.facebook.com/consuladogeneraldehondurasenseattle/?locale=es_LA',
    lat: 47.377,
    lng: -122.213
  }, {
    name: 'Consulate of Tampa',
    nameEs: 'Consulado de Tampa',
    address: '4023 N Armenia Ave #300, Tampa, FL 33607',
    phone: '470-751-9077',
    facebook: 'https://www.facebook.com/p/Consulado-de-Honduras-en-Tampa-61561028897749/',
    lat: 27.968,
    lng: -82.483
  }, {
    name: 'Consulate of Washington D.C.',
    nameEs: 'Consulado de Washington D.C.',
    address: '1990 M St. NW, Washington D.C., DC 20036',
    phone: '202-733-1702',
    facebook: 'https://www.facebook.com/seccionconsularhonduras/?locale=es_LA',
    lat: 38.9055,
    lng: -77.0445
  }],
  links: [{
    label: 'State Apostille Offices',
    labelEs: 'Oficinas de Apostilla por Estado',
    url: '#',
    info: 'state-offices'
  }],
  gradient: 'from-haa-midblue to-haa-blue',
  borderColor: 'border-haa-midblue',
  accentColor: 'text-haa-midblue'
}, {
  icon: LinkIcon,
  titleKey: 'consular.card1.title',
  descriptionKey: 'consular.card1.description',
  flag: '🇭🇳',
  links: [{
    label: 'INM — Returnee Services',
    labelEs: 'INM — Servicios para Retornados',
    url: 'https://inm.gob.hn/retornados.html'
  }, {
    label: 'Honduras Embassy in USA (Facebook)',
    labelEs: 'Embajada de Honduras en EE.UU. (Facebook)',
    url: 'https://www.facebook.com/EmbHondurasUSA/'
  }, {
    label: 'Honduras Foreign Ministry',
    labelEs: 'Cancillería de Honduras',
    url: 'https://sreci.gob.hn/'
  }, {
    label: 'National Registry of Persons',
    labelEs: 'Registro Nacional de las Personas',
    url: 'https://www.rnp.hn/sites/rnpweb/Inicio'
  }, {
    label: 'National Institute of Migration',
    labelEs: 'Instituto Nacional de Migración',
    url: 'https://inm.gob.hn/'
  }, {
    label: 'DIGER — Government Procedures Portal',
    labelEs: 'DIGER — Portal de Trámites del Gobierno',
    url: 'https://tramites.diger.gob.hn/tramites'
  }, {
    label: 'Congress of Honduras',
    labelEs: 'Congreso Nacional de Honduras',
    url: 'https://congresonacional.hn/en-US'
  }],
  gradient: 'from-haa-blue to-haa-navy',
  borderColor: 'border-haa-blue',
  accentColor: 'text-haa-blue'
}, {
  icon: PlaneTakeoffIcon,
  titleKey: 'consular.card3.title',
  descriptionKey: 'consular.card3.description',
  flag: '🇺🇸',
  link: {
    label: 'Honduras Travel Advisory',
    url: 'https://travel.state.gov/content/travel/en/traveladvisories/traveladvisories/honduras-travel-advisory.html'
  },
  links: [{
    label: 'USCIS — Immigration Case Status Check',
    labelEs: 'USCIS — Verificación de Estado de Caso de Inmigración',
    url: 'https://egov.uscis.gov/'
  }, {
    label: 'USCIS — Immigration Case Processing Times',
    labelEs: 'USCIS — Tiempos de Procesamiento de Casos de Inmigración',
    url: 'https://egov.uscis.gov/processing-times/'
  }],
  gradient: 'from-haa-navy to-blue-950',
  borderColor: 'border-haa-navy',
  accentColor: 'text-haa-navy'
}];
export function TipCard({
  tip,
  index
}: {
  tip: ConsularTip;
  index: number;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  const [openConsulate, setOpenConsulate] = useState<number | null>(null);
  const [openLinkInfo, setOpenLinkInfo] = useState<number | null>(null);
  const [openFeeSubItem, setOpenFeeSubItem] = useState<number | null>(null);
  const [consulateLocationsOpen, setConsulateLocationsOpen] = useState(false);
  const [openNestedConsulate, setOpenNestedConsulate] = useState<number | null>(null);
  const [emergencyOpen, setEmergencyOpen] = useState(false);
  const [mapModalOpen, setMapModalOpen] = useState(false);
  const [expandedModal, setExpandedModal] = useState(false);
  // Complaint form state
  const [complaintModalOpen, setComplaintModalOpen] = useState(false);
  const [complaintName, setComplaintName] = useState('');
  const [complaintPhone, setComplaintPhone] = useState('');
  const [complaintEmail, setComplaintEmail] = useState('');
  const [complaintRating, setComplaintRating] = useState<number | null>(null);
  const [complaintConsulate, setComplaintConsulate] = useState('');
  const [complaintText, setComplaintText] = useState('');
  const [complaintSubmitted, setComplaintSubmitted] = useState(false);
  const [complaintDate, setComplaintDate] = useState('');
  const [complaintAgentName, setComplaintAgentName] = useState('');
  const [complaintAnonymous, setComplaintAnonymous] = useState(false);
  const [complaintTimeSpent, setComplaintTimeSpent] = useState('');
  // Positive feedback form state
  const [positiveFeedbackModalOpen, setPositiveFeedbackModalOpen] = useState(false);
  const [positiveName, setPositiveName] = useState('');
  const [positivePhone, setPositivePhone] = useState('');
  const [positiveEmail, setPositiveEmail] = useState('');
  const [positiveRating, setPositiveRating] = useState<number | null>(null);
  const [positiveConsulate, setPositiveConsulate] = useState('');
  const [positiveText, setPositiveText] = useState('');
  const [positiveSubmitted, setPositiveSubmitted] = useState(false);
  const [positiveDate, setPositiveDate] = useState('');
  const [positiveAgentName, setPositiveAgentName] = useState('');
  const [positiveAnonymous, setPositiveAnonymous] = useState(false);
  const [positiveTimeSpent, setPositiveTimeSpent] = useState('');
  // Invite Official form state
  const [inviteModalOpen, setInviteModalOpen] = useState(false);
  const [inviteName, setInviteName] = useState('');
  const [inviteOrg, setInviteOrg] = useState('');
  const [invitePhone, setInvitePhone] = useState('');
  const [inviteEmail, setInviteEmail] = useState('');
  const [inviteDate, setInviteDate] = useState('');
  const [inviteDescription, setInviteDescription] = useState('');
  const [inviteSubmitted, setInviteSubmitted] = useState(false);
  const {
    t,
    language
  } = useLanguage();
  const isEs = language === 'ES';
  const Icon = tip.icon;
  // Get consulates for dropdown from tips[1]
  const consulateOptions = (tips[1].consulates || []).filter(c => !c.isEmbassy);
  const resetComplaintForm = () => {
    setComplaintName('');
    setComplaintPhone('');
    setComplaintEmail('');
    setComplaintRating(null);
    setComplaintConsulate('');
    setComplaintText('');
    setComplaintSubmitted(false);
    setComplaintDate('');
    setComplaintAgentName('');
    setComplaintAnonymous(false);
    setComplaintTimeSpent('');
  };
  const resetPositiveFeedbackForm = () => {
    setPositiveName('');
    setPositivePhone('');
    setPositiveEmail('');
    setPositiveRating(null);
    setPositiveConsulate('');
    setPositiveText('');
    setPositiveSubmitted(false);
    setPositiveDate('');
    setPositiveAgentName('');
    setPositiveAnonymous(false);
    setPositiveTimeSpent('');
  };
  const resetInviteForm = () => {
    setInviteName('');
    setInviteOrg('');
    setInvitePhone('');
    setInviteEmail('');
    setInviteDate('');
    setInviteDescription('');
    setInviteSubmitted(false);
  };
  const handleInviteSubmit = () => {
    const lines = [`*${isEs ? 'Solicitud de Invitación a Oficial' : 'Official Invitation Request'}*`, '', `*${isEs ? 'Nombre' : 'Name'}:* ${inviteName}`, `*${isEs ? 'Organización' : 'Organization'}:* ${inviteOrg}`, `*${isEs ? 'Teléfono' : 'Phone'}:* ${invitePhone}`, `*${isEs ? 'Correo' : 'Email'}:* ${inviteEmail}`, `*${isEs ? 'Fecha del Evento' : 'Event Date'}:* ${inviteDate}`, '', `*${isEs ? 'Descripción' : 'Description'}:*`, inviteDescription];
    const message = encodeURIComponent(lines.join('\n'));
    window.open(`https://wa.me/17033131465?text=${message}`, '_blank');
    setInviteSubmitted(true);
  };
  const COMPLAINT_SHEETS_URL = 'https://script.google.com/macros/s/AKfycbyGcIUI58Iql2YX_1CrA0HyxcbA1Ts14_kFcfuxnbsnh3drqetfN3TgwRE4600kwW8P4g/exec';
  const handleComplaintSubmit = () => {
    const displayName = complaintAnonymous ? isEs ? 'Anónimo' : 'Anonymous' : complaintName;
    const displayPhone = complaintAnonymous ? isEs ? 'Anónimo' : 'Anonymous' : complaintPhone;
    const displayEmail = complaintAnonymous ? isEs ? 'Anónimo' : 'Anonymous' : complaintEmail;
    const data = {
      type: 'complaint',
      name: displayName,
      phone: displayPhone,
      email: displayEmail,
      rating: complaintRating,
      consulate: complaintConsulate,
      date: complaintDate,
      timeSpent: complaintTimeSpent || '',
      agentName: complaintAgentName || '',
      description: complaintText,
      timestamp: new Date().toISOString()
    };
    fetch(COMPLAINT_SHEETS_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'text/plain;charset=utf-8'
      },
      body: JSON.stringify(data)
    }).catch(err => {
      console.warn('Complaint Google Sheets submission error:', err);
    });
    setComplaintSubmitted(true);
  };
  const handlePositiveFeedbackSubmit = () => {
    const displayName = positiveAnonymous ? isEs ? 'Anónimo' : 'Anonymous' : positiveName || (isEs ? 'No proporcionado' : 'Not provided');
    const displayPhone = positiveAnonymous ? isEs ? 'Anónimo' : 'Anonymous' : positivePhone || (isEs ? 'No proporcionado' : 'Not provided');
    const displayEmail = positiveAnonymous ? isEs ? 'Anónimo' : 'Anonymous' : positiveEmail || (isEs ? 'No proporcionado' : 'Not provided');
    const data = {
      type: 'positive-feedback',
      name: displayName,
      phone: displayPhone,
      email: displayEmail,
      rating: positiveRating,
      consulate: positiveConsulate,
      date: positiveDate,
      timeSpent: positiveTimeSpent || '',
      agentName: positiveAgentName || '',
      description: positiveText,
      timestamp: new Date().toISOString()
    };
    fetch(COMPLAINT_SHEETS_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'text/plain;charset=utf-8'
      },
      body: JSON.stringify(data)
    }).catch(err => {
      console.warn('Positive feedback Google Sheets submission error:', err);
    });
    setPositiveSubmitted(true);
  };
  const getRatingColor = (rating: number) => {
    if (rating <= 3) return 'bg-red-500 text-white border-red-500';
    if (rating <= 6) return 'bg-amber-500 text-white border-amber-500';
    return 'bg-emerald-500 text-white border-emerald-500';
  };
  const feeItems: {
    service: string;
    price: string;
    subContent?: React.ReactNode;
  }[] = [{
    service: isEs ? 'Pasaporte 5 años (Menor)' : 'Passport 5 Years (Minor)',
    price: '$60.00',
    subContent: <div className="space-y-3 text-xs text-gray-600" data-id="element-414">
          <p className="font-bold text-gray-800 uppercase tracking-wide" data-id="element-415">
            {isEs ? 'Pasaporte para Menor de 21 Años' : 'Passport for a Minor Under 21'}
          </p>

          <div data-id="element-416">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-417">
              {isEs ? '📋 Confirmación de Cita' : '📋 Appointment Confirmation'}
            </p>
            <p className="pl-2 text-gray-500" data-id="element-418">
              {isEs ? 'La plataforma no está enviando confirmaciones de citas a las direcciones de correo electrónico. Se recomienda tomar una captura de pantalla en su teléfono del mensaje que aparece después de programar la cita.' : "The platform isn't sending appointment confirmations to email addresses. It's recommended that you take a screenshot on your phone of the message that appears after you schedule the appointment."}
            </p>
          </div>

          <div data-id="element-419">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-420">
              {isEs ? '📄 Acta de Nacimiento del Menor' : "📄 Minor's Birth Certificate"}
            </p>
            <p className="pl-2 text-gray-500" data-id="element-421">
              {isEs ? 'Original o copia' : 'Original or copy'}
            </p>
          </div>

          <div data-id="element-422">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-423">
              {'\uD83D\uDCB5 Money Order or Credit/Debit Card depending on consulate'}
            </p>
            <p className="pl-2 text-gray-500" data-id="element-424">
              $60 (5 {isEs ? 'años' : 'years'})
            </p>
          </div>

          <div data-id="element-425">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-426">
              {isEs ? '📜 Documento original de poder notarial con apostilla o sello consular' : '📜 Original power of attorney document with an apostille or consular seal'}
            </p>
          </div>

          <div data-id="element-427">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-428">
              {isEs ? '🧑‍⚖️ El tutor designado debe tener 21 años de edad o más' : '🧑‍⚖️ The appointed guardian must be 21 years of age or older'}
            </p>
          </div>

          <div data-id="element-429">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-430">
              {isEs ? '🪪 El tutor designado debe presentar el documento de identificación indicado en el poder notarial' : '🪪 The appointed guardian must present the identification document listed in the power of attorney document'}
            </p>
          </div>

          <div className="border-t border-gray-200 pt-2" data-id="element-431">
            <p className="font-bold text-gray-800 mb-2 uppercase tracking-wide text-xs" data-id="element-432">
              {isEs ? 'Requisitos Adicionales — Elija 1 Situación:' : 'Additional Requirements — Choose 1 Situation:'}
            </p>

            <div className="space-y-2" data-id="element-433">
              <div className="bg-blue-50 rounded-lg p-2" data-id="element-434">
                <p className="font-semibold text-haa-blue mb-1 text-xs" data-id="element-435">
                  {isEs ? 'Situación #1: Ambos padres se presentan en persona a la cita' : 'Situation #1: Both parents appear in person at the appointment'}
                </p>
                <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-436">
                  <li data-id="element-437">
                    {isEs ? 'Pasaportes o DNIs vigentes de ambos padres' : 'Valid passports or IDs (DNIs) for both parents'}
                  </li>
                </ul>
              </div>

              <div className="bg-blue-50 rounded-lg p-2" data-id="element-438">
                <p className="font-semibold text-haa-blue mb-1 text-xs" data-id="element-439">
                  {isEs ? 'Situación #2: Solo uno de los padres se presenta en persona' : 'Situation #2: Only one parent appears in person'}
                </p>
                <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-440">
                  <li data-id="element-441">
                    {isEs ? 'Pasaporte o DNI vigente del padre/madre presente' : 'Valid passport or ID (DNI) of the parent present'}
                  </li>
                  <li data-id="element-442">
                    {isEs ? 'Carta poder original autorizando la solicitud de pasaporte, emitida por el padre/madre ausente' : 'Original Power of Attorney letter authorizing the passport application, issued by the parent who is not present'}
                  </li>
                  <li data-id="element-443">
                    {isEs ? 'Copia del pasaportes o DNI del padre/madre ausente' : "Copy of the absent parent's passport or ID (DNI)"}
                  </li>
                </ul>
              </div>

              <div className="bg-blue-50 rounded-lg p-2" data-id="element-444">
                <p className="font-semibold text-haa-blue mb-1 text-xs" data-id="element-445">
                  {isEs ? 'Situación #3: Un tutor/representante se presenta en persona' : 'Situation #3: A guardian/representative appears in person'}
                </p>
                <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-446">
                  <li data-id="element-447">
                    {isEs ? 'Carta poder autorizando la solicitud de pasaporte, otorgando permiso al tutor/representante designado:' : 'Power of Attorney letter authorizing the passport application, granting permission to the designated guardian/representative:'}
                    <ul className="list-disc list-inside pl-3 mt-0.5 space-y-0.5" data-id="element-448">
                      <li data-id="element-449">
                        {isEs ? 'Hecha por ambos padres juntos, o' : 'Made by both parents together, or'}
                      </li>
                      <li data-id="element-450">
                        {isEs ? 'Hecha por cada padre individualmente si no están juntos' : 'Made by each parent individually if they are not together'}
                      </li>
                    </ul>
                  </li>
                  <li data-id="element-451">
                    {isEs ? 'Copia de los pasaportes o DNIs de ambos padres' : "Copy of both parents' passports or IDs (DNIs)"}
                  </li>
                  <li data-id="element-452">
                    {isEs ? 'Copia del pasaporte o DNI vigente de la persona designada como tutor/representante' : 'Copy of the valid passport or ID (DNI) of the person designated as guardian/representative'}
                  </li>
                </ul>
              </div>

              <div className="bg-blue-50 rounded-lg p-2" data-id="element-453">
                <p className="font-semibold text-haa-blue mb-1 text-xs" data-id="element-454">
                  {isEs ? 'Situación #4: Uno de los padres ha fallecido' : 'Situation #4: One parent is deceased'}
                </p>
                <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-455">
                  <li data-id="element-456">{'Original death certificate'}</li>
                  <li data-id="element-457">
                    {'The death certificate must be registered with the National Registry of Persons (RNP) in Honduras. If it has not been registered, it will not be considered valid for this process.'}
                  </li>
                  <li data-id="element-458">
                    {isEs ? 'Si la patria potestad es ejercida por alguien que no sea el padre o la madre, debe comprobarlo con documentación autenticada' : 'If parental authority is exercised by someone other than the mother or father, they must prove it with authenticated documentation'}
                  </li>
                </ul>
              </div>

              <div className="bg-blue-50 rounded-lg p-2" data-id="element-459">
                <p className="font-semibold text-haa-blue mb-1 text-xs" data-id="element-460">
                  {isEs ? 'Situación #5: Uno de los padres no puede ser localizado' : 'Situation #5: One of the parents cannot be located'}
                </p>
                <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-461">
                  <li data-id="element-462">
                    {isEs ? 'Los Juzgados de la Niñez (menores de 18 años) o los Juzgados de Familia (menores entre 18 y 21 años) pueden emitir una Orden de Tramitación de Pasaporte para el Instituto Nacional de Migración a favor de un menor' : 'The Juvenile Courts (minors under 18) or Family Courts (minors between 18 and 21) can issue a Passport Processing Order for the National Migration Institute in favor of a minor'}
                  </li>
                  <li data-id="element-463">
                    {isEs ? 'Comuníquese con la Cancillería para más información' : 'Contact the Ministry of Foreign Affairs for more information'}
                  </li>
                </ul>
              </div>
            </div>

            <div className="bg-red-50 rounded-lg p-2 border border-red-200 mt-3" data-id="element-464">
              <p className="font-semibold text-red-700 mb-1 text-xs" data-id="element-465">
                {isEs ? '🚫 Importante: Sin Excepciones para Menores de 21 Años' : '🚫 Important: No Exceptions for Minors Under 21'}
              </p>
              <p className="text-gray-600" data-id="element-466">
                {isEs ? 'Bajo ninguna circunstancia un consulado podrá emitir un pasaporte para una persona menor de 21 años sin cumplir con una de las situaciones descritas anteriormente. Toda la documentación aplicable debe presentarse al momento de la cita.' : 'Under no circumstances may a consulate issue a passport for an individual under the age of 21 without meeting one of the situations described above. All applicable documentation must be presented at the time of the appointment.'}
              </p>
            </div>

            <div className="bg-amber-50 rounded-lg p-2 border border-amber-200 mt-2" data-id="element-467">
              <p className="font-semibold text-amber-700 mb-1 text-xs" data-id="element-468">
                {isEs ? '⚖️ Importante: Órdenes de Custodia de EE.UU. y la Ley Hondureña' : '⚖️ Important: U.S. Custody Orders & Honduran Law'}
              </p>
              <p className="text-gray-600" data-id="element-469">
                {'Please be aware that custody orders issued by U.S. courts are not recognized under Honduran law. For passport purposes, any custody or parental authority determination must be validated through the Honduran legal system, including the appropriate homologation process before the Supreme Court of Honduras. We recommend consulting a qualified attorney in Honduras to understand the legal requirements and procedures.'}
              </p>
            </div>

            <div className="bg-purple-50 rounded-lg p-2 border border-purple-200 mt-2" data-id="element-470">
              <p className="font-semibold text-purple-700 mb-1 text-xs" data-id="element-471">
                {isEs ? '🛡️ Importante: Menores Bajo Servicios de Protección Infantil (CPS)' : '🛡️ Important: Children Under Child Protective Services (CPS)'}
              </p>
              <p className="text-gray-600" data-id="element-472">
                {'If a child is under the custody of Child Protective Services (CPS), the assigned social worker must contact the consulate directly before a passport application can be processed. The consulate, together with CPS and the Migrant Protection Officer, will review the case and determine the appropriate next steps and required documentation.'}
              </p>
            </div>
          </div>
        </div>
  }, {
    service: isEs ? 'Pasaporte 5 o 10 años (Adulto)' : 'Passport 5 or 10 Years (Adult)',
    price: '$75.00',
    subContent: <div className="space-y-4 text-xs text-gray-600" data-id="element-473">
          <div data-id="element-474">
            <p className="font-bold text-gray-800 uppercase tracking-wide mb-2" data-id="element-475">
              {isEs ? 'Primera Vez / Renovación' : 'First Time Applying / Renewal'}
            </p>
            <div className="space-y-2" data-id="element-476">
              <div data-id="element-477">
                <p className="font-semibold text-gray-700 mb-0.5" data-id="element-478">
                  {isEs ? '📋 Confirmación de Cita' : '📋 Appointment Confirmation'}
                </p>
                <p className="pl-2 text-gray-500" data-id="element-479">
                  {isEs ? 'La plataforma no está enviando confirmaciones de citas a las direcciones de correo electrónico. Se recomienda tomar una captura de pantalla en su teléfono del mensaje que aparece después de programar la cita.' : "The platform isn't sending appointment confirmations to email addresses. It's recommended that you take a screenshot on your phone of the message that appears after you schedule the appointment."}
                </p>
              </div>
              <div data-id="element-480">
                <p className="font-semibold text-gray-700 mb-0.5" data-id="element-481">
                  {isEs ? '🪪 DNI emitido en 2020 o posterior' : '🪪 DNI (National ID) issued in 2020 or later'}
                </p>
                <div className="pl-2 bg-amber-50 rounded-lg p-2 mt-1" data-id="element-482">
                  <p className="font-semibold text-amber-700 mb-0.5" data-id="element-483">
                    {isEs ? '¿No tiene DNI?' : "Don't have a DNI?"}
                  </p>
                  <ul className="list-disc list-inside space-y-0.5 text-gray-600" data-id="element-484">
                    <li data-id="element-485">
                      {'You can apply for it the same day at the consulate.'}
                    </li>
                    <li data-id="element-486">{'The process is free the first time.'}</li>
                    <li data-id="element-487">
                      {isEs ? 'Informe al agente consular que no tiene DNI, ya que debe procesarse antes de iniciar el trámite de pasaporte' : 'Please let the consular agent know you do not have a DNI, since it must be processed before starting the passport process'}
                    </li>
                  </ul>
                </div>
              </div>
              <div data-id="element-488">
                <p className="font-semibold text-gray-700 mb-0.5" data-id="element-489">
                  {'\uD83D\uDCB5 Money Order or Credit/Debit Card depending on the Consulate'}
                </p>
                <ul className="list-disc list-inside pl-2 space-y-0.5 text-gray-500" data-id="element-490">
                  <li data-id="element-491">
                    {isEs ? '$60 (5 años) — opción para menores y adultos' : '$60 (5 years) — option for minors and adults'}
                  </li>
                  <li data-id="element-492">
                    {isEs ? '$75 (10 años) — opción solo para adultos de 21+' : '$75 (10 years) — option only for adults 21+'}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="border-t-2 border-gray-300 pt-5 mt-4" data-id="element-493">
            <p className="font-bold text-gray-800 uppercase tracking-wide mb-2" data-id="element-494">
              {isEs ? 'Reposición de Pasaporte Vigente (Perdido o Robado)' : 'Replacement of a Valid Passport (Lost or Stolen)'}
            </p>
            <div className="space-y-2" data-id="element-495">
              <div data-id="element-496">
                <p className="font-semibold text-gray-700 mb-0.5" data-id="element-497">
                  {isEs ? '📋 Confirmación de Cita' : '📋 Appointment Confirmation'}
                </p>
                <p className="pl-2 text-gray-500" data-id="element-498">
                  {isEs ? 'Impresa o en su teléfono' : 'Printed or on your phone'}
                </p>
              </div>
              <div data-id="element-499">
                <p className="font-semibold text-gray-700 mb-0.5" data-id="element-500">
                  {isEs ? '🪪 DNI emitido en 2020 o posterior' : '🪪 DNI (National ID) issued in 2020 or later'}
                </p>
                <div className="pl-2 bg-amber-50 rounded-lg p-2 mt-1" data-id="element-501">
                  <p className="font-semibold text-amber-700 mb-0.5" data-id="element-502">
                    {isEs ? '¿No tiene DNI?' : "Don't have a DNI?"}
                  </p>
                  <ul className="list-disc list-inside space-y-0.5 text-gray-600" data-id="element-503">
                    <li data-id="element-504">
                      {isEs ? 'Puede solicitarlo el mismo día en el consulado' : 'You can apply for it the same day at the consulate'}
                    </li>
                    <li data-id="element-505">
                      {isEs ? 'Informe al agente consular que no tiene DNI, ya que debe procesarse antes de iniciar el trámite de pasaporte' : 'Please let the consular agent know you do not have a DNI, since it must be processed before starting the passport process'}
                    </li>
                  </ul>
                </div>
              </div>
              <div data-id="element-506">
                <p className="font-semibold text-gray-700 mb-0.5" data-id="element-507">
                  {'\uD83D\uDCB5 Money Order or Credit/Debit Card depending on the Consulate (passport fee)'}
                </p>
                <ul className="list-disc list-inside pl-2 space-y-0.5 text-gray-500" data-id="element-508">
                  <li data-id="element-509">
                    {isEs ? '$60 (5 años) — opción para menores y adultos' : '$60 (5 years) — option for minors and adults'}
                  </li>
                  <li data-id="element-510">
                    {isEs ? '$75 (10 años) — opción solo para adultos de 21+' : '$75 (10 years) — option only for adults 21+'}
                  </li>
                </ul>
              </div>
              <div data-id="element-511">
                <p className="font-semibold text-gray-700 mb-0.5" data-id="element-512">
                  {isEs ? '📝 Declaración Jurada de Extravío' : '📝 Sworn Statement of Loss'}
                </p>
                <ul className="list-disc list-inside pl-2 space-y-0.5 text-gray-500" data-id="element-513">
                  <li data-id="element-514">
                    {isEs ? 'Formulario de declaración jurada (se completa en el consulado)' : 'Sworn statement form (you will complete it at the consulate)'}
                  </li>
                  <li data-id="element-515">
                    {'Additional Money Order or Credit/Debit card payment depending on Consulate: $50'}
                  </li>
                </ul>
              </div>
              <div className="bg-blue-50 rounded-lg p-2" data-id="element-516">
                <p className="font-semibold text-haa-blue mb-1" data-id="element-517">
                  {'\u26A0\uFE0F Reminder: You will need 2 money orders or 2 Credit/Debit card payments depending on the Consulate'}
                </p>
                <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-518">
                  <li data-id="element-519">
                    {isEs ? 'Uno para el pasaporte' : 'One for the passport'}
                  </li>
                  <li data-id="element-520">
                    {isEs ? 'Uno para el reporte de extravío' : 'One for the loss report'}
                  </li>
                </ul>
              </div>
              <div className="bg-amber-50 rounded-lg p-2 border border-amber-200" data-id="element-521">
                <p className="font-semibold text-amber-700 mb-1" data-id="element-522">
                  {isEs ? '📋 Importante: Apellido de Casada en Pasaportes' : '📋 Important: Married Last Name on Passports'}
                </p>
                <p className="text-gray-600" data-id="element-523">
                  {isEs ? 'Aunque anteriormente se permitía, las nuevas regulaciones ya no permiten que el apellido de casada de una mujer aparezca en el pasaporte a menos que el matrimonio haya sido certificado y registrado en Honduras. Si su matrimonio se realizó fuera de Honduras, primero debe registrarlo en el registro civil hondureño antes de que su apellido de casada pueda incluirse en su pasaporte, y debe traer el acta de matrimonio original emitida por el RNP.' : "Although this was previously allowed, new regulations no longer permit a woman's married last name to appear on the passport unless the marriage has been certified and registered in Honduras. If your marriage was performed outside of Honduras, you must first register it with the Honduran civil registry before your married name can be included on your passport, and you must bring the original marriage certificate issued by the RNP."}
                </p>
              </div>
            </div>
          </div>
        </div>
  }, {
    service: isEs ? 'Matrícula Consular' : 'Consular ID Card (Matrícula Consular)',
    price: '$25.00',
    subContent: <div className="space-y-3 text-xs text-gray-600" data-id="element-524">
          <div className="space-y-2" data-id="element-525">
            <div data-id="element-526">
              <p className="font-semibold text-gray-700 mb-0.5" data-id="element-527">
                {isEs ? '📋 Confirmación de Cita' : '📋 Appointment Confirmation'}
              </p>
              <p className="pl-2 text-gray-500" data-id="element-528">
                {isEs ? 'La plataforma no está enviando confirmaciones de citas a las direcciones de correo electrónico. Se recomienda tomar una captura de pantalla en su teléfono del mensaje que aparece después de programar la cita.' : "The platform isn't sending appointment confirmations to email addresses. It's recommended that you take a screenshot on your phone of the message that appears after you schedule the appointment."}
              </p>
            </div>
            <div data-id="element-529">
              <p className="font-semibold text-gray-700 mb-0.5" data-id="element-530">
                {isEs ? '🪪 DNI (Documento Nacional de Identidad)' : '🪪 DNI (National Identification Card)'}
              </p>
            </div>
            <div data-id="element-531">
              <p className="font-semibold text-gray-700 mb-0.5" data-id="element-532">
                {isEs ? '🏠 Comprobante de Domicilio' : '🏠 Proof of Residence'}
              </p>
              <p className="pl-2 text-gray-500" data-id="element-533">
                {isEs ? 'Factura de servicio público original que muestre el nombre y la dirección del solicitante.' : "Original utility bill showing the applicant's name and address."}
              </p>
              <div className="pl-2 bg-amber-50 rounded-lg p-2 mt-1" data-id="element-534">
                <p className="font-semibold text-amber-700 mb-0.5" data-id="element-535">
                  {isEs ? '*Si la factura no está a nombre del solicitante:' : "*If the bill is not under the applicant's name:"}
                </p>
                <p className="text-gray-600" data-id="element-536">
                  {isEs ? 'Se deben presentar dos facturas de servicios públicos originales bajo el mismo nombre y dirección.' : 'Two original utility bills under the same name and address must be presented.'}
                </p>
              </div>
            </div>
            <div data-id="element-537">
              <p className="font-semibold text-gray-700 mb-0.5" data-id="element-538">
                {isEs ? '📍 Dirección' : '📍 Address'}
              </p>
              <p className="pl-2 text-gray-500" data-id="element-539">
                {isEs ? 'La matrícula consular reflejará la dirección residencial del solicitante.' : "The consular ID card will reflect the applicant's residential address."}
              </p>
            </div>
            <div data-id="element-540">
              <p className="font-semibold text-gray-700 mb-0.5" data-id="element-541">
                {isEs ? '✅ Emisión' : '✅ Issuance'}
              </p>
              <p className="pl-2 text-gray-500" data-id="element-542">
                {isEs ? 'La matrícula consular se emite el mismo día.' : 'The consular ID card is issued the same day.'}
              </p>
            </div>
          </div>
        </div>
  }, {
    service: isEs ? 'Salvoconducto con fotografía' : 'Travel Document with Photo (Salvoconducto)',
    price: '$10.00',
    subContent: <div className="space-y-3 text-xs text-gray-600" data-id="element-543">
          <div className="space-y-2" data-id="element-544">
            <div data-id="element-545">
              <p className="font-semibold text-gray-700 mb-0.5" data-id="element-546">
                {isEs ? '📋 Confirmación de Cita' : '📋 Appointment Confirmation'}
              </p>
              <p className="pl-2 text-gray-500" data-id="element-547">
                {isEs ? 'La plataforma no está enviando confirmaciones de citas a las direcciones de correo electrónico. Se recomienda tomar una captura de pantalla en su teléfono del mensaje que aparece después de programar la cita.' : "The platform isn't sending appointment confirmations to email addresses. It's recommended that you take a screenshot on your phone of the message that appears after you schedule the appointment."}
              </p>
            </div>
            <div data-id="element-548">
              <p className="font-semibold text-gray-700 mb-0.5" data-id="element-549">
                {isEs ? '🪪 DNI (Documento Nacional de Identidad)' : '🪪 DNI (National Identification Card)'}
              </p>
            </div>
            <div data-id="element-550">
              <p className="font-semibold text-gray-700 mb-0.5" data-id="element-551">
                {isEs ? '📸 Dos fotos tamaño pasaporte' : '📸 Two passport-size photos'}
              </p>
            </div>
            <div data-id="element-552">
              <p className="font-semibold text-gray-700 mb-0.5" data-id="element-553">
                {'\uD83D\uDCB5 Money Order or Credit/Debit Card depending on the Consulate'}
              </p>
            </div>
          </div>
          <div className="bg-amber-50 rounded-lg p-2 border border-amber-200" data-id="element-554">
            <p className="font-semibold text-amber-700 mb-1" data-id="element-555">
              {isEs ? '👶 Para Menores' : '👶 For Minors'}
            </p>
            <p className="text-gray-600" data-id="element-556">
              {isEs ? 'Para menores, aplican los mismos requisitos que para una solicitud de pasaporte de menor.' : 'For minors, the same requirements applicable to a minor passport application will apply.'}
            </p>
          </div>
          <div className="bg-blue-50 rounded-lg p-2 border border-blue-200 mt-2" data-id="element-557">
            <p className="font-semibold text-haa-blue mb-1" data-id="element-558">
              {isEs ? 'ℹ️ ¿Qué es un Salvoconducto?' : 'ℹ️ What is a Salvoconducto?'}
            </p>
            <p className="text-gray-600" data-id="element-559">
              {isEs ? 'Este es un documento de viaje de ida utilizado para regresar a su país de origen. Puede ser emitido a personas que no tienen pasaporte o que no pueden acudir al consulado, como alguien hospitalizado. Cuando sea necesario por razones médicas, el personal consular puede visitar a la persona para tomar sus huellas dactilares.' : 'This is a one-way travel document used to return to your home country. It may be issued to people who do not have a passport or cannot come to the consulate, such as someone hospitalized. When necessary for medical reasons, consulate staff can visit the person to take fingerprints.'}
            </p>
          </div>
        </div>
  }, {
    service: isEs ? 'Visa múltiple (VUCA)' : 'Multiple Visa (VUCA)',
    price: '$60.00'
  }, {
    service: isEs ? 'Visa simple (VUCA)' : 'Single Visa (VUCA)',
    price: '$30.00'
  }, {
    service: isEs ? 'Traducción de documentos' : 'Document Translation',
    price: '$30.00'
  }, {
    service: isEs ? 'Inscripción de nacimientos' : 'Birth Registration',
    price: isEs ? 'Gratis' : 'Free',
    subContent: <div className="space-y-3 text-xs text-gray-600" data-id="element-560">
          <div data-id="element-561">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-562">
              {isEs ? '📋 Confirmación de Cita' : '📋 Appointment Confirmation'}
            </p>
            <p className="pl-2 text-gray-500" data-id="element-563">
              {isEs ? 'La plataforma no está enviando confirmaciones de citas a las direcciones de correo electrónico. Se recomienda tomar una captura de pantalla en su teléfono del mensaje que aparece después de programar la cita.' : "The platform isn't sending appointment confirmations to email addresses. It's recommended that you take a screenshot on your phone of the message that appears after you schedule the appointment."}
            </p>
          </div>
          <p className="font-bold text-gray-800 uppercase tracking-wide" data-id="element-564">
            {isEs ? 'Inscripción de Nacimientos' : 'Birth Registration'}
          </p>
          <div data-id="element-565">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-566">
              {isEs ? '👶 Elegibilidad' : '👶 Eligibility'}
            </p>
            <p className="pl-2 text-gray-500" data-id="element-567">
              {isEs ? 'Para menores de 0–20 años' : 'For minors ages 0–20'}
            </p>
          </div>
          <div className="border-t border-gray-200 pt-2" data-id="element-568">
            <p className="font-bold text-gray-800 mb-2 uppercase tracking-wide text-xs" data-id="element-569">
              {isEs ? 'Requisitos' : 'Requirements'}
            </p>
            <div className="space-y-2" data-id="element-570">
              <div data-id="element-571">
                <p className="font-semibold text-gray-700 mb-0.5" data-id="element-572">
                  {isEs ? '📄 Acta de Nacimiento' : '📄 Birth Certificate'}
                </p>
                <p className="pl-2 text-gray-500" data-id="element-573">
                  {isEs ? 'Apostillada en la Secretaría de Estado' : 'Apostilled by the Secretary of State'}
                </p>
              </div>
              <div data-id="element-574">
                <p className="font-semibold text-gray-700 mb-0.5" data-id="element-575">
                  {isEs ? '🪪 Identificación de los Padres' : '🪪 Parent Identification'}
                </p>
                <p className="pl-2 text-gray-500" data-id="element-576">
                  {isEs ? 'Pasaporte vigente de los dos padres o DNI' : 'Valid passport or DNI of both parents'}
                </p>
              </div>
              <div className="bg-blue-50 rounded-lg p-2" data-id="element-577">
                <p className="font-semibold text-haa-blue mb-1 text-xs" data-id="element-578">
                  {isEs ? 'ℹ️ Asistencia' : 'ℹ️ Attendance'}
                </p>
                <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-579">
                  <li data-id="element-580">
                    {isEs ? 'Solo tiene que ir uno si no pueden ir los dos' : 'Only one parent needs to attend if both cannot go'}
                  </li>
                  <li data-id="element-581">
                    {isEs ? 'No necesita ir el menor' : 'The minor does not need to be present'}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="bg-emerald-50 rounded-lg p-2 border border-emerald-200 mt-1" data-id="element-582">
            <p className="font-semibold text-emerald-700 mb-1 text-xs" data-id="element-583">
              {isEs ? '🛂 Pasaporte el Mismo Día' : '🛂 Same-Day Passport'}
            </p>
            <p className="text-gray-600" data-id="element-584">
              {isEs ? 'Pueden sacar pasaporte el mismo día si está presente el menor y los dos padres, o con los documentos de soporte indicados en la sección de pasaporte de menor. Pueden hacer el pasaporte el mismo día en el consulado.' : 'You can get a passport the same day if the minor and both parents are present, or with the supporting documents listed in the minor passport section. The passport can be processed the same day at the consulate.'}
            </p>
          </div>
        </div>
  }, {
    service: isEs ? 'Inscripción de defunciones' : 'Death Registration',
    price: '$25.00',
    subContent: <div className="space-y-3 text-xs text-gray-600" data-id="element-585">
          <div data-id="element-586">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-587">
              {isEs ? '📋 Confirmación de Cita' : '📋 Appointment Confirmation'}
            </p>
            <p className="pl-2 text-gray-500" data-id="element-588">
              {isEs ? 'La plataforma no está enviando confirmaciones de citas a las direcciones de correo electrónico. Se recomienda tomar una captura de pantalla en su teléfono del mensaje que aparece después de programar la cita.' : "The platform isn't sending appointment confirmations to email addresses. It's recommended that you take a screenshot on your phone of the message that appears after you schedule the appointment."}
            </p>
          </div>
          <div className="border-t border-gray-200 pt-2" data-id="element-589">
            <p className="font-bold text-gray-800 mb-2 uppercase tracking-wide text-xs" data-id="element-590">
              {isEs ? 'Paso 1: En el Consulado' : 'Step 1: At the Consulate'}
            </p>
            <div className="space-y-2" data-id="element-591">
              <div data-id="element-592">
                <p className="font-semibold text-gray-700 mb-0.5" data-id="element-593">
                  {isEs ? '📄 Acta de Defunción' : '📄 Death Certificate'}
                </p>
                <p className="pl-2 text-gray-500" data-id="element-594">
                  {isEs ? 'Se requiere el acta de defunción original' : 'Original death certificate is required'}
                </p>
              </div>
              <div data-id="element-595">
                <p className="font-semibold text-gray-700 mb-0.5" data-id="element-596">
                  {isEs ? '📜 Apostilla' : '📜 Apostille'}
                </p>
                <p className="pl-2 text-gray-500" data-id="element-597">
                  {isEs ? 'La apostilla es opcional, pero recomendada' : 'An apostille is optional, but recommended'}
                </p>
              </div>
              <div className="bg-blue-50 rounded-lg p-2" data-id="element-598">
                <p className="font-semibold text-haa-blue mb-1 text-xs" data-id="element-599">
                  {isEs ? 'ℹ️ ¿Quién Puede Presentar?' : 'ℹ️ Who Can Submit?'}
                </p>
                <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-600">
                  <li data-id="element-601">
                    {isEs ? 'El documento puede ser presentado por cualquier persona; no tiene que ser un familiar' : 'The document may be presented by any person; it does not have to be a family member'}
                  </li>
                  <li data-id="element-602">
                    {isEs ? 'La persona que presenta el documento preferiblemente debe ser hondureña' : 'The person presenting the document should preferably be Honduran'}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-200 pt-2" data-id="element-603">
            <p className="font-bold text-gray-800 mb-2 uppercase tracking-wide text-xs" data-id="element-604">
              {isEs ? 'Paso 2: En Honduras' : 'Step 2: In Honduras'}
            </p>
            <div className="space-y-2" data-id="element-605">
              <div data-id="element-606">
                <p className="font-semibold text-gray-700 mb-0.5" data-id="element-607">
                  {isEs ? '📬 Envío de Documentos' : '📬 Document Submission'}
                </p>
                <p className="pl-2 text-gray-500" data-id="element-608">
                  {isEs ? 'Envíe los documentos a un familiar en Honduras dentro del tercer grado de parentesco para que los presente ante el RNP para su certificación' : 'Send the documents to a relative in Honduras within the third degree of kinship so they can submit them to the RNP for certification'}
                </p>
              </div>
              <div className="bg-amber-50 rounded-lg p-2 border border-amber-200" data-id="element-609">
                <p className="font-semibold text-amber-700 mb-1 text-xs" data-id="element-610">
                  {isEs ? '📝 Recomendación' : '📝 Recommendation'}
                </p>
                <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-611">
                  <li data-id="element-612">
                    {isEs ? 'Si es posible, se recomienda también enviar un poder notarial que autorice a la persona en Honduras a completar el proceso' : 'If possible, it is recommended to also send a power of attorney authorizing the person in Honduras to complete the process'}
                  </li>
                  <li data-id="element-613">
                    {isEs ? 'El poder notarial puede ser preparado en el consulado' : 'The power of attorney can be prepared at the consulate'}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
  }, {
    service: isEs ? 'Inscripción de matrimonios' : 'Marriage Registration',
    price: '$25.00',
    subContent: <div className="space-y-3 text-xs text-gray-600" data-id="element-614">
          <div data-id="element-615">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-616">
              {isEs ? '📋 Confirmación de Cita' : '📋 Appointment Confirmation'}
            </p>
            <p className="pl-2 text-gray-500" data-id="element-617">
              {isEs ? 'La plataforma no está enviando confirmaciones de citas a las direcciones de correo electrónico. Se recomienda tomar una captura de pantalla en su teléfono del mensaje que aparece después de programar la cita.' : "The platform isn't sending appointment confirmations to email addresses. It's recommended that you take a screenshot on your phone of the message that appears after you schedule the appointment."}
            </p>
          </div>
          <div className="border-t border-gray-200 pt-2" data-id="element-618">
            <p className="font-bold text-gray-800 mb-2 uppercase tracking-wide text-xs" data-id="element-619">
              {isEs ? 'Paso 1: En el Consulado' : 'Step 1: At the Consulate'}
            </p>
            <div className="space-y-2" data-id="element-620">
              <div data-id="element-621">
                <p className="font-semibold text-gray-700 mb-0.5" data-id="element-622">
                  {isEs ? '📄 Acta de Matrimonio' : '📄 Marriage Certificate'}
                </p>
                <p className="pl-2 text-gray-500" data-id="element-623">
                  {isEs ? 'Se requiere el acta de matrimonio original' : 'Original marriage certificate is required'}
                </p>
              </div>
              <div data-id="element-624">
                <p className="font-semibold text-gray-700 mb-0.5" data-id="element-625">
                  {isEs ? '📜 Apostilla' : '📜 Apostille'}
                </p>
                <p className="pl-2 text-gray-500" data-id="element-626">
                  {isEs ? 'La apostilla es opcional, pero recomendada' : 'An apostille is optional, but recommended'}
                </p>
              </div>
              <div className="bg-blue-50 rounded-lg p-2" data-id="element-627">
                <p className="font-semibold text-haa-blue mb-1 text-xs" data-id="element-628">
                  {isEs ? 'ℹ️ ¿Quién Puede Presentar?' : 'ℹ️ Who Can Submit?'}
                </p>
                <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-629">
                  <li data-id="element-630">
                    {isEs ? 'El documento puede ser presentado por cualquier persona; no tiene que ser un familiar' : 'The document may be presented by any person; it does not have to be a family member'}
                  </li>
                  <li data-id="element-631">
                    {isEs ? 'La persona que presenta el documento preferiblemente debe ser hondureña' : 'The person presenting the document should preferably be Honduran'}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-200 pt-2" data-id="element-632">
            <p className="font-bold text-gray-800 mb-2 uppercase tracking-wide text-xs" data-id="element-633">
              {isEs ? 'Paso 2: En Honduras' : 'Step 2: In Honduras'}
            </p>
            <div className="space-y-2" data-id="element-634">
              <div data-id="element-635">
                <p className="font-semibold text-gray-700 mb-0.5" data-id="element-636">
                  {isEs ? '📬 Envío de Documentos' : '📬 Document Submission'}
                </p>
                <p className="pl-2 text-gray-500" data-id="element-637">
                  {isEs ? 'Envíe los documentos a un familiar en Honduras dentro del tercer grado de parentesco para que los presente ante el RNP para su certificación' : 'Send the documents to a relative in Honduras within the third degree of kinship so they can submit them to the RNP for certification'}
                </p>
              </div>
              <div className="bg-amber-50 rounded-lg p-2 border border-amber-200" data-id="element-638">
                <p className="font-semibold text-amber-700 mb-1 text-xs" data-id="element-639">
                  {isEs ? '📝 Recomendación' : '📝 Recommendation'}
                </p>
                <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-640">
                  <li data-id="element-641">
                    {isEs ? 'Si es posible, se recomienda también enviar un poder notarial que autorice a la persona en Honduras a completar el proceso' : 'If possible, it is recommended to also send a power of attorney authorizing the person in Honduras to complete the process'}
                  </li>
                  <li data-id="element-642">
                    {isEs ? 'El poder notarial puede ser preparado en el consulado' : 'The power of attorney can be prepared at the consulate'}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
  }, {
    service: isEs ? 'Inscripciones de divorcios' : 'Divorce Registration',
    price: '$25.00',
    subContent: <div className="space-y-3 text-xs text-gray-600" data-id="element-643">
          <div data-id="element-644">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-645">
              {isEs ? '📋 Confirmación de Cita' : '📋 Appointment Confirmation'}
            </p>
            <p className="pl-2 text-gray-500" data-id="element-646">
              {isEs ? 'La plataforma no está enviando confirmaciones de citas a las direcciones de correo electrónico. Se recomienda tomar una captura de pantalla en su teléfono del mensaje que aparece después de programar la cita.' : "The platform isn't sending appointment confirmations to email addresses. It's recommended that you take a screenshot on your phone of the message that appears after you schedule the appointment."}
            </p>
          </div>
          <div className="border-t border-gray-200 pt-2" data-id="element-647">
            <p className="font-bold text-gray-800 mb-2 uppercase tracking-wide text-xs" data-id="element-648">
              {isEs ? 'Paso 1: En el Consulado' : 'Step 1: At the Consulate'}
            </p>
            <div className="space-y-2" data-id="element-649">
              <div data-id="element-650">
                <p className="font-semibold text-gray-700 mb-0.5" data-id="element-651">
                  {isEs ? '📄 Decreto de Divorcio' : '📄 Divorce Decree'}
                </p>
                <p className="pl-2 text-gray-500" data-id="element-652">
                  {isEs ? 'Se requiere el decreto de divorcio original' : 'Original divorce decree is required'}
                </p>
              </div>
              <div data-id="element-653">
                <p className="font-semibold text-gray-700 mb-0.5" data-id="element-654">
                  {isEs ? '📜 Apostilla' : '📜 Apostille'}
                </p>
                <p className="pl-2 text-gray-500" data-id="element-655">
                  {isEs ? 'La apostilla es opcional, pero recomendada' : 'An apostille is optional, but recommended'}
                </p>
              </div>
              <div className="bg-blue-50 rounded-lg p-2" data-id="element-656">
                <p className="font-semibold text-haa-blue mb-1 text-xs" data-id="element-657">
                  {isEs ? 'ℹ️ ¿Quién Puede Presentar?' : 'ℹ️ Who Can Submit?'}
                </p>
                <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-658">
                  <li data-id="element-659">
                    {isEs ? 'El documento puede ser presentado por cualquier persona; no tiene que ser un familiar' : 'The document may be presented by any person; it does not have to be a family member'}
                  </li>
                  <li data-id="element-660">
                    {isEs ? 'La persona que presenta el documento preferiblemente debe ser hondureña' : 'The person presenting the document should preferably be Honduran'}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-200 pt-2" data-id="element-661">
            <p className="font-bold text-gray-800 mb-2 uppercase tracking-wide text-xs" data-id="element-662">
              {isEs ? 'Paso 2: En Honduras' : 'Step 2: In Honduras'}
            </p>
            <div className="space-y-2" data-id="element-663">
              <div data-id="element-664">
                <p className="font-semibold text-gray-700 mb-0.5" data-id="element-665">
                  {isEs ? '📬 Envío de Documentos' : '📬 Document Submission'}
                </p>
                <p className="pl-2 text-gray-500" data-id="element-666">
                  {isEs ? 'Envíe los documentos a un familiar en Honduras dentro del tercer grado de parentesco para que los presente ante el RNP para su certificación' : 'Send the documents to a relative in Honduras within the third degree of kinship so they can submit them to the RNP for certification'}
                </p>
              </div>
              <div className="bg-amber-50 rounded-lg p-2 border border-amber-200" data-id="element-667">
                <p className="font-semibold text-amber-700 mb-1 text-xs" data-id="element-668">
                  {isEs ? '📝 Recomendación' : '📝 Recommendation'}
                </p>
                <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-669">
                  <li data-id="element-670">
                    {isEs ? 'Si es posible, se recomienda también enviar un poder notarial que autorice a la persona en Honduras a completar el proceso' : 'If possible, it is recommended to also send a power of attorney authorizing the person in Honduras to complete the process'}
                  </li>
                  <li data-id="element-671">
                    {isEs ? 'El poder notarial puede ser preparado en el consulado' : 'The power of attorney can be prepared at the consulate'}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
  }, {
    service: isEs ? 'Fe de vida' : 'Proof of Life (Fe de Vida)',
    price: '$25.00',
    subContent: <div className="space-y-3 text-xs text-gray-600" data-id="element-672">
          <div data-id="element-673">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-674">
              {isEs ? '📋 Confirmación de Cita' : '📋 Appointment Confirmation'}
            </p>
            <p className="pl-2 text-gray-500" data-id="element-675">
              {isEs ? 'La plataforma no está enviando confirmaciones de citas a las direcciones de correo electrónico. Se recomienda tomar una captura de pantalla en su teléfono del mensaje que aparece después de programar la cita.' : "The platform isn't sending appointment confirmations to email addresses. It's recommended that you take a screenshot on your phone of the message that appears after you schedule the appointment."}
            </p>
          </div>
          <div data-id="element-676">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-677">
              {isEs ? '📋 Descripción' : '📋 Description'}
            </p>
            <p className="pl-2 text-gray-500" data-id="element-678">
              {isEs ? 'Esta es una certificación que confirma que la persona está viva.' : 'This is a certification confirming that the person is alive.'}
            </p>
          </div>
          <div data-id="element-679">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-680">
              {isEs ? '🏛️ Uso Común' : '🏛️ Common Use'}
            </p>
            <p className="pl-2 text-gray-500" data-id="element-681">
              {isEs ? 'Puede ser utilizada para asuntos relacionados con pensiones, incluyendo en instituciones como INJUPEMP.' : 'It may be used for pension-related matters, including at institutions such as INJUPEMP.'}
            </p>
          </div>
          <div className="border-t border-gray-200 pt-2" data-id="element-682">
            <p className="font-bold text-gray-800 mb-2 uppercase tracking-wide text-xs" data-id="element-683">
              {isEs ? 'Requisitos' : 'Requirements'}
            </p>
            <div className="bg-blue-50 rounded-lg p-2" data-id="element-684">
              <p className="font-semibold text-haa-blue mb-1 text-xs" data-id="element-685">
                {isEs ? 'Identificación' : 'Identification'}
              </p>
              <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-686">
                <li data-id="element-687">
                  {isEs ? 'DNI o Pasaporte vigente' : 'Valid DNI or Passport'}
                </li>
                <li data-id="element-688">
                  {isEs ? 'La persona debe presentarse en persona' : 'The person must appear in person'}
                </li>
              </ul>
            </div>
          </div>
        </div>
  }, {
    service: isEs ? 'Poder General' : 'General Power of Attorney (Poder General)',
    price: '$150.00',
    subContent: <div className="space-y-3 text-xs text-gray-600" data-id="element-689">
          <div data-id="element-690">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-691">
              {isEs ? '📋 Confirmación de Cita' : '📋 Appointment Confirmation'}
            </p>
            <p className="pl-2 text-gray-500" data-id="element-692">
              {isEs ? 'La plataforma no está enviando confirmaciones de citas a las direcciones de correo electrónico. Se recomienda tomar una captura de pantalla en su teléfono del mensaje que aparece después de programar la cita.' : "The platform isn't sending appointment confirmations to email addresses. It's recommended that you take a screenshot on your phone of the message that appears after you schedule the appointment."}
            </p>
          </div>
          <div data-id="element-693">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-694">
              {isEs ? '📋 Descripción' : '📋 Description'}
            </p>
            <p className="pl-2 text-gray-500" data-id="element-695">
              {isEs ? 'Un Poder General se utiliza para autorizar a alguien a representarlo en un asunto específico hasta su conclusión. Por ejemplo: un poder para divorcio, matrimonio, disputas legales, representación y procedimientos similares.' : 'A Poder General is used to authorize someone to represent you in a specific matter through to its completion. For example: a power of attorney for divorce, marriage, legal disputes, representation, and similar proceedings.'}
            </p>
          </div>
          <div className="bg-red-50 rounded-lg p-2 border border-red-200" data-id="element-696">
            <p className="font-semibold text-red-700 mb-1 text-xs" data-id="element-697">
              {isEs ? '⚠️ Recordatorio Especial' : '⚠️ Special Reminder'}
            </p>
            <p className="text-gray-600" data-id="element-698">
              {isEs ? 'Este tipo de Poder es abierto y no tiene fecha de vencimiento.' : 'This type of Poder is open-ended and does not have an end date.'}
            </p>
          </div>
          <div className="border-t border-gray-200 pt-2 mt-2" data-id="element-699">
            <p className="font-bold text-gray-800 uppercase tracking-wide mb-2" data-id="element-700">
              {isEs ? 'Requisitos' : 'Requirements'}
            </p>
            <div className="space-y-2" data-id="element-701">
              <div className="bg-blue-50 rounded-lg p-2" data-id="element-702">
                <p className="font-semibold text-haa-blue mb-1 text-xs" data-id="element-703">
                  {isEs ? '1. Identificación del Solicitante' : "1. Applicant's Identification"}
                </p>
                <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-704">
                  <li data-id="element-705">
                    {isEs ? 'DNI o Pasaporte vigente' : 'Valid DNI (National Identification Card) or Passport'}
                  </li>
                  <li data-id="element-706">
                    {isEs ? 'Se le pedirán sus datos personales: estado civil, profesión y dirección' : 'You will be asked for your personal details: marital status, profession, and address'}
                  </li>
                </ul>
              </div>
              <div className="bg-blue-50 rounded-lg p-2" data-id="element-707">
                <p className="font-semibold text-haa-blue mb-1 text-xs" data-id="element-708">
                  {isEs ? '2. Información de la Persona que Recibe el Poder' : '2. Information of the Person Receiving the Power of Attorney'}
                </p>
                <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-709">
                  <li data-id="element-710">{isEs ? 'Nombre completo' : 'Full name'}</li>
                  <li data-id="element-711">
                    {isEs ? 'Copia de su DNI' : 'Copy of their DNI (National Identification Card)'}
                  </li>
                  <li data-id="element-712">
                    {isEs ? 'Estado civil, profesión y dirección' : 'Marital status, profession, and address'}
                  </li>
                  <li data-id="element-713">
                    {isEs ? 'Si la persona es abogado: nombre completo, número de colegiación del Colegio de Abogados de Honduras y dirección profesional' : 'If the person is an attorney: full name, Honduras Bar Association card number, and professional address'}
                  </li>
                </ul>
              </div>
              <div className="bg-blue-50 rounded-lg p-2" data-id="element-714">
                <p className="font-semibold text-haa-blue mb-1 text-xs" data-id="element-715">
                  {isEs ? '3. Nombre de la Institución' : '3. Name of the Institution'}
                </p>
                <p className="pl-1 text-gray-600" data-id="element-716">
                  {isEs ? 'El nombre de la institución donde se realizará el trámite' : 'The name of the institution where the procedure will be carried out'}
                </p>
              </div>
            </div>
            <div className="bg-amber-50 rounded-lg p-2 border border-amber-200 mt-3" data-id="element-717">
              <p className="font-semibold text-amber-700 mb-1 text-xs" data-id="element-718">
                {isEs ? '📝 Nota' : '📝 Note'}
              </p>
              <p className="text-gray-600" data-id="element-719">
                {isEs ? 'El solicitante puede presentar un borrador del texto que requiere. De lo contrario, el documento se redactará según el tipo de Poder solicitado, siguiendo los formatos vigentes de Instrumentos Públicos establecidos en el Código Procesal Civil y el Código del Notariado.' : 'The applicant may present a draft of the text they require. Otherwise, the document will be drafted according to the type of Power of Attorney requested, following the current Public Instruments formats established in the Civil Procedural Code and the Notarial Code.'}
              </p>
            </div>
          </div>
        </div>
  }, {
    service: isEs ? 'Poder Especial' : 'Special Power of Attorney (Poder Especial)',
    price: '$200.00',
    subContent: <div className="space-y-3 text-xs text-gray-600" data-id="element-720">
          <div data-id="element-721">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-722">
              {isEs ? '📋 Confirmación de Cita' : '📋 Appointment Confirmation'}
            </p>
            <p className="pl-2 text-gray-500" data-id="element-723">
              {isEs ? 'La plataforma no está enviando confirmaciones de citas a las direcciones de correo electrónico. Se recomienda tomar una captura de pantalla en su teléfono del mensaje que aparece después de programar la cita.' : "The platform isn't sending appointment confirmations to email addresses. It's recommended that you take a screenshot on your phone of the message that appears after you schedule the appointment."}
            </p>
          </div>
          <div data-id="element-724">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-725">
              {isEs ? '📋 Descripción' : '📋 Description'}
            </p>
            <p className="pl-2 text-gray-500" data-id="element-726">
              {isEs ? 'Un Poder Especial se utiliza para autorizar a alguien a representarlo en un asunto específico hasta su conclusión. Por ejemplo: un poder para divorcio, matrimonio, disputas legales, representación y procedimientos similares.' : 'A Poder Especial is used to authorize someone to represent you in a specific matter through to its completion. For example: a power of attorney for divorce, marriage, legal disputes, representation, and similar proceedings.'}
            </p>
          </div>
          <div className="bg-red-50 rounded-lg p-2 border border-red-200" data-id="element-727">
            <p className="font-semibold text-red-700 mb-1 text-xs" data-id="element-728">
              {isEs ? '⚠️ Recordatorio Especial' : '⚠️ Special Reminder'}
            </p>
            <p className="text-gray-600" data-id="element-729">
              {isEs ? 'Este tipo de Poder es abierto y no tiene fecha de vencimiento.' : 'This type of Poder is open-ended and does not have an end date.'}
            </p>
          </div>
          <div className="border-t border-gray-200 pt-2 mt-2" data-id="element-730">
            <p className="font-bold text-gray-800 uppercase tracking-wide mb-2" data-id="element-731">
              {isEs ? 'Requisitos' : 'Requirements'}
            </p>
            <div className="space-y-2" data-id="element-732">
              <div className="bg-blue-50 rounded-lg p-2" data-id="element-733">
                <p className="font-semibold text-haa-blue mb-1 text-xs" data-id="element-734">
                  {isEs ? '1. Identificación del Solicitante' : "1. Applicant's Identification"}
                </p>
                <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-735">
                  <li data-id="element-736">
                    {isEs ? 'DNI o Pasaporte vigente' : 'Valid DNI (National Identification Card) or Passport'}
                  </li>
                  <li data-id="element-737">
                    {isEs ? 'Se le pedirán sus datos personales: estado civil, profesión y dirección' : 'You will be asked for your personal details: marital status, profession, and address'}
                  </li>
                </ul>
              </div>
              <div className="bg-blue-50 rounded-lg p-2" data-id="element-738">
                <p className="font-semibold text-haa-blue mb-1 text-xs" data-id="element-739">
                  {isEs ? '2. Información de la Persona que Recibe el Poder' : '2. Information of the Person Receiving the Power of Attorney'}
                </p>
                <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-740">
                  <li data-id="element-741">{isEs ? 'Nombre completo' : 'Full name'}</li>
                  <li data-id="element-742">
                    {isEs ? 'Copia de su DNI' : 'Copy of their DNI (National Identification Card)'}
                  </li>
                  <li data-id="element-743">
                    {isEs ? 'Estado civil, profesión y dirección' : 'Marital status, profession, and address'}
                  </li>
                  <li data-id="element-744">
                    {isEs ? 'Si la persona es abogado: nombre completo, número de colegiación del Colegio de Abogados de Honduras y dirección profesional' : 'If the person is an attorney: full name, Honduras Bar Association card number, and professional address'}
                  </li>
                </ul>
              </div>
              <div className="bg-blue-50 rounded-lg p-2" data-id="element-745">
                <p className="font-semibold text-haa-blue mb-1 text-xs" data-id="element-746">
                  {isEs ? '3. Nombre de la Institución' : '3. Name of the Institution'}
                </p>
                <p className="pl-1 text-gray-600" data-id="element-747">
                  {isEs ? 'El nombre de la institución donde se realizará el trámite' : 'The name of the institution where the procedure will be carried out'}
                </p>
              </div>
            </div>
            <div className="bg-amber-50 rounded-lg p-2 border border-amber-200 mt-3" data-id="element-748">
              <p className="font-semibold text-amber-700 mb-1 text-xs" data-id="element-749">
                {isEs ? '📝 Nota' : '📝 Note'}
              </p>
              <p className="text-gray-600" data-id="element-750">
                {isEs ? 'El solicitante puede presentar un borrador del texto que requiere. De lo contrario, el documento se redactará según el tipo de Poder solicitado, siguiendo los formatos vigentes de Instrumentos Públicos establecidos en el Código Procesal Civil y el Código del Notariado.' : 'The applicant may present a draft of the text they require. Otherwise, the document will be drafted according to the type of Power of Attorney requested, following the current Public Instruments formats established in the Civil Procedural Code and the Notarial Code.'}
              </p>
            </div>
          </div>
        </div>
  }, {
    service: isEs ? 'Testamento Abierto' : 'Open Will (Testamento Abierto)',
    price: '$100.00',
    subContent: <div className="space-y-3 text-xs text-gray-600" data-id="element-751">
          <div data-id="element-752">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-753">
              {isEs ? '📋 Confirmación de Cita' : '📋 Appointment Confirmation'}
            </p>
            <p className="pl-2 text-gray-500" data-id="element-754">
              {isEs ? 'La plataforma no está enviando confirmaciones de citas a las direcciones de correo electrónico. Se recomienda tomar una captura de pantalla en su teléfono del mensaje que aparece después de programar la cita.' : "The platform isn't sending appointment confirmations to email addresses. It's recommended that you take a screenshot on your phone of the message that appears after you schedule the appointment."}
            </p>
          </div>
          <div data-id="element-755">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-756">
              {isEs ? '🪪 Identificación del Testador' : '🪪 Testator Identification'}
            </p>
            <p className="pl-2 text-gray-500" data-id="element-757">
              {isEs ? 'Se requiere un DNI o pasaporte vigente' : 'A valid DNI or passport is required'}
            </p>
          </div>
          <div data-id="element-758">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-759">
              {isEs ? '🧑‍⚖️ Presencia en Persona' : '🧑‍⚖️ In-Person Appearance'}
            </p>
            <p className="pl-2 text-gray-500" data-id="element-760">
              {isEs ? 'La persona que hace el testamento debe presentarse en persona' : 'The person making the will must appear in person'}
            </p>
          </div>
          <div data-id="element-761">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-762">
              {isEs ? '📄 Identificación de Beneficiarios' : '📄 Beneficiary Identification'}
            </p>
            <p className="pl-2 text-gray-500" data-id="element-763">
              {isEs ? 'Se requiere una copia del DNI o pasaporte vigente de cada persona nombrada en el testamento' : 'A copy of the valid DNI or passport of each person named in the will is required'}
            </p>
          </div>
          <div className="bg-blue-50 rounded-lg p-2 border border-blue-200 mt-1" data-id="element-764">
            <p className="font-semibold text-haa-blue mb-1 text-xs" data-id="element-765">
              {isEs ? 'ℹ️ ¿Qué es un Testamento Abierto?' : 'ℹ️ What is a Testamento Abierto?'}
            </p>
            <p className="text-gray-600" data-id="element-766">
              {isEs ? 'Un testamento abierto es aquel que se otorga ante un notario y testigos, y cuyo contenido es conocido por todos los presentes.' : 'An open will is one that is granted before a notary and witnesses, and whose content is known by all those present.'}
            </p>
          </div>
        </div>
  }, {
    service: isEs ? 'Testamento Cerrado' : 'Closed Will (Testamento Cerrado)',
    price: '$150.00',
    subContent: <div className="space-y-3 text-xs text-gray-600" data-id="element-767">
          <div data-id="element-768">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-769">
              {isEs ? '📋 Confirmación de Cita' : '📋 Appointment Confirmation'}
            </p>
            <p className="pl-2 text-gray-500" data-id="element-770">
              {isEs ? 'La plataforma no está enviando confirmaciones de citas a las direcciones de correo electrónico. Se recomienda tomar una captura de pantalla en su teléfono del mensaje que aparece después de programar la cita.' : "The platform isn't sending appointment confirmations to email addresses. It's recommended that you take a screenshot on your phone of the message that appears after you schedule the appointment."}
            </p>
          </div>
          <div data-id="element-771">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-772">
              {isEs ? '🪪 Identificación del Testador' : '🪪 Testator Identification'}
            </p>
            <p className="pl-2 text-gray-500" data-id="element-773">
              {isEs ? 'Se requiere un DNI o pasaporte vigente' : 'A valid DNI or passport is required'}
            </p>
          </div>
          <div data-id="element-774">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-775">
              {isEs ? '🧑‍⚖️ Presencia en Persona' : '🧑‍⚖️ In-Person Appearance'}
            </p>
            <p className="pl-2 text-gray-500" data-id="element-776">
              {isEs ? 'La persona que hace el testamento debe presentarse en persona' : 'The person making the will must appear in person'}
            </p>
          </div>
          <div data-id="element-777">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-778">
              {isEs ? '📄 Identificación de Beneficiarios' : '📄 Beneficiary Identification'}
            </p>
            <p className="pl-2 text-gray-500" data-id="element-779">
              {isEs ? 'Se requiere una copia del DNI o pasaporte vigente de cada persona nombrada en el testamento' : 'A copy of the valid DNI or passport of each person named in the will is required'}
            </p>
          </div>
          <div className="bg-blue-50 rounded-lg p-2 border border-blue-200 mt-1" data-id="element-780">
            <p className="font-semibold text-haa-blue mb-1 text-xs" data-id="element-781">
              {isEs ? 'ℹ️ ¿Qué es un Testamento Cerrado?' : 'ℹ️ What is a Testamento Cerrado?'}
            </p>
            <p className="text-gray-600" data-id="element-782">
              {isEs ? 'Un testamento cerrado es aquel cuyo contenido permanece sellado y secreto hasta después del fallecimiento del testador. Se presenta ante un notario en un sobre cerrado.' : 'A closed will is one whose content remains sealed and secret until after the death of the testator. It is presented before a notary in a sealed envelope.'}
            </p>
          </div>
        </div>
  }, {
    service: isEs ? 'Carta Poder' : 'Power of Attorney Letter (Carta Poder)',
    price: '$50.00',
    subContent: <div className="space-y-2 text-xs text-gray-600" data-id="element-783">
          <div data-id="element-784">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-785">
              {isEs ? '📋 Confirmación de Cita' : '📋 Appointment Confirmation'}
            </p>
            <p className="pl-2 text-gray-500" data-id="element-786">
              {isEs ? 'La plataforma no está enviando confirmaciones de citas a las direcciones de correo electrónico. Se recomienda tomar una captura de pantalla en su teléfono del mensaje que aparece después de programar la cita.' : "The platform isn't sending appointment confirmations to email addresses. It's recommended that you take a screenshot on your phone of the message that appears after you schedule the appointment."}
            </p>
          </div>
          <div data-id="element-787">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-788">
              {isEs ? '📝 Descripción' : '📝 Description'}
            </p>
            <p className="pl-2 text-gray-500" data-id="element-789">
              {isEs ? 'Una Carta Poder se utiliza para autorizar a alguien a representarlo en un asunto específico ante una oficina específica. Por ejemplo: trámites de cobro de pensión ante agencias como INJUPEM o las Fuerzas Armadas (FFAA), apertura y/o cierre de cuentas bancarias, y otras transacciones similares.' : 'A Carta Poder is used to authorize someone to represent you in a specific matter before a specific office. For example: pension collection procedures before agencies such as INJUPEM or the Armed Forces (FFAA), opening and/or closing bank accounts, and other similar transactions.'}
            </p>
          </div>
          <div className="border-t border-gray-200 pt-2 mt-2" data-id="element-790">
            <p className="font-bold text-gray-800 uppercase tracking-wide mb-2" data-id="element-791">
              {isEs ? 'Requisitos' : 'Requirements'}
            </p>
            <div className="space-y-2" data-id="element-792">
              <div className="bg-blue-50 rounded-lg p-2" data-id="element-793">
                <p className="font-semibold text-haa-blue mb-1 text-xs" data-id="element-794">
                  {isEs ? '1. Identificación del Solicitante' : "1. Applicant's Identification"}
                </p>
                <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-795">
                  <li data-id="element-796">
                    {isEs ? 'DNI o Pasaporte vigente' : 'Valid DNI (National Identification Card) or Passport'}
                  </li>
                  <li data-id="element-797">
                    {isEs ? 'Se le pedirán sus datos personales: estado civil, profesión y dirección' : 'You will be asked for your personal details: marital status, profession, and address'}
                  </li>
                </ul>
              </div>
              <div className="bg-blue-50 rounded-lg p-2" data-id="element-798">
                <p className="font-semibold text-haa-blue mb-1 text-xs" data-id="element-799">
                  {isEs ? '2. Información de la Persona que Recibe el Poder' : '2. Information of the Person Receiving the Power of Attorney'}
                </p>
                <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-800">
                  <li data-id="element-801">{isEs ? 'Nombre completo' : 'Full name'}</li>
                  <li data-id="element-802">
                    {isEs ? 'Copia de su DNI' : 'Copy of their DNI (National Identification Card)'}
                  </li>
                  <li data-id="element-803">
                    {isEs ? 'Estado civil, profesión y dirección' : 'Marital status, profession, and address'}
                  </li>
                  <li data-id="element-804">
                    {isEs ? 'Si la persona es abogado: nombre completo, número de colegiación del Colegio de Abogados de Honduras y dirección profesional' : 'If the person is an attorney: full name, Honduras Bar Association card number, and professional address'}
                  </li>
                </ul>
              </div>
              <div className="bg-blue-50 rounded-lg p-2" data-id="element-805">
                <p className="font-semibold text-haa-blue mb-1 text-xs" data-id="element-806">
                  {isEs ? '3. Nombre de la Institución' : '3. Name of the Institution'}
                </p>
                <p className="pl-1 text-gray-600" data-id="element-807">
                  {isEs ? 'El nombre de la institución donde se realizará el trámite' : 'The name of the institution where the procedure will be carried out'}
                </p>
              </div>
            </div>
            <div className="bg-amber-50 rounded-lg p-2 border border-amber-200 mt-3" data-id="element-808">
              <p className="font-semibold text-amber-700 mb-1 text-xs" data-id="element-809">
                {isEs ? '📝 Nota' : '📝 Note'}
              </p>
              <p className="text-gray-600" data-id="element-810">
                {isEs ? 'El solicitante puede presentar un borrador del texto que requiere. De lo contrario, el documento se redactará según el tipo de Poder solicitado, siguiendo los formatos vigentes de Instrumentos Públicos establecidos en el Código Procesal Civil y el Código del Notariado.' : 'The applicant may present a draft of the text they require. Otherwise, the document will be drafted according to the type of Power of Attorney requested, following the current Public Instruments formats established in the Civil Procedural Code and the Notarial Code.'}
              </p>
            </div>
          </div>
        </div>
  }, {
    service: isEs ? 'Declaración Jurada' : 'Sworn Statement (Declaración Jurada)',
    price: '$50.00'
  }, {
    service: isEs ? 'Autorizaciones' : 'Authorizations (Autorizaciones)',
    price: '$50.00',
    subContent: <div className="space-y-3 text-xs text-gray-600" data-id="element-811">
          <div data-id="element-812">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-813">
              {isEs ? '📋 Confirmación de Cita' : '📋 Appointment Confirmation'}
            </p>
            <p className="pl-2 text-gray-500" data-id="element-814">
              {isEs ? 'La plataforma no está enviando confirmaciones de citas a las direcciones de correo electrónico. Se recomienda tomar una captura de pantalla en su teléfono del mensaje que aparece después de programar la cita.' : "The platform isn't sending appointment confirmations to email addresses. It's recommended that you take a screenshot on your phone of the message that appears after you schedule the appointment."}
            </p>
          </div>
          <div data-id="element-815">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-816">
              {isEs ? '📋 Descripción' : '📋 Description'}
            </p>
            <p className="pl-2 text-gray-500" data-id="element-817">
              {isEs ? 'Destinado a padres que autorizan a otro padre a completar un trámite para su hijo, como solicitar un pasaporte.' : 'Intended for parents who authorize another parent to complete a procedure for their child, such as applying for a passport.'}
            </p>
          </div>
          <div className="border-t border-gray-200 pt-2" data-id="element-818">
            <p className="font-bold text-gray-800 mb-2 uppercase tracking-wide text-xs" data-id="element-819">
              {isEs ? 'Requisitos' : 'Requirements'}
            </p>
            <div className="space-y-2" data-id="element-820">
              <div className="bg-blue-50 rounded-lg p-2" data-id="element-821">
                <p className="font-semibold text-haa-blue mb-1 text-xs" data-id="element-822">
                  {isEs ? '1. Identificación del Padre/Madre' : "1. Parent's Identification"}
                </p>
                <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-823">
                  <li data-id="element-824">
                    {isEs ? 'DNI o Pasaporte vigente' : 'Valid DNI or Passport'}
                  </li>
                  <li data-id="element-825">
                    {isEs ? 'Debe presentarse en persona' : 'Must appear in person'}
                  </li>
                </ul>
              </div>
              <div className="bg-blue-50 rounded-lg p-2" data-id="element-826">
                <p className="font-semibold text-haa-blue mb-1 text-xs" data-id="element-827">
                  {isEs ? '2. Información del Menor' : "2. Minor's Information"}
                </p>
                <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-828">
                  <li data-id="element-829">
                    {isEs ? 'Acta de nacimiento del menor' : "Minor's birth certificate"}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
  }, {
    service: isEs ? 'Certificaciones Varias' : 'Miscellaneous Certifications (Certificaciones Varias)',
    price: '$50.00',
    subContent: <div className="space-y-3 text-xs text-gray-600" data-id="element-830">
          <div data-id="element-831">
            <p className="font-semibold text-gray-700 mb-0.5" data-id="element-832">
              {isEs ? '📋 Confirmación de Cita' : '📋 Appointment Confirmation'}
            </p>
            <p className="pl-2 text-gray-500" data-id="element-833">
              {isEs ? 'La plataforma no está enviando confirmaciones de citas a las direcciones de correo electrónico. Se recomienda tomar una captura de pantalla en su teléfono del mensaje que aparece después de programar la cita.' : "The platform isn't sending appointment confirmations to email addresses. It's recommended that you take a screenshot on your phone of the message that appears after you schedule the appointment."}
            </p>
          </div>
          <div data-id="element-834">
            <p className="text-gray-600 leading-relaxed" data-id="element-835">
              {isEs ? 'Certificación de documentos como licencias de manejar o acta de nacimiento, etc.' : "Certification of documents such as driver's licenses or birth certificates, etc."}
            </p>
          </div>
          <div className="bg-blue-50 rounded-lg p-2 border border-blue-200" data-id="element-836">
            <p className="text-gray-600" data-id="element-837">
              {isEs ? '• Consultar con el consulado si tiene preguntas.' : '• Contact the consulate if you have questions.'}
            </p>
          </div>
        </div>
  }];
  return <motion.article ref={ref} initial={{
    opacity: 0,
    y: 50,
    rotate: index % 2 === 0 ? -2 : 2
  }} animate={inView ? {
    opacity: 1,
    y: 0,
    rotate: 0
  } : {}} transition={{
    duration: 0.7,
    delay: index * 0.1,
    ease: [0.16, 1, 0.3, 1]
  }} className={`bg-white rounded-2xl shadow-lg overflow-hidden border-l-4 ${tip.borderColor} flex flex-col`} data-id="element-838">
      <div className="p-6 flex flex-col flex-1" data-id="element-839">
        <div className="flex items-center gap-2 mb-4 cursor-pointer group/header" onClick={() => setExpandedModal(true)} role="button" tabIndex={0} onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setExpandedModal(true);
        }
      }} data-id="element-840">
          <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${tip.gradient} flex items-center justify-center shadow-md group-hover/header:shadow-lg transition-shadow`} data-id="element-841">
            <Icon className="w-6 h-6 text-white" data-id="element-842" />
          </div>
          {tip.flag && <span className="text-2xl" role="img" aria-label="flag" data-id="element-843">
              {tip.flag}
            </span>}
          <div className="ml-auto opacity-0 group-hover/header:opacity-100 transition-opacity" data-id="element-844">
            <svg className="w-4 h-4 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-845">
              <path d="M15 3h6v6M14 10l6.1-6.1M9 21H3v-6M10 14l-6.1 6.1" data-id="element-846" />
            </svg>
          </div>
        </div>

        <h3 className={`font-bebas text-2xl tracking-wider leading-tight mb-2 ${tip.accentColor} cursor-pointer hover:opacity-80 transition-opacity`} onClick={() => setExpandedModal(true)} data-id="element-847">
          {t(tip.titleKey)}
        </h3>

        <div className="font-nunito text-gray-500 text-sm leading-relaxed flex-1" data-id="element-848">
          <p data-id="element-849">{t(tip.descriptionKey)}</p>
          {tip.titleKey === 'consular.card4.title' && <ul className="list-disc list-inside mt-1.5 space-y-0.5 text-gray-500 text-xs" data-id="element-850">
              <li data-id="element-851">{t('consular.card4.bullet1')}</li>
              <li data-id="element-852">{t('consular.card4.bullet2')}</li>
              <li data-id="element-853">{t('consular.card4.bullet4')}</li>
            </ul>}

          {tip.link && <div className="mt-2 flex flex-col gap-2" data-id="element-854">
              {/* Emergency Assistance Dropdown */}
              <div className="rounded-xl border border-gray-200 overflow-hidden" data-id="element-855">
                <button onClick={() => setEmergencyOpen(!emergencyOpen)} className="w-full flex items-center justify-between px-3 py-2 bg-gray-50 hover:bg-gray-100 transition-colors text-left" data-id="element-856">
                  <span className={`font-semibold text-xs ${tip.accentColor} uppercase tracking-wide`} data-id="element-857">
                    {isEs ? '🚨 Asistencia de Emergencia' : '🚨 Emergency Assistance'}
                  </span>
                  <motion.div animate={{
                rotate: emergencyOpen ? 180 : 0
              }} transition={{
                duration: 0.2
              }} data-id="element-858">
                    <ChevronDownIcon className={`w-3.5 h-3.5 ${tip.accentColor}`} data-id="element-859" />
                  </motion.div>
                </button>
                <AnimatePresence initial={false} data-id="element-860">
                  {emergencyOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: [0.16, 1, 0.3, 1]
              }} className="overflow-hidden" data-id="element-861">
                      <div className="px-3 py-3 bg-white border-t border-gray-100 text-xs text-gray-600 space-y-2" data-id="element-862">
                        <img src="https://cdn.magicpatterns.com/uploads/hLxF4YHQUyJak43UqQtdRn/Tegucigalpa_MCACView_Resized-2-1024x753.jpg" alt={isEs ? 'Embajada de los Estados Unidos de América en Tegucigalpa' : 'Embassy of the United States of America in Tegucigalpa'} className="w-full rounded-lg object-cover mb-2" data-id="element-863" />
                        <p className="leading-relaxed" data-id="element-864">
                          {isEs ? 'Para emergencias en Honduras, los ciudadanos estadounidenses deben llamar al ' : 'For emergencies in Honduras, U.S. citizens should call '}
                          <strong data-id="element-865">911</strong>
                          {isEs ? ' para policía local, bomberos o asistencia médica.' : 'for local police, fire, or medical assistance.'}
                        </p>
                        <div className="flex items-center gap-2" data-id="element-866">
                          <PhoneIcon className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" data-id="element-867" />
                          <span data-id="element-868">
                            {isEs ? 'Embajada de EE.UU. Emergencias:' : 'U.S. Embassy Emergency:'}
                          </span>
                          <a href="tel:+50422385114" className={`font-semibold ${tip.accentColor} hover:underline`} data-id="element-869">
                            +504 2238-5114
                          </a>
                        </div>
                        <div className="flex items-center gap-2" data-id="element-870">
                          <PhoneIcon className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" data-id="element-871" />
                          <span data-id="element-872">
                            {isEs ? 'Fuera de Horario:' : 'After Hours:'}
                          </span>
                          <a href="tel:+50422369320" className={`font-semibold ${tip.accentColor} hover:underline`} data-id="element-873">
                            +504 2236-9320
                          </a>
                        </div>
                        <div className="flex items-center gap-2" data-id="element-874">
                          <PhoneIcon className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" data-id="element-875" />
                          <span data-id="element-876">
                            {isEs ? 'Consulta General (Tegucigalpa):' : 'General Inquiries (Tegucigalpa):'}
                          </span>
                          <a href="tel:+50422175000" className={`font-semibold ${tip.accentColor} hover:underline`} data-id="element-877">
                            +504 2217-5000
                          </a>
                        </div>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>

              <a href="https://prechequeo.inm.gob.hn/" target="_blank" rel="noopener noreferrer" className={`inline-flex items-center gap-1 font-semibold text-xs ${tip.accentColor} hover:underline`} data-id="element-878">
                {isEs ? 'Pre-chequeo Migratorio de Honduras' : 'Honduras Immigration Pre-check'}{' '}
                →
              </a>
              <a href="https://sisglobal.aduanas.gob.hn/Pech/#/plataforma/otra_gestiones/formularioDJRV" target="_blank" rel="noopener noreferrer" className={`inline-flex items-center gap-1 font-semibold text-xs ${tip.accentColor} hover:underline`} data-id="element-879">
                {isEs ? 'Formulario de Viaje de Aduanas de Honduras' : 'Honduras Customs Travel Form'}{' '}
                →
              </a>
              <a href={tip.link.url} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center gap-1 font-semibold text-xs ${tip.accentColor} hover:underline`} data-id="element-880">
                {isEs ? 'Aviso de Viaje para Honduras' : tip.link.label} →
              </a>
              <a href="https://mytravel.state.gov/s/step" target="_blank" rel="noopener noreferrer" className={`inline-flex items-center gap-1 font-semibold text-xs ${tip.accentColor} hover:underline`} data-id="element-881">
                {isEs ? 'STEP – Programa de Inscripción para Viajeros Inteligentes' : 'STEP – Smart Traveler Enrollment Program'}{' '}
                →
              </a>
              <a href="https://www.instagram.com/usembassyhn/" target="_blank" rel="noopener noreferrer" className={`inline-flex items-center gap-1 font-semibold text-xs ${tip.accentColor} hover:underline`} data-id="element-882">
                {isEs ? 'Embajada de EE.UU. en Honduras (Instagram)' : 'US Embassy Honduras (Instagram)'}{' '}
                →
              </a>
              <a href="https://hn.usembassy.gov/" target="_blank" rel="noopener noreferrer" className={`inline-flex items-center gap-1 font-semibold text-xs ${tip.accentColor} hover:underline`} data-id="element-883">
                {isEs ? 'Embajada de EE.UU. en Honduras (Página Principal)' : 'US Embassy Honduras (Homepage)'}{' '}
                →
              </a>
              <a href="https://hn.usembassy.gov/education/" target="_blank" rel="noopener noreferrer" className={`inline-flex items-center gap-1 font-semibold text-xs ${tip.accentColor} hover:underline`} data-id="element-884">
                US Embassy Honduras (Education Opportunities) →
              </a>
              <a href="https://www.uscis.gov/" target="_blank" rel="noopener noreferrer" className={`inline-flex items-center gap-1 font-semibold text-xs ${tip.accentColor} hover:underline`} data-id="element-885">
                {isEs ? 'USCIS — Servicios de Ciudadanía e Inmigración de EE.UU.' : 'USCIS — U.S. Citizenship and Immigration Services'}{' '}
                →
              </a>
            </div>}

          {tip.links && tip.links.length > 0 && <div className="mt-2 flex flex-col gap-2" data-id="element-886">
              {tip.titleKey === 'consular.card4.title' && tip.links.filter(l => l.info === 'fees').map((l, _idx) => {
            const feeIndex = tip.links.findIndex(link => link.info === 'fees');
            return <div key="fees-top" className="bg-amber-50 rounded-xl p-2.5 border border-amber-200 mb-1" data-id="element-887">
                        <p className="font-semibold text-amber-700 mb-1 text-xs" data-id="element-888">
                          {isEs ? 'Aranceles Consulares' : 'Consular Fees'}
                        </p>
                        <p className="text-[10px] text-gray-500 leading-relaxed mb-2" data-id="element-889">
                          {isEs ? 'Tarifas oficiales para servicios consulares para 2026' : 'Official fees for consular services for 2026'}
                        </p>
                        <div className="rounded-xl border overflow-hidden border-gray-200" data-id="element-890">
                          <div className="flex items-center justify-between px-3 py-2 bg-gray-50" onClick={() => setOpenLinkInfo(openLinkInfo === feeIndex ? null : feeIndex)} role="button" data-id="element-891">
                            <span className={`inline-flex items-center gap-1 font-semibold text-xs ${tip.accentColor}`} data-id="element-892">
                              {isEs && l.labelEs ? l.labelEs : l.label}
                            </span>
                            <button onClick={() => setOpenLinkInfo(openLinkInfo === feeIndex ? null : feeIndex)} className="ml-2 flex items-center gap-1 transition-colors text-gray-400 hover:text-gray-600" aria-label="More info" data-id="element-893">
                              <span className="text-xs font-medium" data-id="element-894">
                                {t('consular.info.button')}
                              </span>
                              <motion.div animate={{
                      rotate: openLinkInfo === feeIndex ? 180 : 0
                    }} transition={{
                      duration: 0.2
                    }} data-id="element-895">
                                <ChevronDownIcon className="w-3.5 h-3.5" data-id="element-896" />
                              </motion.div>
                            </button>
                          </div>
                          <AnimatePresence initial={false} data-id="element-897">
                            {openLinkInfo === feeIndex && <motion.div initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.25,
                    ease: [0.16, 1, 0.3, 1]
                  }} className="overflow-hidden" data-id="element-898">
                                <div className="px-3 py-3 bg-white border-t border-gray-100" data-id="element-899">
                                  <div className="space-y-1" data-id="element-900">
                                    <p className="text-xs font-bold text-center py-1.5 px-2 bg-green-100 text-green-700 rounded-lg mb-2" data-id="element-901">
                                      {isEs ? 'ℹ️ Aranceles vigentes a partir de 2026.' : 'ℹ️ Fees current as of 2026.'}
                                    </p>
                                    {feeItems.map((item, idx) => <div key={idx} className="border-b border-gray-50 last:border-none" data-id="element-902">
                                        <div className={`flex items-center justify-between py-1.5 ${item.subContent ? 'cursor-pointer hover:bg-gray-50 rounded-lg px-1 -mx-1 transition-colors' : ''}`} onClick={item.subContent ? () => setOpenFeeSubItem(openFeeSubItem === idx ? null : idx) : undefined} role={item.subContent ? 'button' : undefined} tabIndex={item.subContent ? 0 : undefined} onKeyDown={item.subContent ? e => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault();
                              setOpenFeeSubItem(openFeeSubItem === idx ? null : idx);
                            }
                          } : undefined} data-id="element-903">
                                          <span className="text-xs text-gray-600 pr-2" data-id="element-904">
                                            {item.service}
                                          </span>
                                          <div className="flex items-center gap-1 flex-shrink-0" data-id="element-905">
                                            <span className={`text-xs font-bold ${tip.accentColor}`} data-id="element-906">
                                              {item.price}
                                            </span>
                                            {item.subContent && <motion.div animate={{
                                rotate: openFeeSubItem === idx ? 180 : 0
                              }} transition={{
                                duration: 0.2
                              }} className="ml-1 text-gray-400" data-id="element-907">
                                                <ChevronDownIcon className="w-3 h-3" data-id="element-908" />
                                              </motion.div>}
                                          </div>
                                        </div>
                                        {item.subContent && <AnimatePresence initial={false} data-id="element-909">
                                            {openFeeSubItem === idx && <motion.div initial={{
                              height: 0,
                              opacity: 0
                            }} animate={{
                              height: 'auto',
                              opacity: 1
                            }} exit={{
                              height: 0,
                              opacity: 0
                            }} transition={{
                              duration: 0.25,
                              ease: [0.16, 1, 0.3, 1]
                            }} className="overflow-hidden" data-id="element-910">
                                                <div className="pb-2 pt-1 pl-1 pr-1 bg-gray-50 rounded-lg mb-1" data-id="element-911">
                                                  {item.subContent}
                                                </div>
                                              </motion.div>}
                                          </AnimatePresence>}
                                      </div>)}
                                  </div>
                                </div>
                              </motion.div>}
                          </AnimatePresence>
                        </div>
                      </div>;
          })}
              {tip.titleKey === 'consular.card4.title' && <div className="bg-emerald-50 rounded-xl p-2.5 border border-emerald-200 mb-1" data-id="element-912">
                  <p className="font-semibold text-emerald-700 mb-1 text-xs" data-id="element-913">
                    {isEs ? 'Plataforma de Citas SRECI' : 'SRECI Appointment Platform'}
                  </p>
                  <p className="text-[10px] text-gray-500 leading-relaxed mb-2" data-id="element-914">
                    {isEs ? 'Para los siguientes consulados:' : 'For the following consulates:'}{' '}
                    Atlanta · Aurora · Boston · Charlotte · Chicago · Dallas ·
                    Houston · McAllen · Miami · New Orleans · New York · Oakland
                    · Seattle · Washington DC
                  </p>
                  {/* Consular Appointments dropdown nested inside */}
                  {tip.links.filter(l => l.info === 'appointments').map((l, idx) => {
              const originalIndex = tip.links.findIndex(link => link.info === 'appointments');
              return <div key={`appt-${idx}`} className="rounded-xl border overflow-hidden border-gray-200" data-id="element-915">
                          <div className="flex items-center justify-between px-3 py-2 bg-gray-50" onClick={() => setOpenLinkInfo(openLinkInfo === originalIndex ? null : originalIndex)} role="button" data-id="element-916">
                            <span className={`inline-flex items-center gap-1 font-semibold text-xs ${tip.accentColor}`} data-id="element-917">
                              {isEs && l.labelEs ? l.labelEs : l.label}
                            </span>
                            <button onClick={() => setOpenLinkInfo(openLinkInfo === originalIndex ? null : originalIndex)} className="ml-2 flex items-center gap-1 transition-colors text-gray-400 hover:text-gray-600" aria-label="More info" data-id="element-918">
                              <span className="text-xs font-medium" data-id="element-919">
                                {t('consular.info.button')}
                              </span>
                              <motion.div animate={{
                      rotate: openLinkInfo === originalIndex ? 180 : 0
                    }} transition={{
                      duration: 0.2
                    }} data-id="element-920">
                                <ChevronDownIcon className="w-3.5 h-3.5 text-gray-400" data-id="element-921" />
                              </motion.div>
                            </button>
                          </div>
                          <AnimatePresence initial={false} data-id="element-922">
                            {openLinkInfo === originalIndex && <motion.div initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.25,
                    ease: [0.16, 1, 0.3, 1]
                  }} className="overflow-hidden" data-id="element-923">
                                <div className="px-3 py-2.5 bg-white border-t border-gray-100 space-y-3 text-xs text-gray-600" data-id="element-924">
                                  <a href="https://citaconsular.sreci.gob.hn/citaconsular/pages/layout/CitaConsular.php" target="_blank" rel="noopener noreferrer" className="w-full inline-flex items-center justify-center gap-2 py-2.5 px-4 bg-gradient-to-r from-emerald-500 to-haa-skyblue text-white font-nunito font-bold text-sm rounded-xl shadow-md hover:shadow-lg transition-shadow" data-id="element-925">
                                    📅{' '}
                                    {isEs ? 'Hacer una Cita' : 'Make an Appointment'}
                                  </a>

                                  <div className="space-y-2.5" data-id="element-926">
                                    <div className="bg-blue-50 rounded-lg p-2" data-id="element-927">
                                      <p className="font-semibold text-haa-blue mb-1" data-id="element-928">
                                        {isEs ? 'Paso 1 — Buscar su identidad' : 'Step 1 — Search Your Identity'}
                                      </p>
                                      <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-929">
                                        <li data-id="element-930">
                                          {isEs ? 'Ingrese su Número de Identidad Nacional' : 'Enter your National Identification Number'}
                                        </li>
                                        <li data-id="element-931">
                                          {isEs ? 'Haga clic en "Buscar"' : 'Click "Search"'}
                                        </li>
                                      </ul>
                                    </div>
                                    <div className="bg-blue-50 rounded-lg p-2" data-id="element-932">
                                      <p className="font-semibold text-haa-blue mb-1" data-id="element-933">
                                        {isEs ? 'Paso 2 — Seleccionar consulado y servicio' : 'Step 2 — Select Consulate & Service'}
                                      </p>
                                      <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-934">
                                        <li data-id="element-935">
                                          {isEs ? 'En Ubicación, seleccione "Estados Unidos"' : 'Under Location, select "United States"'}
                                        </li>
                                        <li data-id="element-936">
                                          {isEs ? 'En Seleccionar Consulado, elija el consulado donde desea completar su servicio' : 'Under Select Consulate, choose the consulate where you want to complete your service'}
                                        </li>
                                        <li data-id="element-937">
                                          {isEs ? 'En Tipo de Servicio, seleccione el servicio que desea' : 'Under Type of Service, select the service you want'}
                                        </li>
                                      </ul>
                                    </div>
                                    <div className="bg-blue-50 rounded-lg p-2" data-id="element-938">
                                      <p className="font-semibold text-haa-blue mb-1" data-id="element-939">
                                        {isEs ? 'Paso 3 — Información personal' : 'Step 3 — Personal Information'}
                                      </p>
                                      <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-940">
                                        <li data-id="element-941">
                                          {isEs ? 'Ingrese su ciudad, código postal, correo electrónico, número de teléfono y dirección' : 'Enter your city, ZIP code, email address, phone number, and address'}
                                        </li>
                                        <li data-id="element-942">
                                          {isEs ? 'Haga clic en "Seleccionar"' : 'Click "Select"'}
                                        </li>
                                      </ul>
                                    </div>
                                    <div className="bg-blue-50 rounded-lg p-2" data-id="element-943">
                                      <p className="font-semibold text-haa-blue mb-1" data-id="element-944">
                                        {isEs ? 'Paso 4 — Seleccionar una fecha' : 'Step 4 — Select a Date'}
                                      </p>
                                      <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-945">
                                        <li data-id="element-946">
                                          {isEs ? 'Se abrirá la página del calendario' : 'The calendar page will open'}
                                        </li>
                                        <li data-id="element-947">
                                          {isEs ? 'Seleccione un día disponible en el calendario:' : 'Select an available day on the calendar:'}
                                          <ul className="list-disc list-inside pl-3 mt-0.5 space-y-0.5 text-gray-500" data-id="element-948">
                                            <li data-id="element-949">
                                              {isEs ? 'Días en blanco = disponibles' : 'Days in white = available'}
                                            </li>
                                            <li data-id="element-950">
                                              {isEs ? 'Días en morado = sin citas disponibles' : 'Days in purple = no appointments available'}
                                            </li>
                                            <li data-id="element-951">
                                              {isEs ? 'Días en rojo = el consulado no ofrece servicios' : 'Days in red = consulate does not offer services'}
                                            </li>
                                          </ul>
                                        </li>
                                      </ul>
                                    </div>
                                    <div className="bg-blue-50 rounded-lg p-2" data-id="element-952">
                                      <p className="font-semibold text-haa-blue mb-1" data-id="element-953">
                                        {isEs ? 'Paso 5 — Confirmar su cita' : 'Step 5 — Confirm Your Appointment'}
                                      </p>
                                      <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-954">
                                        <li data-id="element-955">
                                          {isEs ? 'Una vez que seleccione un día, aparecerán todos los detalles de su cita' : 'Once you select a day, all of your appointment details will appear'}
                                        </li>
                                        <li data-id="element-956">
                                          {isEs ? 'Desplácese hacia abajo y haga clic en "Ver Requisitos"' : 'Scroll down and click "View Requirements"'}
                                        </li>
                                        <li data-id="element-957">
                                          {isEs ? 'Luego desplácese hacia abajo nuevamente y haga clic en "Programar Cita"' : 'Then scroll down again and click "Schedule Appointment"'}
                                        </li>
                                        <li data-id="element-958">
                                          {isEs ? 'Aparecerá la confirmación de su cita' : 'Your appointment confirmation will appear'}
                                        </li>
                                        <li data-id="element-959">
                                          {isEs ? 'Tome una captura de pantalla de la confirmación como prueba de su cita' : 'Take a screenshot of the confirmation to keep as proof of your appointment'}
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </motion.div>}
                          </AnimatePresence>
                        </div>;
            })}
                </div>}
              {tip.titleKey === 'consular.card4.title' && <div className="bg-blue-50 rounded-xl p-2.5 border border-blue-200 mb-1" data-id="element-960">
                  <p className="font-semibold text-haa-blue mb-1 text-xs" data-id="element-961">
                    {isEs ? 'Plataforma de Citas ACOS' : 'ACOS Appointment Platform'}
                  </p>
                  <p className="text-[10px] text-gray-500 leading-relaxed mb-2" data-id="element-962">
                    {isEs ? 'Para los siguientes consulados:' : 'For the following consulates:'}{' '}
                    Tampa · Pittsburgh · Phoenix · Colorado · Los Angeles ·
                    Kansas
                  </p>
                  {/* ACOS Appointment Guide dropdown nested inside */}
                  {tip.links.filter(l => l.info === 'la-appointments').map((l, idx) => {
              const originalIndex = tip.links.findIndex(link => link.info === 'la-appointments');
              return <div key={`acos-${idx}`} className="rounded-xl border overflow-hidden border-gray-200" data-id="element-963">
                          <div className="flex items-center justify-between px-3 py-2 bg-gray-50" onClick={() => setOpenLinkInfo(openLinkInfo === originalIndex ? null : originalIndex)} role="button" data-id="element-964">
                            <span className={`inline-flex items-center gap-1 font-semibold text-xs ${tip.accentColor}`} data-id="element-965">
                              {isEs && l.labelEs ? l.labelEs : l.label}
                            </span>
                            <button onClick={() => setOpenLinkInfo(openLinkInfo === originalIndex ? null : originalIndex)} className="ml-2 flex items-center gap-1 transition-colors text-gray-400 hover:text-gray-600" aria-label="More info" data-id="element-966">
                              <span className="text-xs font-medium" data-id="element-967">
                                {t('consular.info.button')}
                              </span>
                              <motion.div animate={{
                      rotate: openLinkInfo === originalIndex ? 180 : 0
                    }} transition={{
                      duration: 0.2
                    }} data-id="element-968">
                                <ChevronDownIcon className="w-3.5 h-3.5 text-gray-400" data-id="element-969" />
                              </motion.div>
                            </button>
                          </div>
                          <AnimatePresence initial={false} data-id="element-970">
                            {openLinkInfo === originalIndex && <motion.div initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.25,
                    ease: [0.16, 1, 0.3, 1]
                  }} className="overflow-hidden" data-id="element-971">
                                <div className="px-3 py-2.5 bg-white border-t border-gray-100 space-y-3 text-xs text-gray-600" data-id="element-972">
                                  
                                  <a href="https://asuntosconsulares.inm.gob.hn/#openModal" target="_blank" rel="noopener noreferrer" className="w-full inline-flex items-center justify-center gap-2 py-2.5 px-4 bg-gradient-to-r from-haa-blue to-haa-midblue text-white font-nunito font-bold text-sm rounded-xl shadow-md hover:shadow-lg transition-shadow" data-id="element-973">
                                    📅 Make An Appointment
                                  </a>
                                  <div className="space-y-2.5" data-id="element-974">
                                    <div className="bg-blue-50 rounded-lg p-2" data-id="element-975">
                                      <p className="font-semibold text-haa-blue mb-1" data-id="element-976">
                                        {isEs ? 'Paso 1 — Acceso a la plataforma' : 'Step 1 — Access the Platform'}
                                      </p>
                                      <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-977">
                                        <li data-id="element-978">
                                          {isEs ? 'Busca en Google: "Asuntos Consulares Honduras", haz clic en el primer resultado, o haz clic en el botón azul de arriba' : 'Search Google for: "Asuntos Consulares Honduras", click on the first result, or click on the blue button above'}
                                        </li>
                                        <li data-id="element-979">
                                          {isEs ? 'Haz clic en "Acepto términos y condiciones"' : 'Click "I accept terms and conditions"'}
                                        </li>
                                        <li data-id="element-980">
                                          {isEs ? 'Luego selecciona "Registrarse"' : 'Then select "Register"'}
                                        </li>
                                      </ul>
                                    </div>
                                    <div className="bg-blue-50 rounded-lg p-2" data-id="element-981">
                                      <p className="font-semibold text-haa-blue mb-1" data-id="element-982">
                                        {isEs ? 'Paso 2 — Creación de perfil' : 'Step 2 — Create Your Profile'}
                                      </p>
                                      <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-983">
                                        <li data-id="element-984">
                                          {isEs ? 'Haz clic en la bandera de Honduras 🇭🇳' : 'Click on the Honduras flag 🇭🇳'}
                                        </li>
                                        <li data-id="element-985">
                                          {isEs ? 'Llena todos los datos de la persona que realizará el trámite (DNI, correo electrónico, etc.)' : 'Fill in all the information for the person who will be completing the process (DNI, email, etc.)'}
                                        </li>
                                        <li data-id="element-986">
                                          {isEs ? 'Recuerda guardar tu contraseña' : 'Remember to save your password'}
                                        </li>
                                        <li data-id="element-987">
                                          {isEs ? 'Haz clic en "Registrarse"' : 'Click "Register"'}
                                        </li>
                                      </ul>
                                    </div>
                                    <div className="bg-blue-50 rounded-lg p-2" data-id="element-988">
                                      <p className="font-semibold text-haa-blue mb-1" data-id="element-989">
                                        {isEs ? 'Paso 3 — Activación de perfil' : 'Step 3 — Activate Your Profile'}
                                      </p>
                                      <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-990">
                                        <li data-id="element-991">
                                          {isEs ? 'Abre el correo electrónico que registraste' : 'Open the email you registered with'}
                                        </li>
                                        <li data-id="element-992">
                                          {isEs ? 'Recibirás un email de "ACOS"' : 'You will receive an email from "ACOS"'}
                                        </li>
                                        <li data-id="element-993">
                                          {isEs ? 'Haz clic en la frase "Haz click aquí" para activar tu cuenta' : 'Click on "Click here" to activate your account'}
                                        </li>
                                      </ul>
                                    </div>
                                    <div className="bg-blue-50 rounded-lg p-2" data-id="element-994">
                                      <p className="font-semibold text-haa-blue mb-1" data-id="element-995">
                                        {isEs ? 'Paso 4 — Ingresar a tu perfil' : 'Step 4 — Log Into Your Profile'}
                                      </p>
                                      <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-996">
                                        <li data-id="element-997">
                                          {isEs ? 'Vuelve a ingresar a la plataforma' : 'Go back to the platform'}
                                        </li>
                                        <li data-id="element-998">
                                          {isEs ? 'Ingresa tu correo electrónico y haz clic en "Siguiente"' : 'Enter your email and click "Next"'}
                                        </li>
                                        <li data-id="element-999">
                                          {isEs ? 'Ingresa tu contraseña y haz clic en "Ingresar"' : 'Enter your password and click "Log In"'}
                                        </li>
                                        <li data-id="element-1000">
                                          {isEs ? 'Haz clic en "Nueva Cita"' : 'Click "New Appointment"'}
                                        </li>
                                      </ul>
                                    </div>
                                    <div className="bg-blue-50 rounded-lg p-2" data-id="element-1001">
                                      <p className="font-semibold text-haa-blue mb-1" data-id="element-1002">
                                        {isEs ? 'Paso 5 — Creación de cita' : 'Step 5 — Create Your Appointment'}
                                      </p>
                                      <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-1003">
                                        <li data-id="element-1004">
                                          {isEs ? 'Selecciona tu consulado' : 'Select your consulate'}
                                        </li>
                                        <li data-id="element-1005">
                                          {isEs ? 'Elige el servicio que deseas (Pasaporte, Carta poder, etc.)' : 'Choose the service you need (Passport, Power of Attorney, etc.)'}
                                        </li>
                                        <li data-id="element-1006">
                                          {isEs ? 'Haz clic en "Agregar Servicio"' : 'Click "Add Service"'}
                                        </li>
                                        <li data-id="element-1007">
                                          {isEs ? 'Selecciona una fecha disponible' : 'Select an available date'}
                                        </li>
                                        <li data-id="element-1008">
                                          {isEs ? 'Marca los servicios agregados' : 'Check the added services'}
                                        </li>
                                        <li data-id="element-1009">
                                          {isEs ? 'Haz clic en "Pagar" y sigue los pasos indicados' : 'Click "Pay" and follow the indicated steps'}
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </motion.div>}
                          </AnimatePresence>
                        </div>;
            })}
                </div>}
              {tip.links.map((l, i) => l.info === 'appointments' || l.info === 'la-appointments' || l.info === 'fees' || l.info === 'state-offices' ? null : l.info ? <div key={i} className={`rounded-xl border overflow-hidden ${l.info === 'complaint' ? 'border-red-300 shadow-sm' : l.info === 'positive-feedback' ? 'border-emerald-300 shadow-sm' : l.info === 'invite-official' ? 'border-indigo-300 shadow-sm' : l.info === 'detainee-locator' ? 'border-amber-300 shadow-sm' : l.info === 'migrant-protection' ? 'border-purple-300 shadow-sm' : l.info === 'repatriation' ? 'border-gray-500 shadow-sm' : l.info === 'dni-locator' ? 'border-sky-300 shadow-sm' : 'border-gray-200'}`} data-id="element-1010">
                    <div className={`flex items-center justify-between px-3 py-2 ${l.info === 'complaint' ? 'bg-gradient-to-r from-red-500 to-red-700 cursor-pointer' : l.info === 'positive-feedback' ? 'bg-gradient-to-r from-emerald-500 to-emerald-700 cursor-pointer' : l.info === 'invite-official' ? 'bg-gradient-to-r from-indigo-500 to-indigo-700 cursor-pointer' : l.info === 'detainee-locator' ? 'bg-gradient-to-r from-amber-500 to-orange-600 cursor-pointer' : l.info === 'migrant-protection' ? 'bg-gradient-to-r from-purple-400 to-purple-600 cursor-pointer' : l.info === 'repatriation' ? 'bg-gradient-to-r from-gray-700 to-gray-900 cursor-pointer' : l.info === 'dni-locator' ? 'bg-gradient-to-r from-sky-400 to-sky-600 cursor-pointer' : 'bg-gray-50'}`} onClick={l.info === 'complaint' || l.info === 'positive-feedback' || l.info === 'invite-official' || l.info === 'detainee-locator' || l.info === 'migrant-protection' || l.info === 'repatriation' || l.info === 'dni-locator' ? () => setOpenLinkInfo(openLinkInfo === i ? null : i) : undefined} role={l.info === 'complaint' || l.info === 'positive-feedback' || l.info === 'invite-official' || l.info === 'detainee-locator' || l.info === 'migrant-protection' || l.info === 'repatriation' || l.info === 'dni-locator' ? 'button' : undefined} data-id="element-1011">
                      {l.info === 'complaint' ? <span className="inline-flex items-center gap-1.5 font-bold text-xs text-white uppercase tracking-wide" data-id="element-1012">
                          <ClipboardListIcon className="w-3.5 h-3.5" data-id="element-1013" />
                          {isEs && l.labelEs ? l.labelEs : l.label}
                        </span> : l.info === 'positive-feedback' ? <span className="inline-flex items-center gap-1.5 font-bold text-xs text-white uppercase tracking-wide" data-id="element-1014">
                          🌟 {isEs && l.labelEs ? l.labelEs : l.label}
                        </span> : l.info === 'invite-official' ? <span className="inline-flex items-center gap-1.5 font-bold text-xs text-white uppercase tracking-wide" data-id="element-1015">
                          📩 {isEs && l.labelEs ? l.labelEs : l.label}
                        </span> : l.info === 'detainee-locator' ? <span className="inline-flex items-center gap-1.5 font-bold text-xs text-white uppercase tracking-wide" data-id="element-1016">
                          🔍 {isEs && l.labelEs ? l.labelEs : l.label}
                        </span> : l.info === 'migrant-protection' ? <span className="inline-flex items-center gap-1.5 font-bold text-xs text-white uppercase tracking-wide" data-id="element-1017">
                          🛡️ {isEs && l.labelEs ? l.labelEs : l.label}
                        </span> : l.info === 'repatriation' ? <span className="inline-flex items-center gap-1.5 font-bold text-xs text-white uppercase tracking-wide" data-id="element-1018">
                          ✈️ {isEs && l.labelEs ? l.labelEs : l.label}
                        </span> : l.info === 'dni-locator' ? <span className="inline-flex items-center gap-1.5 font-bold text-xs text-white uppercase tracking-wide" data-id="element-1019">
                          🪪 {isEs && l.labelEs ? l.labelEs : l.label}
                        </span> : l.url && l.url !== '#' ? <a href={l.url} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center gap-1 font-semibold text-xs ${tip.accentColor} hover:underline`} data-id="element-1020">
                          {isEs && l.labelEs ? l.labelEs : l.label} →
                        </a> : <span className={`inline-flex items-center gap-1 font-semibold text-xs ${tip.accentColor}`} data-id="element-1021">
                          {isEs && l.labelEs ? l.labelEs : l.label}
                        </span>}
                      <button onClick={() => setOpenLinkInfo(openLinkInfo === i ? null : i)} className={`ml-2 flex items-center gap-1 transition-colors ${l.info === 'complaint' || l.info === 'positive-feedback' || l.info === 'invite-official' || l.info === 'migrant-protection' || l.info === 'repatriation' || l.info === 'detainee-locator' || l.info === 'dni-locator' ? 'text-white/80 hover:text-white' : 'text-gray-400 hover:text-gray-600'}`} aria-label="More info" data-id="element-1022">
                        <span className="text-xs font-medium" data-id="element-1023">
                          {t('consular.info.button')}
                        </span>
                        <motion.div animate={{
                  rotate: openLinkInfo === i ? 180 : 0
                }} transition={{
                  duration: 0.2
                }} data-id="element-1024">
                          <ChevronDownIcon className="w-3.5 h-3.5" data-id="element-1025" />
                        </motion.div>
                      </button>
                    </div>
                    <AnimatePresence initial={false} data-id="element-1026">
                      {openLinkInfo === i && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: [0.16, 1, 0.3, 1]
              }} className="overflow-hidden" data-id="element-1027">
                          <div className="px-3 py-3 bg-white border-t border-gray-100" data-id="element-1028">
                            {l.info === 'fees' ? <div className="space-y-1" data-id="element-1029">
                                <p className="text-xs font-bold text-center py-1.5 px-2 bg-green-100 text-green-700 rounded-lg mb-2" data-id="element-1030">
                                  {isEs ? 'ℹ️ Aranceles vigentes a partir de 2026.' : 'ℹ️ Fees current as of 2026.'}
                                </p>
                                {feeItems.map((item, idx) => <div key={idx} className="border-b border-gray-50 last:border-none" data-id="element-1031">
                                    <div className={`flex items-center justify-between py-1.5 ${item.subContent ? 'cursor-pointer hover:bg-gray-50 rounded-lg px-1 -mx-1 transition-colors' : ''}`} onClick={item.subContent ? () => setOpenFeeSubItem(openFeeSubItem === idx ? null : idx) : undefined} role={item.subContent ? 'button' : undefined} tabIndex={item.subContent ? 0 : undefined} onKeyDown={item.subContent ? e => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          setOpenFeeSubItem(openFeeSubItem === idx ? null : idx);
                        }
                      } : undefined} data-id="element-1032">
                                      <span className="text-xs text-gray-600 pr-2" data-id="element-1033">
                                        {item.service}
                                      </span>
                                      <div className="flex items-center gap-1 flex-shrink-0" data-id="element-1034">
                                        <span className={`text-xs font-bold ${tip.accentColor}`} data-id="element-1035">
                                          {item.price}
                                        </span>
                                        {item.subContent && <motion.div animate={{
                            rotate: openFeeSubItem === idx ? 180 : 0
                          }} transition={{
                            duration: 0.2
                          }} className="ml-1 text-gray-400" data-id="element-1036">
                                            <ChevronDownIcon className="w-3 h-3" data-id="element-1037" />
                                          </motion.div>}
                                      </div>
                                    </div>
                                    {item.subContent && <AnimatePresence initial={false} data-id="element-1038">
                                        {openFeeSubItem === idx && <motion.div initial={{
                          height: 0,
                          opacity: 0
                        }} animate={{
                          height: 'auto',
                          opacity: 1
                        }} exit={{
                          height: 0,
                          opacity: 0
                        }} transition={{
                          duration: 0.25,
                          ease: [0.16, 1, 0.3, 1]
                        }} className="overflow-hidden" data-id="element-1039">
                                            <div className="pb-2 pt-1 pl-1 pr-1 bg-gray-50 rounded-lg mb-1" data-id="element-1040">
                                              {item.subContent}
                                            </div>
                                          </motion.div>}
                                      </AnimatePresence>}
                                  </div>)}
                              </div> : l.info === 'requirements' ? <div className="space-y-3" data-id="element-1041">
                                {(isEs ? [{
                      category: 'Pasaporte',
                      items: ['DNI vigente o acta de nacimiento', 'Formulario de solicitud completado', 'Foto reciente tamaño pasaporte (fondo blanco)', 'Pago de la tarifa correspondiente', 'Pasaporte anterior (si es renovación)']
                    }] : [{
                      category: 'Passport (Pasaporte)',
                      items: ['Valid national ID (DNI) or birth certificate', 'Completed application form', 'Recent passport-size photo (white background)', 'Payment of applicable fee', 'Previous passport (if renewal)']
                    }]).map((section, si) => <div key={si} data-id="element-1042">
                                    <p className="text-xs font-bold text-gray-700 mb-1" data-id="element-1043">
                                      {section.category}
                                    </p>
                                    <ul className="text-xs text-gray-600 leading-relaxed list-disc list-inside space-y-0.5 pl-1" data-id="element-1044">
                                      {section.items.map((item, ii) => <li key={ii} data-id="element-1045">{item}</li>)}
                                    </ul>
                                  </div>)}
                              </div> : l.info === 'state-offices' ? <div className="space-y-2 text-xs" data-id="element-1046">
                                <p className="font-bold text-gray-700 uppercase tracking-wide mb-2" data-id="element-1047">
                                  {isEs ? 'Oficinas de Apostilla por Estado' : 'State Apostille Offices'}
                                </p>
                                {[{
                      state: 'U.S. Department of State Apostille Office',
                      addresses: ['600 19th Street NW, Washington, DC 20006'],
                      phone: '(202) 485-8000'
                    }, {
                      state: 'Arizona',
                      addresses: ['1700 W Washington St, Phoenix, AZ 85007', '400 West Congress Street, Suite 221, Tucson, AZ 85701'],
                      phone: '(602) 542-4285'
                    }, {
                      state: 'Arkansas',
                      addresses: ['1401 W Capitol Ave #250, Little Rock, AR 72201'],
                      phone: '(501) 682-3409'
                    }, {
                      state: 'California',
                      addresses: ['1500 11th Street, 3rd Floor, Sacramento, CA 95814', '300 South Spring Street, Room 12513, Los Angeles, CA 90013'],
                      phones: [{
                        label: 'Sacramento',
                        number: '(916) 653-6814'
                      }, {
                        label: 'Los Angeles',
                        number: '(213) 897-5310'
                      }]
                    }, {
                      state: 'Colorado',
                      addresses: ['1700 Broadway, Suite 550, Denver, CO 80290'],
                      phone: '(303) 894-2200'
                    }, {
                      state: 'Connecticut',
                      addresses: ['165 Capitol Ave #1000, Hartford, CT 06106'],
                      phone: '(860) 509-6002'
                    }, {
                      state: 'Delaware',
                      addresses: ['401 Federal Street - Suite 4, Dover, DE 19901'],
                      phone: '(302) 739-3073'
                    }, {
                      state: 'Florida',
                      addresses: ['2415 N. Monroe Street, Suite 810, Tallahassee, FL 32303'],
                      phone: '(850) 245-6000'
                    }, {
                      state: 'Georgia',
                      addresses: ['1875 Century Boulevard, Suite 100, Atlanta, GA 30345'],
                      phone: '(404) 327-6023'
                    }, {
                      state: 'Illinois',
                      addresses: ['69 W. Washington St., Suite 1240, Chicago, IL 60602', '2701 S. Dirksen Parkway, Springfield, IL 62723'],
                      phones: [{
                        label: 'Chicago',
                        number: '(312) 814-8218'
                      }, {
                        label: 'Springfield',
                        number: '(217) 782-7017'
                      }]
                    }, {
                      state: 'Kansas',
                      addresses: ['915 SW Harrison Street, Topeka, KS 66612'],
                      phone: '(785) 296-4564'
                    }, {
                      state: 'Louisiana',
                      addresses: ['8585 Archives Ave., Baton Rouge, LA 70809'],
                      phone: '(225) 922-0330'
                    }, {
                      state: 'Maryland',
                      addresses: ['Wineland Building, 1st Fl., Annapolis, MD 21401'],
                      phone: '(410) 974-5521'
                    }, {
                      state: 'Massachusetts',
                      addresses: ['One Ashburton Place, Room 1719, Boston, MA 02108'],
                      phone: '(617) 727-2836'
                    }, {
                      state: 'Nevada',
                      addresses: ['101 N Carson Street, Suite 3, Carson City, NV 89701'],
                      phone: '(775) 684-5708'
                    }, {
                      state: 'New Jersey',
                      addresses: ['33 West State Street, 5th Floor, Trenton, NJ 08608-1214'],
                      phone: '(609) 292-9292'
                    }, {
                      state: 'New York',
                      addresses: ['123 William St #2, New York, NY 10038'],
                      phone: '(518) 474-4429'
                    }, {
                      state: 'North Carolina',
                      addresses: ['2 South Salisbury Street, Raleigh, NC 27601'],
                      phone: '(919) 814-5400'
                    }, {
                      state: 'Pennsylvania',
                      addresses: ['210 North Office Building, Harrisburg, PA 17120'],
                      phone: '(717) 787-5280'
                    }, {
                      state: 'Texas',
                      addresses: ['1019 Brazos, Austin, TX 78701'],
                      phone: '(512) 463-5705'
                    }, {
                      state: 'Virginia',
                      addresses: ['1111 East Broad Street, Richmond, VA 23219'],
                      phone: '(804) 692-0114'
                    }, {
                      state: 'Washington D.C.',
                      addresses: ['899 North Capitol Street, NE, Suite 8100'],
                      phone: '(202) 727-3117'
                    }].map((entry, si) => <div key={si} className="border-b border-gray-50 last:border-none pb-1.5 last:pb-0" data-id="element-1048">
                                    <p className={`font-semibold text-emerald-600 mb-0.5`} data-id="element-1049">
                                      {entry.state}
                                    </p>
                                    {entry.addresses.length > 0 ? <ul className="space-y-0.5" data-id="element-1050">
                                        {entry.addresses.map((addr, ai) => <li key={ai} className="flex items-start gap-1 text-gray-500" data-id="element-1051">
                                            <MapPinIcon className="w-3 h-3 text-gray-300 flex-shrink-0 mt-0.5" data-id="element-1052" />
                                            <span data-id="element-1053">{addr}</span>
                                          </li>)}
                                      </ul> : <p className="text-gray-400 italic pl-1" data-id="element-1054">
                                        {isEs ? 'Dirección próximamente' : 'Address coming soon'}
                                      </p>}
                                    {entry.phone && <div className="flex items-center gap-1 text-gray-500 mt-0.5 pl-0" data-id="element-1055">
                                        <PhoneIcon className="w-3 h-3 text-gray-400 flex-shrink-0" data-id="element-1056" />
                                        <a href={`tel:${entry.phone.replace(/[^0-9+]/g, '')}`} className="text-emerald-600 font-semibold hover:underline" data-id="element-1057">
                                          {entry.phone}
                                        </a>
                                      </div>}
                                    {entry.phones && entry.phones.map((p: {
                        label: string;
                        number: string;
                      }, pi: number) => <div key={pi} className="flex items-center gap-1 text-gray-500 mt-0.5 pl-0" data-id="element-1058">
                                            <PhoneIcon className="w-3 h-3 text-gray-400 flex-shrink-0" data-id="element-1059" />
                                            <a href={`tel:${p.number.replace(/[^0-9+]/g, '')}`} className="text-emerald-600 font-semibold hover:underline" data-id="element-1060">
                                              {p.label}: {p.number}
                                            </a>
                                          </div>)}
                                  </div>)}
                              </div> : l.info === 'complaint' ? <div className="space-y-3 text-xs text-gray-600" data-id="element-1061">
                                <p className="font-bold text-red-700 uppercase tracking-wide" data-id="element-1062">
                                  {isEs ? '⚠️ Queja de Servicio Consular' : '⚠️ Consular Service Complaint'}
                                </p>
                                <p className="leading-relaxed" data-id="element-1063">
                                  {isEs ? 'Si tuvo una experiencia negativa con un servicio consular, puede reportarla a la Asociación Hondureño-Americana. Periódicamente compartiremos los comentarios recibidos con el liderazgo consular para su consideración.' : 'If you had a negative experience with a consular service, you can report it to the Honduran-American Association. We will periodically share feedback received with consular leadership for their review.'}
                                </p>

                                {/* File a Complaint Button */}
                                <motion.button onClick={() => setComplaintModalOpen(true)} whileHover={{
                      scale: 1.02
                    }} whileTap={{
                      scale: 0.98
                    }} className="w-full mt-3 py-2.5 px-4 bg-gradient-to-r from-red-500 to-red-700 text-white font-nunito font-bold text-sm rounded-xl shadow-md hover:shadow-lg transition-shadow flex items-center justify-center gap-2" data-id="element-1064">
                                  <ClipboardListIcon className="w-4 h-4" data-id="element-1065" />
                                  {isEs ? 'Presentar una Queja' : 'File a Complaint'}
                                </motion.button>
                              </div> : l.info === 'positive-feedback' ? <div className="space-y-3 text-xs text-gray-600" data-id="element-1066">
                                <p className="font-bold text-emerald-700 uppercase tracking-wide" data-id="element-1067">
                                  {isEs ? '🌟 Experiencia Consular Positiva' : '🌟 Positive Consular Experience'}
                                </p>
                                <p className="leading-relaxed" data-id="element-1068">
                                  {isEs ? '¡Nos encanta escuchar sobre experiencias positivas! Si un funcionario consular le brindó un servicio excepcional, comparta su experiencia para que podamos reconocer su trabajo. Periódicamente compartiremos los comentarios recibidos con el liderazgo consular para su consideración.' : 'We love hearing about positive experiences! If a consular official provided you with exceptional service, share your experience so we can recognize their work. We will periodically share feedback received with consular leadership for their review.'}
                                </p>

                                {/* Share Experience Button */}
                                <motion.button onClick={() => setPositiveFeedbackModalOpen(true)} whileHover={{
                      scale: 1.02
                    }} whileTap={{
                      scale: 0.98
                    }} className="w-full mt-3 py-2.5 px-4 bg-gradient-to-r from-emerald-500 to-emerald-700 text-white font-nunito font-bold text-sm rounded-xl shadow-md hover:shadow-lg transition-shadow flex items-center justify-center gap-2" data-id="element-1069">
                                  🌟
                                  {isEs ? 'Compartir Experiencia Positiva' : 'Share Positive Experience'}
                                </motion.button>
                              </div> : l.info === 'invite-official' ? <div className="space-y-3 text-xs text-gray-600" data-id="element-1070">
                                <p className="font-bold text-indigo-700 uppercase tracking-wide" data-id="element-1071">
                                  {isEs ? '📩 Invitar a un Oficial a un Evento' : '📩 Invite an Official to Event'}
                                </p>
                                <p className="leading-relaxed" data-id="element-1072">
                                  {isEs ? 'Nos encantaría ayudarle a conectar con su oficial consular local o la Embajada para eventos de mayor perfil. Por favor envíe el siguiente formulario y finalice a través de WhatsApp, o contacte directamente a su consulado más cercano.' : 'We would love to help you connect with your local consular official or the Embassy for bigger profile events. Please submit the following form and finalize via WhatsApp, or contact your nearest consulate directly.'}
                                </p>

                                <motion.button onClick={() => setInviteModalOpen(true)} whileHover={{
                      scale: 1.02
                    }} whileTap={{
                      scale: 0.98
                    }} className="w-full mt-3 py-2.5 px-4 bg-gradient-to-r from-indigo-500 to-indigo-700 text-white font-nunito font-bold text-sm rounded-xl shadow-md hover:shadow-lg transition-shadow flex items-center justify-center gap-2" data-id="element-1073">
                                  📩
                                  {isEs ? 'Enviar Solicitud de Invitación' : 'Submit Invitation Request'}
                                </motion.button>
                              </div> : l.info === 'detainee-locator' ? <div className="space-y-3 text-xs text-gray-600" data-id="element-1074">
                                <p className="font-bold text-amber-700 uppercase tracking-wide" data-id="element-1075">
                                  {isEs ? '🔍 Localizador de Detenidos por ICE' : '🔍 ICE Detainee Locator'}
                                </p>
                                <p className="leading-relaxed" data-id="element-1076">
                                  {isEs ? 'Si un familiar o amigo ha sido detenido por el Servicio de Inmigración y Control de Aduanas (ICE), puede usar el Sistema de Localización de Detenidos en Línea para buscar su ubicación y estado de detención. Necesitará el nombre completo y país de nacimiento de la persona, o su número de registro de extranjero (A-Number).' : "If a family member or friend has been detained by U.S. Immigration and Customs Enforcement (ICE), you can use the Online Detainee Locator System to search for their location and detention status. You will need the person's full name and country of birth, or their Alien Registration Number (A-Number)."}
                                </p>
                                <a href="https://locator.ice.gov/odls/#/search" target="_blank" rel="noopener noreferrer" className="w-full mt-1 inline-flex items-center justify-center gap-2 py-2.5 px-4 bg-gradient-to-r from-amber-500 to-orange-600 text-white font-nunito font-bold text-sm rounded-xl shadow-md hover:shadow-lg transition-shadow" data-id="element-1077">
                                  🔍{' '}
                                  {isEs ? 'Buscar a un Detenido' : 'Search for a Detainee'}
                                </a>
                                <div className="bg-blue-50 rounded-lg p-2.5 border border-blue-200 mt-2" data-id="element-1078">
                                  <p className="text-gray-600 leading-relaxed" data-id="element-1079">
                                    {isEs ? '📞 Si no puede comunicarse con su consulado local, envíe un mensaje al +1-703-313-1465 con una explicación de su situación.' : '📞 If you are not able to get in contact with your local consulate, please send a message to +1-703-313-1465 with an explanation of your situation.'}
                                  </p>
                                </div>
                              </div> : l.info === 'migrant-protection' ? <div className="space-y-3 text-xs text-gray-600" data-id="element-1080">
                                <p className="font-bold text-purple-700 uppercase tracking-wide" data-id="element-1081">
                                  {isEs ? '🛡️ Servicio de Protección al Migrante' : '🛡️ Immigrant Protection Services'}
                                </p>
                                <p className="leading-relaxed" data-id="element-1082">
                                  {isEs ? 'Los consulados hondureños ofrecen servicios de protección y asistencia a connacionales en situaciones migratorias. A continuación se detallan los principales servicios disponibles:' : 'Honduran consulates provide protection and assistance services to nationals facing immigration-related situations. Below are the key services available:'}
                                </p>
                                <ul className="space-y-2 pl-1" data-id="element-1083">
                                  <li className="flex items-start gap-2" data-id="element-1084">
                                    <span className="text-purple-500 mt-0.5" data-id="element-1085">
                                      •
                                    </span>
                                    <span data-id="element-1086">
                                      <strong className="text-gray-700" data-id="element-1087">
                                        {isEs ? 'Visitas a centros migratorios' : 'Immigration Detention Center Visits'}
                                      </strong>
                                      <br data-id="element-1088" />
                                      <span className="text-gray-500" data-id="element-1089">
                                        {isEs ? 'Personal consular realiza visitas periódicas a centros de detención migratoria para verificar el bienestar de connacionales detenidos.' : 'Consular staff conduct regular visits to immigration detention facilities to verify the well-being of detained Honduran nationals.'}
                                      </span>
                                    </span>
                                  </li>
                                  <li className="flex items-start gap-2" data-id="element-1090">
                                    <span className="text-purple-500 mt-0.5" data-id="element-1091">
                                      •
                                    </span>
                                    <span data-id="element-1092">
                                      <strong className="text-gray-700" data-id="element-1093">
                                        {isEs ? 'Verificación de detenidos por ICE' : 'ICE Detainee Verification'}
                                      </strong>
                                      <br data-id="element-1094" />
                                      <span className="text-gray-500" data-id="element-1095">
                                        {isEs ? 'Asistencia para localizar y confirmar la situación de connacionales bajo custodia del Servicio de Inmigración y Control de Aduanas (ICE).' : 'Assistance in locating and confirming the status of nationals held in U.S. Immigration and Customs Enforcement (ICE) custody.'}
                                      </span>
                                    </span>
                                  </li>
                                  <li className="flex items-start gap-2" data-id="element-1096">
                                    <span className="text-purple-500 mt-0.5" data-id="element-1097">
                                      •
                                    </span>
                                    <span data-id="element-1098">
                                      <strong className="text-gray-700" data-id="element-1099">
                                        {isEs ? 'Reunificaciones familiares' : 'Family Reunification'}
                                      </strong>
                                      <br data-id="element-1100" />
                                      <span className="text-gray-500" data-id="element-1101">
                                        {isEs ? 'Apoyo en la coordinación y gestión de procesos de reunificación familiar para connacionales separados durante procedimientos migratorios.' : 'Support in coordinating and managing family reunification processes for nationals separated during immigration proceedings.'}
                                      </span>
                                    </span>
                                  </li>
                                  <li className="flex items-start gap-2" data-id="element-1102">
                                    <span className="text-purple-500 mt-0.5" data-id="element-1103">
                                      •
                                    </span>
                                    <span data-id="element-1104">
                                      <strong className="text-gray-700" data-id="element-1105">
                                        {isEs ? 'Representación de menores en audiencias' : 'Legal Representation for Minors in Hearings'}
                                      </strong>
                                      <br data-id="element-1106" />
                                      <span className="text-gray-500" data-id="element-1107">
                                        {isEs ? 'Gestión de representación consular para menores no acompañados que enfrentan audiencias migratorias.' : 'Consular representation for unaccompanied minors facing immigration court hearings.'}
                                      </span>
                                    </span>
                                  </li>
                                  <li className="flex items-start gap-2" data-id="element-1108">
                                    <span className="text-purple-500 mt-0.5" data-id="element-1109">
                                      •
                                    </span>
                                    <span data-id="element-1110">
                                      <strong className="text-gray-700" data-id="element-1111">
                                        {isEs ? 'Apoyo a connacionales enfermos' : 'Assistance for Ill Nationals'}
                                      </strong>
                                      <br data-id="element-1112" />
                                      <span className="text-gray-500" data-id="element-1113">
                                        {isEs ? 'Asistencia y acompañamiento a connacionales hospitalizados o que enfrentan emergencias médicas en Estados Unidos.' : 'Assistance and support for Honduran nationals who are hospitalized or facing medical emergencies in the United States.'}
                                      </span>
                                    </span>
                                  </li>
                                </ul>
                                <div className="bg-purple-50 rounded-lg p-2.5 border border-purple-200 mt-2" data-id="element-1114">
                                  <p className="font-semibold text-purple-700 mb-1" data-id="element-1115">
                                    {isEs ? '⚠️ Importante' : '⚠️ Important'}
                                  </p>
                                  <p className="text-gray-600 leading-relaxed" data-id="element-1116">
                                    {isEs ? 'Los consulados no tienen autoridad para intervenir en procedimientos legales migratorios ni en decisiones de las cortes de inmigración. Los servicios de protección se limitan a asistencia consular, verificación de bienestar y apoyo humanitario.' : 'Consulates do not have the authority to intervene in immigration legal proceedings or immigration court decisions. Protection services are limited to consular assistance, welfare verification, and humanitarian support.'}
                                  </p>
                                </div>
                                <div className="bg-blue-50 rounded-lg p-2.5 border border-blue-200 mt-2" data-id="element-1117">
                                  <p className="text-gray-600 leading-relaxed" data-id="element-1118">
                                    {isEs ? '📞 Si no puede comunicarse con su consulado local, envíe un mensaje al +1-703-313-1465 con una explicación de su situación.' : '📞 If you are not able to get in contact with your local consulate, please send a message to +1-703-313-1465 with an explanation of your situation.'}
                                  </p>
                                </div>
                              </div> : l.info === 'repatriation' ? <div className="space-y-3 text-xs text-gray-600" data-id="element-1119">
                                <p className="font-bold text-gray-800 uppercase tracking-wide" data-id="element-1120">
                                  {isEs ? '✈️ Servicios de Repatriación' : '✈️ Repatriation Services'}
                                </p>
                                <p className="leading-relaxed" data-id="element-1121">
                                  {'In the event of a Honduran national passing away in the United States, Honduran consulates may assist with the repatriation of remains to Honduras for families experiencing dire financial hardship and who are in urgent need of support. This service may cover the following:'}
                                </p>
                                <div className="bg-gray-100 rounded-lg p-3 border border-gray-300" data-id="element-1122">
                                  <p className="font-semibold text-gray-800 mb-2 text-xs uppercase tracking-wide" data-id="element-1123">
                                    {isEs ? 'Cobertura del Servicio' : 'Service Coverage'}
                                  </p>
                                  <ul className="space-y-1.5" data-id="element-1124">
                                    <li className="flex items-start gap-2" data-id="element-1125">
                                      <span className="text-gray-600 mt-0.5" data-id="element-1126">
                                        •
                                      </span>
                                      <span data-id="element-1127">
                                        <strong className="text-gray-700" data-id="element-1128">
                                          {isEs ? 'Preparación del cuerpo' : 'Body Preparation'}
                                        </strong>
                                        <br data-id="element-1129" />
                                        <span className="text-gray-500" data-id="element-1130">
                                          {isEs ? 'Coordinación de los servicios funerarios necesarios para la preparación y preservación de los restos.' : 'Coordination of funeral services required for the preparation and preservation of remains.'}
                                        </span>
                                      </span>
                                    </li>
                                    <li className="flex items-start gap-2" data-id="element-1131">
                                      <span className="text-gray-600 mt-0.5" data-id="element-1132">
                                        •
                                      </span>
                                      <span data-id="element-1133">
                                        <strong className="text-gray-700" data-id="element-1134">
                                          {isEs ? 'Retiro del cuerpo de la morgue' : 'Removal of Remains from the Morgue'}
                                        </strong>
                                        <br data-id="element-1135" />
                                        <span className="text-gray-500" data-id="element-1136">
                                          {isEs ? 'Gestión y coordinación del retiro de los restos de la morgue o institución correspondiente.' : 'Management and coordination of the removal of remains from the morgue or corresponding institution.'}
                                        </span>
                                      </span>
                                    </li>
                                    <li className="flex items-start gap-2" data-id="element-1137">
                                      <span className="text-gray-600 mt-0.5" data-id="element-1138">
                                        •
                                      </span>
                                      <span data-id="element-1139">
                                        <strong className="text-gray-700" data-id="element-1140">
                                          {isEs ? 'Tramitación de documentos' : 'Document Processing'}
                                        </strong>
                                        <br data-id="element-1141" />
                                        <span className="text-gray-500" data-id="element-1142">
                                          {isEs ? 'Procesamiento de toda la documentación legal y consular requerida para la repatriación, incluyendo certificados de defunción y permisos de traslado.' : 'Processing of all legal and consular documentation required for repatriation, including death certificates and transfer permits.'}
                                        </span>
                                      </span>
                                    </li>
                                    <li className="flex items-start gap-2" data-id="element-1143">
                                      <span className="text-gray-600 mt-0.5" data-id="element-1144">
                                        •
                                      </span>
                                      <span data-id="element-1145">
                                        <strong className="text-gray-700" data-id="element-1146">
                                          {isEs ? 'Envío del cuerpo a Honduras' : 'Shipment of Remains to Honduras'}
                                        </strong>
                                        <br data-id="element-1147" />
                                        <span className="text-gray-500" data-id="element-1148">
                                          {isEs ? 'Coordinación del traslado aéreo de los restos mortales hasta Honduras para su entrega a los familiares.' : 'Coordination of the air transport of remains to Honduras for delivery to family members.'}
                                        </span>
                                      </span>
                                    </li>
                                  </ul>
                                </div>
                                <div className="bg-amber-50 rounded-lg p-2.5 border border-amber-200 mt-1" data-id="element-1149">
                                  <p className="font-semibold text-amber-700 mb-1" data-id="element-1150">
                                    {isEs ? 'ℹ️ Nota' : 'ℹ️ Note'}
                                  </p>
                                  <p className="text-gray-600 leading-relaxed" data-id="element-1151">
                                    {isEs ? 'El servicio de repatriación cubre únicamente los aspectos mencionados anteriormente. Para más información o para iniciar el proceso, comuníquese directamente con el consulado más cercano.' : 'The repatriation service covers only the aspects listed above. For more information or to initiate the process, please contact your nearest consulate directly.'}
                                  </p>
                                </div>
                                <div className="bg-blue-50 rounded-lg p-2.5 border border-blue-200 mt-2" data-id="element-1152">
                                  <p className="text-gray-600 leading-relaxed" data-id="element-1153">
                                    {isEs ? '📞 Si no puede comunicarse con su consulado local, envíe un mensaje al +1-703-313-1465 con una explicación de su situación.' : '📞 If you are not able to get in contact with your local consulate, please send a message to +1-703-313-1465 with an explanation of your situation.'}
                                  </p>
                                </div>
                              </div> : l.info === 'dni-locator' ? <div className="space-y-3 text-xs text-gray-600" data-id="element-1154">
                                <p className="font-bold text-sky-700 uppercase tracking-wide" data-id="element-1155">
                                  {isEs ? '🪪 Búsqueda de Entrega de DNI' : '🪪 DNI Locator Search'}
                                </p>
                                <p className="leading-relaxed" data-id="element-1156">
                                  {isEs ? 'Utilice esta herramienta del Registro Nacional de las Personas (RNP) para verificar el estado de entrega de su Documento Nacional de Identidad (DNI) y localizar dónde recogerlo.' : 'Use this tool from the National Registry of Persons (RNP) to check the delivery status of your National Identification Card (DNI) and locate where to pick it up.'}
                                </p>
                                <a href="https://entregadni.rnp.hn/dni/#/" target="_blank" rel="noopener noreferrer" className="w-full inline-flex items-center justify-center gap-2 py-2.5 px-4 bg-gradient-to-r from-sky-500 to-sky-600 text-white font-nunito font-bold text-sm rounded-xl shadow-md hover:shadow-lg transition-shadow" data-id="element-1157">
                                  🪪{' '}
                                  {isEs ? 'Buscar Estado de DNI' : 'Search DNI Status'}
                                </a>
                              </div> : l.info === 'la-appointments' ? <div className="space-y-3 text-xs text-gray-600" data-id="element-1158">
                                <p className="font-bold text-haa-blue" data-id="element-1159">
                                  {isEs ? '¿Deseas realizar una cita en el Consulado General de Honduras en Los Ángeles? Te explicamos paso a paso.' : "Want to make an appointment at the Consulate General of Honduras in Los Angeles? Here's a step-by-step guide."}
                                </p>
                                <a href="https://asuntosconsulares.inm.gob.hn/#openModal" target="_blank" rel="noopener noreferrer" className="w-full inline-flex items-center justify-center gap-2 py-2.5 px-4 bg-gradient-to-r from-haa-blue to-haa-midblue text-white font-nunito font-bold text-sm rounded-xl shadow-md hover:shadow-lg transition-shadow" data-id="element-1160">
                                  📅 ACOS Appointment Platform{' '}
                                  <span className="text-xs font-normal opacity-80" data-id="element-1161">
                                    (Click Here)
                                  </span>
                                </a>
                                <div className="space-y-2.5" data-id="element-1162">
                                  <div className="bg-blue-50 rounded-lg p-2" data-id="element-1163">
                                    <p className="font-semibold text-haa-blue mb-1" data-id="element-1164">
                                      {isEs ? 'Paso 1 — Acceso a la plataforma' : 'Step 1 — Access the Platform'}
                                    </p>
                                    <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-1165">
                                      <li data-id="element-1166">
                                        {isEs ? 'Busca en Google: "Asuntos Consulares Honduras", haz clic en el primer resultado, o haz clic en el botón azul de arriba' : 'Search Google for: "Asuntos Consulares Honduras", click on the first result, or click on the blue button above'}
                                      </li>
                                      <li data-id="element-1167">
                                        {isEs ? 'Haz clic en "Acepto términos y condiciones"' : 'Click "I accept terms and conditions"'}
                                      </li>
                                      <li data-id="element-1168">
                                        {isEs ? 'Luego selecciona "Registrarse"' : 'Then select "Register"'}
                                      </li>
                                    </ul>
                                  </div>
                                  <div className="bg-blue-50 rounded-lg p-2" data-id="element-1169">
                                    <p className="font-semibold text-haa-blue mb-1" data-id="element-1170">
                                      {isEs ? 'Paso 2 — Creación de perfil' : 'Step 2 — Create Your Profile'}
                                    </p>
                                    <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-1171">
                                      <li data-id="element-1172">
                                        {isEs ? 'Haz clic en la bandera de Honduras 🇭🇳' : 'Click on the Honduras flag 🇭🇳'}
                                      </li>
                                      <li data-id="element-1173">
                                        {isEs ? 'Llena todos los datos de la persona que realizará el trámite (DNI, correo electrónico, etc.)' : 'Fill in all the information for the person who will be completing the process (DNI, email, etc.)'}
                                      </li>
                                      <li data-id="element-1174">
                                        {isEs ? 'Recuerda guardar tu contraseña' : 'Remember to save your password'}
                                      </li>
                                      <li data-id="element-1175">
                                        {isEs ? 'Haz clic en "Registrarse"' : 'Click "Register"'}
                                      </li>
                                    </ul>
                                  </div>
                                  <div className="bg-blue-50 rounded-lg p-2" data-id="element-1176">
                                    <p className="font-semibold text-haa-blue mb-1" data-id="element-1177">
                                      {isEs ? 'Paso 3 — Activación de perfil' : 'Step 3 — Activate Your Profile'}
                                    </p>
                                    <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-1178">
                                      <li data-id="element-1179">
                                        {isEs ? 'Abre el correo electrónico que registraste' : 'Open the email you registered with'}
                                      </li>
                                      <li data-id="element-1180">
                                        {isEs ? 'Recibirás un email de "ACOS"' : 'You will receive an email from "ACOS"'}
                                      </li>
                                      <li data-id="element-1181">
                                        {isEs ? 'Haz clic en la frase "Haz click aquí" para activar tu cuenta' : 'Click on "Click here" to activate your account'}
                                      </li>
                                    </ul>
                                  </div>
                                  <div className="bg-blue-50 rounded-lg p-2" data-id="element-1182">
                                    <p className="font-semibold text-haa-blue mb-1" data-id="element-1183">
                                      {isEs ? 'Paso 4 — Ingresar a tu perfil' : 'Step 4 — Log Into Your Profile'}
                                    </p>
                                    <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-1184">
                                      <li data-id="element-1185">
                                        {isEs ? 'Vuelve a ingresar a la plataforma' : 'Go back to the platform'}
                                      </li>
                                      <li data-id="element-1186">
                                        {isEs ? 'Ingresa tu correo electrónico y haz clic en "Siguiente"' : 'Enter your email and click "Next"'}
                                      </li>
                                      <li data-id="element-1187">
                                        {isEs ? 'Ingresa tu contraseña y haz clic en "Ingresar"' : 'Enter your password and click "Log In"'}
                                      </li>
                                      <li data-id="element-1188">
                                        {isEs ? 'Haz clic en "Nueva Cita"' : 'Click "New Appointment"'}
                                      </li>
                                    </ul>
                                  </div>
                                  <div className="bg-blue-50 rounded-lg p-2" data-id="element-1189">
                                    <p className="font-semibold text-haa-blue mb-1" data-id="element-1190">
                                      {isEs ? 'Paso 5 — Creación de cita' : 'Step 5 — Create Your Appointment'}
                                    </p>
                                    <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-1191">
                                      <li data-id="element-1192">
                                        {isEs ? 'Selecciona el Consulado de Los Ángeles' : 'Select the Los Angeles Consulate'}
                                      </li>
                                      <li data-id="element-1193">
                                        {isEs ? 'Elige el servicio que deseas (Pasaporte, Carta poder, etc.)' : 'Choose the service you need (Passport, Power of Attorney, etc.)'}
                                      </li>
                                      <li data-id="element-1194">
                                        {isEs ? 'Haz clic en "Agregar Servicio"' : 'Click "Add Service"'}
                                      </li>
                                      <li data-id="element-1195">
                                        {isEs ? 'Selecciona una fecha disponible' : 'Select an available date'}
                                      </li>
                                      <li data-id="element-1196">
                                        {isEs ? 'Marca los servicios agregados' : 'Check the added services'}
                                      </li>
                                      <li data-id="element-1197">
                                        {isEs ? 'Haz clic en "Pagar" y sigue los pasos indicados' : 'Click "Pay" and follow the indicated steps'}
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div> : <div className="space-y-3 text-xs text-gray-600" data-id="element-1198">
                                <ul className="text-xs text-gray-500 leading-relaxed list-disc list-inside space-y-0.5 pl-1" data-id="element-1199">
                                  <li data-id="element-1200">{t('consular.appt.bullet1')}</li>
                                  <li data-id="element-1201">{t('consular.appt.bullet2')}</li>
                                  <li data-id="element-1202">{t('consular.appt.bullet3')}</li>
                                  <li data-id="element-1203">{t('consular.appt.bullet4')}</li>
                                </ul>
                                <a href="https://citaconsular.sreci.gob.hn/citaconsular/pages/layout/CitaConsular.php" target="_blank" rel="noopener noreferrer" className="w-full inline-flex items-center justify-center gap-2 py-2.5 px-4 bg-gradient-to-r from-emerald-500 to-haa-skyblue text-white font-nunito font-bold text-sm rounded-xl shadow-md hover:shadow-lg transition-shadow" data-id="element-1204">
                                  📅{' '}
                                  {isEs ? 'Hacer una Cita' : 'Make an Appointment'}
                                </a>
                                <p className="text-xs text-gray-400 italic mt-1" data-id="element-1205">
                                  *
                                  {isEs ? 'Excepto el Consulado de Los Ángeles — ver guía abajo' : 'Except Los Angeles Consulate — see guide below'}
                                </p>
                                <div className="space-y-2.5" data-id="element-1206">
                                  <div className="bg-blue-50 rounded-lg p-2" data-id="element-1207">
                                    <p className="font-semibold text-haa-blue mb-1" data-id="element-1208">
                                      {isEs ? 'Paso 1 — Buscar su identidad' : 'Step 1 — Search Your Identity'}
                                    </p>
                                    <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-1209">
                                      <li data-id="element-1210">
                                        {isEs ? 'Ingrese su Número de Identidad Nacional' : 'Enter your National Identification Number'}
                                      </li>
                                      <li data-id="element-1211">
                                        {isEs ? 'Haga clic en "Buscar"' : 'Click "Search"'}
                                      </li>
                                    </ul>
                                  </div>
                                  <div className="bg-blue-50 rounded-lg p-2" data-id="element-1212">
                                    <p className="font-semibold text-haa-blue mb-1" data-id="element-1213">
                                      {isEs ? 'Paso 2 — Seleccionar consulado y servicio' : 'Step 2 — Select Consulate & Service'}
                                    </p>
                                    <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-1214">
                                      <li data-id="element-1215">
                                        {isEs ? 'En Ubicación, seleccione "Estados Unidos"' : 'Under Location, select "United States"'}
                                      </li>
                                      <li data-id="element-1216">
                                        {isEs ? 'En Seleccionar Consulado, elija el consulado donde desea completar su servicio' : 'Under Select Consulate, choose the consulate where you want to complete your service'}
                                      </li>
                                      <li data-id="element-1217">
                                        {isEs ? 'En Tipo de Servicio, seleccione el servicio que desea' : 'Under Type of Service, select the service you want'}
                                      </li>
                                    </ul>
                                  </div>
                                  <div className="bg-blue-50 rounded-lg p-2" data-id="element-1218">
                                    <p className="font-semibold text-haa-blue mb-1" data-id="element-1219">
                                      {isEs ? 'Paso 3 — Información personal' : 'Step 3 — Personal Information'}
                                    </p>
                                    <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-1220">
                                      <li data-id="element-1221">
                                        {isEs ? 'Ingrese su ciudad, código postal, correo electrónico, número de teléfono y dirección' : 'Enter your city, ZIP code, email address, phone number, and address'}
                                      </li>
                                      <li data-id="element-1222">
                                        {isEs ? 'Haga clic en "Seleccionar"' : 'Click "Select"'}
                                      </li>
                                    </ul>
                                  </div>
                                  <div className="bg-blue-50 rounded-lg p-2" data-id="element-1223">
                                    <p className="font-semibold text-haa-blue mb-1" data-id="element-1224">
                                      {isEs ? 'Paso 4 — Seleccionar una fecha' : 'Step 4 — Select a Date'}
                                    </p>
                                    <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-1225">
                                      <li data-id="element-1226">
                                        {isEs ? 'Se abrirá la página del calendario' : 'The calendar page will open'}
                                      </li>
                                      <li data-id="element-1227">
                                        {isEs ? 'Seleccione un día disponible en el calendario:' : 'Select an available day on the calendar:'}
                                        <ul className="list-disc list-inside pl-3 mt-0.5 space-y-0.5 text-gray-500" data-id="element-1228">
                                          <li data-id="element-1229">
                                            {isEs ? 'Días en blanco = disponibles' : 'Days in white = available'}
                                          </li>
                                          <li data-id="element-1230">
                                            {isEs ? 'Días en morado = sin citas disponibles' : 'Days in purple = no appointments available'}
                                          </li>
                                          <li data-id="element-1231">
                                            {isEs ? 'Días en rojo = el consulado no ofrece servicios' : 'Days in red = consulate does not offer services'}
                                          </li>
                                        </ul>
                                      </li>
                                    </ul>
                                  </div>
                                  <div className="bg-blue-50 rounded-lg p-2" data-id="element-1232">
                                    <p className="font-semibold text-haa-blue mb-1" data-id="element-1233">
                                      {isEs ? 'Paso 5 — Confirmar su cita' : 'Step 5 — Confirm Your Appointment'}
                                    </p>
                                    <ul className="list-disc list-inside pl-1 space-y-0.5 text-gray-600" data-id="element-1234">
                                      <li data-id="element-1235">
                                        {isEs ? 'Una vez que seleccione un día, aparecerán todos los detalles de su cita' : 'Once you select a day, all of your appointment details will appear'}
                                      </li>
                                      <li data-id="element-1236">
                                        {isEs ? 'Desplácese hacia abajo y haga clic en "Ver Requisitos"' : 'Scroll down and click "View Requirements"'}
                                      </li>
                                      <li data-id="element-1237">
                                        {isEs ? 'Luego desplácese hacia abajo nuevamente y haga clic en "Programar Cita"' : 'Then scroll down again and click "Schedule Appointment"'}
                                      </li>
                                      <li data-id="element-1238">
                                        {isEs ? 'Aparecerá la confirmación de su cita' : 'Your appointment confirmation will appear'}
                                      </li>
                                      <li data-id="element-1239">
                                        {isEs ? 'Tome una captura de pantalla de la confirmación como prueba de su cita' : 'Take a screenshot of the confirmation to keep as proof of your appointment'}
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>}
                          </div>
                        </motion.div>}
                    </AnimatePresence>
                  </div> : <a key={i} href={l.url} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center gap-1 font-semibold text-xs ${tip.accentColor} hover:underline`} data-id="element-1240">
                    {isEs && l.labelEs ? l.labelEs : l.label} →
                  </a>)}
            </div>}

          {tip.consulates && tip.consulates.length > 0 && <div className="mt-3" data-id="element-1241">
              <div className="rounded-xl overflow-hidden border border-gray-200 shadow-sm cursor-pointer group relative" onClick={() => setMapModalOpen(true)} role="button" tabIndex={0} onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') setMapModalOpen(true);
          }} aria-label={isEs ? 'Ampliar mapa' : 'Expand map'} data-id="element-1242">
                <ConsulateMap consulates={tip.consulates} accentColor={tip.accentColor} data-id="element-1243" />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-200 flex items-center justify-center pointer-events-none" data-id="element-1244">
                  <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 bg-white/90 backdrop-blur-sm text-gray-700 font-nunito font-semibold text-xs px-4 py-2 rounded-full shadow-lg" data-id="element-1245">
                    {isEs ? '🗺️ Ampliar Mapa' : '🗺️ Expand Map'}
                  </span>
                </div>
              </div>
            </div>}

          {/* Map Modal */}
          <AnimatePresence data-id="element-1246">
            {mapModalOpen && tip.consulates && <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 0.2
          }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setMapModalOpen(false)} data-id="element-1247">
                <motion.div initial={{
              opacity: 0,
              scale: 0.95,
              y: 20
            }} animate={{
              opacity: 1,
              scale: 1,
              y: 0
            }} exit={{
              opacity: 0,
              scale: 0.95,
              y: 20
            }} transition={{
              duration: 0.3,
              ease: [0.16, 1, 0.3, 1]
            }} className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-1248">
                  {/* Header */}
                  <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100" data-id="element-1249">
                    <div className="flex items-center gap-3" data-id="element-1250">
                      <div className={`w-10 h-10 rounded-xl bg-gradient-to-br ${tip.gradient} flex items-center justify-center shadow-sm`} data-id="element-1251">
                        <MapIcon className="w-5 h-5 text-white" data-id="element-1252" />
                      </div>
                      <h2 className="font-bebas text-2xl sm:text-3xl text-haa-navy tracking-wider" data-id="element-1253">
                        {isEs ? 'Consulados en EE.UU.' : 'Consulates in the USA'}
                      </h2>
                    </div>
                    <button onClick={() => setMapModalOpen(false)} className="p-2 rounded-lg hover:bg-gray-100 transition-colors text-gray-400 hover:text-gray-600" aria-label="Close" data-id="element-1254">
                      <XIcon className="w-5 h-5" data-id="element-1255" />
                    </button>
                  </div>

                  {/* Map */}
                  <div className="flex-1 min-h-0" data-id="element-1256">
                    <ConsulateMap consulates={tip.consulates} accentColor={tip.accentColor} expanded={true} data-id="element-1257" />
                  </div>

                  {/* Footer */}
                  <div className="px-6 py-3 border-t border-gray-100 bg-gray-50/50 flex items-center justify-between" data-id="element-1258">
                    <p className="font-nunito text-gray-400 text-xs" data-id="element-1259">
                      {isEs ? 'Haga clic en los marcadores para ver detalles' : 'Click markers for details'}
                    </p>
                    <button onClick={() => setMapModalOpen(false)} className="py-2 px-6 bg-haa-navy hover:bg-haa-blue text-white font-nunito font-bold text-sm rounded-xl transition-colors" data-id="element-1260">
                      {isEs ? 'Cerrar' : 'Close'}
                    </button>
                  </div>
                </motion.div>
              </motion.div>}
          </AnimatePresence>
          {/* Grouped dropdowns for conulates */}
          {tip.consulates && tip.consulates.length > 0 && <div className="mt-3 flex flex-col gap-2" data-id="element-1261">
              {/* Embassy of Honduras — standalone dropdown */}
              {tip.consulates.filter(c => c.isEmbassy).map((consulate, i) => <div key={`embassy-${i}`} className="rounded-xl border border-gray-200 overflow-hidden" data-id="element-1262">
                    <button onClick={() => setOpenConsulate(openConsulate === i ? null : i)} className="w-full flex items-center justify-between px-4 py-3 bg-gray-50 hover:bg-gray-100 transition-colors text-left" data-id="element-1263">
                      <span className={`font-semibold text-xs ${tip.accentColor} uppercase tracking-wide`} data-id="element-1264">
                        {isEs && consulate.nameEs ? consulate.nameEs : consulate.name}
                      </span>
                      <motion.div animate={{
                rotate: openConsulate === i ? 180 : 0
              }} transition={{
                duration: 0.2
              }} data-id="element-1265">
                        <ChevronDownIcon className={`w-4 h-4 ${tip.accentColor}`} data-id="element-1266" />
                      </motion.div>
                    </button>
                    <AnimatePresence initial={false} data-id="element-1267">
                      {openConsulate === i && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: [0.16, 1, 0.3, 1]
              }} className="overflow-hidden" data-id="element-1268">
                          <div className="px-4 py-3 flex flex-col gap-2 bg-white border-t border-gray-100" data-id="element-1269">
                            <img src="https://cdn.magicpatterns.com/uploads/r1SebeZn3BYVUu85sQTJgV/rflores_Ambassador.jpg" alt="Ambassador Roberto Flores Bermúdez" className="w-full rounded-lg object-cover object-top mb-1" data-id="element-1270" />
                            <div className="flex items-start gap-2" data-id="element-1271">
                              <MapPinIcon className="w-3.5 h-3.5 text-gray-400 flex-shrink-0 mt-0.5" data-id="element-1272" />
                              <span className="text-xs text-gray-600" data-id="element-1273">
                                {consulate.address}
                              </span>
                            </div>
                            <div className="flex items-center gap-2" data-id="element-1274">
                              <PhoneIcon className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" data-id="element-1275" />
                              <a href={`tel:${consulate.phone.replace(/-/g, '')}`} className={`text-xs font-semibold ${tip.accentColor} hover:underline`} data-id="element-1276">
                                {consulate.phone}
                              </a>
                            </div>
                            {consulate.email && <div className="flex items-center gap-2" data-id="element-1277">
                                <MailIcon className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" data-id="element-1278" />
                                <a href={`mailto:${consulate.email}`} className={`text-xs font-semibold ${tip.accentColor} hover:underline`} data-id="element-1279">
                                  {consulate.email}
                                </a>
                              </div>}
                            <div className="flex items-center gap-2" data-id="element-1280">
                              <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 text-gray-400 flex-shrink-0 fill-current" aria-hidden="true" data-id="element-1281">
                                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" data-id="element-1282" />
                              </svg>
                              <a href="https://x.com/EmbHondurasUSA" target="_blank" rel="noopener noreferrer" className={`text-xs font-semibold ${tip.accentColor} hover:underline`} data-id="element-1283">
                                @EmbHondurasUSA
                              </a>
                            </div>
                            <div className="flex items-center gap-2" data-id="element-1284">
                              <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 text-gray-400 flex-shrink-0 fill-current" aria-hidden="true" data-id="element-1285">
                                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-1286" />
                              </svg>
                              <a href="https://www.facebook.com/EmbHondurasUSA/" target="_blank" rel="noopener noreferrer" className={`text-xs font-semibold ${tip.accentColor} hover:underline`} data-id="element-1287">
                                EmbHondurasUSA
                              </a>
                            </div>
                          </div>
                        </motion.div>}
                    </AnimatePresence>
                  </div>)}
              {/* Consulate Locations — grouped dropdown */}
              <div className="rounded-xl border border-gray-200 overflow-hidden" data-id="element-1288">
                <button onClick={() => {
              setConsulateLocationsOpen(!consulateLocationsOpen);
              setOpenNestedConsulate(null);
            }} className="w-full flex items-center justify-between px-4 py-3 bg-gray-50 hover:bg-gray-100 transition-colors text-left" data-id="element-1289">
                  <span className={`font-semibold text-xs ${tip.accentColor} uppercase tracking-wide`} data-id="element-1290">
                    {isEs ? 'Ubicaciones de Consulados' : 'Consulate Locations'}
                  </span>
                  <motion.div animate={{
                rotate: consulateLocationsOpen ? 180 : 0
              }} transition={{
                duration: 0.2
              }} data-id="element-1291">
                    <ChevronDownIcon className={`w-4 h-4 ${tip.accentColor}`} data-id="element-1292" />
                  </motion.div>
                </button>
                <AnimatePresence initial={false} data-id="element-1293">
                  {consulateLocationsOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: [0.16, 1, 0.3, 1]
              }} className="overflow-hidden" data-id="element-1294">
                      <div className="bg-white border-t border-gray-100 flex flex-col gap-1 p-2" data-id="element-1295">
                        <p className="text-xs font-bold text-center py-1.5 px-2 bg-green-100 text-green-700 rounded-lg" data-id="element-1296">
                          {isEs ? 'ℹ️ Información de contacto vigente a partir de 2026.' : 'ℹ️ Contact info current as of 2026.'}
                        </p>
                        {tip.consulates.filter(c => !c.isEmbassy).map((consulate, ni) => <div key={`nested-${ni}`} className="rounded-lg border border-gray-100 overflow-hidden" data-id="element-1297">
                              <button onClick={() => setOpenNestedConsulate(openNestedConsulate === ni ? null : ni)} className="w-full flex items-center justify-between px-3 py-2 bg-gray-50 hover:bg-gray-100 transition-colors text-left" data-id="element-1298">
                                <span className={`font-semibold text-xs ${tip.accentColor}`} data-id="element-1299">
                                  {isEs && consulate.nameEs ? consulate.nameEs : consulate.name}
                                </span>
                                <motion.div animate={{
                        rotate: openNestedConsulate === ni ? 180 : 0
                      }} transition={{
                        duration: 0.2
                      }} data-id="element-1300">
                                  <ChevronDownIcon className={`w-3.5 h-3.5 ${tip.accentColor}`} data-id="element-1301" />
                                </motion.div>
                              </button>
                              <AnimatePresence initial={false} data-id="element-1302">
                                {openNestedConsulate === ni && <motion.div initial={{
                        height: 0,
                        opacity: 0
                      }} animate={{
                        height: 'auto',
                        opacity: 1
                      }} exit={{
                        height: 0,
                        opacity: 0
                      }} transition={{
                        duration: 0.2,
                        ease: [0.16, 1, 0.3, 1]
                      }} className="overflow-hidden" data-id="element-1303">
                                    <div className="px-3 py-2 flex flex-col gap-1.5 bg-white border-t border-gray-100" data-id="element-1304">
                                      <div className="flex items-start gap-2" data-id="element-1305">
                                        <MapPinIcon className="w-3 h-3 text-gray-400 flex-shrink-0 mt-0.5" data-id="element-1306" />
                                        <span className="text-xs text-gray-600" data-id="element-1307">
                                          {consulate.address}
                                        </span>
                                      </div>
                                      <div className="flex items-center gap-2" data-id="element-1308">
                                        <PhoneIcon className="w-3 h-3 text-gray-400 flex-shrink-0" data-id="element-1309" />
                                        <a href={`tel:${consulate.phone.replace(/-/g, '')}`} className={`text-xs font-semibold ${tip.accentColor} hover:underline`} data-id="element-1310">
                                          {consulate.phone}
                                        </a>
                                      </div>
                                      {consulate.facebook && <div className="flex items-center gap-2" data-id="element-1311">
                                          <svg viewBox="0 0 24 24" className="w-3 h-3 text-gray-400 flex-shrink-0 fill-current" aria-hidden="true" data-id="element-1312">
                                            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-1313" />
                                          </svg>
                                          <a href={consulate.facebook} target="_blank" rel="noopener noreferrer" className={`text-xs font-semibold ${tip.accentColor} hover:underline`} data-id="element-1314">
                                            Facebook
                                          </a>
                                        </div>}
                                    </div>
                                  </motion.div>}
                              </AnimatePresence>
                            </div>)}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </div>}
          {/* State Apostille Offices — rendered after consulate locations */}
          {tip.links && tip.links.filter(l => l.info === 'state-offices').map((l, _idx) => {
          const stateOfficeIndex = tip.links!.findIndex(link => link.info === 'state-offices');
          return <div key="state-offices-card" className="mt-3 rounded-xl border overflow-hidden border-gray-200" data-id="element-1315">
                    <div className="flex items-center justify-between px-3 py-2 bg-gray-50" onClick={() => setOpenLinkInfo(openLinkInfo === stateOfficeIndex ? null : stateOfficeIndex)} role="button" data-id="element-1316">
                      <span className={`inline-flex items-center gap-1 font-semibold text-xs ${tip.accentColor}`} data-id="element-1317">
                        {isEs && l.labelEs ? l.labelEs : l.label}
                      </span>
                      <button onClick={e => {
                e.stopPropagation();
                setOpenLinkInfo(openLinkInfo === stateOfficeIndex ? null : stateOfficeIndex);
              }} className="ml-2 flex items-center gap-1 transition-colors text-gray-400 hover:text-gray-600" aria-label="More info" data-id="element-1318">
                        <span className="text-xs font-medium" data-id="element-1319">
                          {t('consular.info.button')}
                        </span>
                        <motion.div animate={{
                  rotate: openLinkInfo === stateOfficeIndex ? 180 : 0
                }} transition={{
                  duration: 0.2
                }} data-id="element-1320">
                          <ChevronDownIcon className="w-3.5 h-3.5" data-id="element-1321" />
                        </motion.div>
                      </button>
                    </div>
                    <AnimatePresence initial={false} data-id="element-1322">
                      {openLinkInfo === stateOfficeIndex && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: [0.16, 1, 0.3, 1]
              }} className="overflow-hidden" data-id="element-1323">
                          <div className="px-3 py-3 bg-white border-t border-gray-100" data-id="element-1324">
                            <div className="space-y-3 text-xs text-gray-600" data-id="element-1325">
                              <p className="font-bold text-gray-800 uppercase tracking-wide" data-id="element-1326">
                                {isEs ? 'Oficinas de Apostilla por Estado' : 'State Apostille Offices'}
                              </p>
                              <div data-id="element-1327">
                                <p className="font-semibold text-gray-700 mb-0.5" data-id="element-1328">
                                  {isEs ? '🏛️ Oficina Federal' : '🏛️ Federal Office'}
                                </p>
                                <p className="pl-2 text-gray-500" data-id="element-1329">
                                  U.S. Department of State Apostille Office
                                </p>
                                <p className="pl-2 text-gray-500" data-id="element-1330">
                                  Office of Authentications
                                </p>
                                <p className="pl-2 text-gray-500" data-id="element-1331">
                                  600 19th Street NW, Washington, DC 20006
                                </p>
                                <p className="pl-2 text-gray-500" data-id="element-1332">
                                  (202) 485-8000
                                </p>
                              </div>
                              <div className="border-t border-gray-200 pt-2" data-id="element-1333">
                                <p className="font-bold text-gray-800 mb-2 uppercase tracking-wide text-xs" data-id="element-1334">
                                  {isEs ? 'Oficinas Estatales' : 'State Offices'}
                                </p>
                                {[{
                        state: 'Arizona',
                        addresses: ['1700 W Washington St, Phoenix, AZ 85007', '400 West Congress Street, Suite 221, Tucson, AZ 85701'],
                        phone: '(602) 542-4285'
                      }, {
                        state: 'California',
                        addresses: ['1500 11th Street, 3rd Floor, Sacramento, CA 95814', '300 South Spring Street, Room 12513, Los Angeles, CA 90013'],
                        phones: [{
                          label: 'Sacramento',
                          number: '(916) 653-6814'
                        }, {
                          label: 'Los Angeles',
                          number: '(213) 897-5310'
                        }]
                      }, {
                        state: 'Florida',
                        addresses: ['R.A. Gray Building, 500 South Bronough Street, Tallahassee, FL 32399'],
                        phone: '(850) 245-6500'
                      }, {
                        state: 'Georgia',
                        addresses: ['214 State Capitol, Atlanta, GA 30334'],
                        phone: '(470) 312-2808'
                      }, {
                        state: 'Illinois',
                        addresses: ['69 W. Washington St., Suite 1240, Chicago, IL 60602', '2701 S. Dirksen Parkway, Springfield, IL 62723'],
                        phones: [{
                          label: 'Chicago',
                          number: '(312) 814-8218'
                        }, {
                          label: 'Springfield',
                          number: '(217) 782-7017'
                        }]
                      }, {
                        state: 'Kansas',
                        addresses: ['915 SW Harrison Street, Topeka, KS 66612'],
                        phone: '(785) 296-4564'
                      }, {
                        state: 'Louisiana',
                        addresses: ['8585 Archives Ave, Baton Rouge, LA 70809'],
                        phone: '(225) 922-0433'
                      }, {
                        state: 'Maryland',
                        addresses: ['16 Francis Street, Annapolis, MD 21401'],
                        phone: '(410) 974-5521'
                      }, {
                        state: 'Massachusetts',
                        addresses: ['One Ashburton Place, Room 1719, Boston, MA 02108'],
                        phone: '(617) 727-9180'
                      }, {
                        state: 'New Jersey',
                        addresses: ['33 West State Street, 5th Floor, Trenton, NJ 08608'],
                        phone: '(609) 292-4925'
                      }, {
                        state: 'New York',
                        addresses: ['99 Washington Avenue, Albany, NY 12231', '123 William St #2, New York, NY 10038'],
                        phone: '(518) 474-4429'
                      }, {
                        state: 'North Carolina',
                        addresses: ['2 South Salisbury Street, Raleigh, NC 27601'],
                        phone: '(919) 814-5400'
                      }, {
                        state: 'Pennsylvania',
                        addresses: ['210 North Office Building, Harrisburg, PA 17120'],
                        phone: '(717) 787-5280'
                      }, {
                        state: 'Texas',
                        addresses: ['1019 Brazos, Austin, TX 78701'],
                        phone: '(512) 463-5705'
                      }, {
                        state: 'Virginia',
                        addresses: ['1111 East Broad Street, Richmond, VA 23219'],
                        phone: '(804) 786-2441'
                      }, {
                        state: 'Washington D.C.',
                        addresses: ['899 North Capitol Street, NE, Suite 8100'],
                        phone: '(202) 727-3117'
                      }].map((entry, si) => <div key={si} className="bg-blue-50 rounded-lg p-2 mb-1.5" data-id="element-1335">
                                    <p className="font-semibold text-haa-blue text-xs mb-0.5" data-id="element-1336">
                                      {entry.state}
                                    </p>
                                    {entry.addresses.length > 1 ? <ul className="space-y-0.5 pl-1" data-id="element-1337">
                                        {entry.addresses.map((addr, ai) => <li key={ai} className="flex items-start gap-1.5 text-gray-500" data-id="element-1338">
                                            <span className="text-gray-400 mt-0.5 flex-shrink-0" data-id="element-1339">
                                              •
                                            </span>
                                            <span data-id="element-1340">{addr}</span>
                                          </li>)}
                                      </ul> : entry.addresses.map((addr, ai) => <p key={ai} className="pl-1 text-gray-500" data-id="element-1341">
                                          {addr}
                                        </p>)}
                                    {entry.phones ? entry.phones.map((p: {
                          label: string;
                          number: string;
                        }, pi: number) => <div key={pi} className="flex items-center gap-1 mt-0.5 pl-1" data-id="element-1342">
                                            <PhoneIcon className="w-3 h-3 text-gray-400 flex-shrink-0" data-id="element-1343" />
                                            <a href={`tel:${p.number.replace(/[^0-9+]/g, '')}`} className="text-emerald-600 font-semibold hover:underline" data-id="element-1344">
                                              {p.label}: {p.number}
                                            </a>
                                          </div>) : entry.phone ? <div className="flex items-center gap-1 mt-0.5 pl-1" data-id="element-1345">
                                        <PhoneIcon className="w-3 h-3 text-gray-400 flex-shrink-0" data-id="element-1346" />
                                        <a href={`tel:${entry.phone.replace(/[^0-9+]/g, '')}`} className="text-emerald-600 font-semibold hover:underline" data-id="element-1347">
                                          {entry.phone}
                                        </a>
                                      </div> : null}
                                  </div>)}
                              </div>
                            </div>
                          </div>
                        </motion.div>}
                    </AnimatePresence>
                  </div>;
        })}
        </div>
      </div>
      {/* Complaint Form Modal */}
      <AnimatePresence data-id="element-1348">
        {complaintModalOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => {
        setComplaintModalOpen(false);
        if (complaintSubmitted) resetComplaintForm();
      }} data-id="element-1349">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: [0.16, 1, 0.3, 1]
        }} className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-1350">
              {/* Header */}
              <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100" data-id="element-1351">
                <div className="flex items-center gap-3" data-id="element-1352">
                  <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-red-500 to-red-700 flex items-center justify-center shadow-sm" data-id="element-1353">
                    <ClipboardListIcon className="w-5 h-5 text-white" data-id="element-1354" />
                  </div>
                  <h2 className="font-bebas text-2xl sm:text-3xl text-haa-navy tracking-wider" data-id="element-1355">
                    {isEs ? 'Queja de Servicio Consular' : 'Consular Service Complaint'}
                  </h2>
                </div>
                <button onClick={() => {
              setComplaintModalOpen(false);
              if (complaintSubmitted) resetComplaintForm();
            }} className="p-2 rounded-lg hover:bg-gray-100 transition-colors text-gray-400 hover:text-gray-600" aria-label="Close" data-id="element-1356">
                  <XIcon className="w-5 h-5" data-id="element-1357" />
                </button>
              </div>

              {/* Content */}
              <div className="flex-1 overflow-y-auto px-6 py-5" data-id="element-1358">
                {complaintSubmitted ?
            // Success State
            <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} className="flex flex-col items-center justify-center py-10 text-center" data-id="element-1359">
                    <div className="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center mb-4" data-id="element-1360">
                      <svg className="w-8 h-8 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} data-id="element-1361">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-1362" />
                      </svg>
                    </div>
                    <h3 className="font-bebas text-2xl text-haa-navy tracking-wider mb-2" data-id="element-1363">
                      {isEs ? '¡Gracias por su Reporte!' : 'Thank You for Your Report!'}
                    </h3>
                    <p className="font-nunito text-gray-600 text-sm max-w-md" data-id="element-1364">
                      {isEs ? 'Su queja ha sido enviada exitosamente. Revisaremos su reporte y periódicamente compartiremos los comentarios recibidos con el liderazgo consular.' : 'Your complaint has been submitted successfully. We will review your report and periodically share feedback with consular leadership.'}
                    </p>
                    <p className="font-nunito text-gray-500 text-xs max-w-md mt-3" data-id="element-1365">
                      🔒{' '}
                      {isEs ? 'Su privacidad es de suma importancia para nosotros.' : 'Your privacy is of the utmost importance to us.'}
                    </p>
                  </motion.div> :
            // Form
            <div className="space-y-5" data-id="element-1366">
                    <p className="font-nunito text-gray-500 text-sm" data-id="element-1367">
                      {isEs ? 'Complete el formulario a continuación para presentar su queja. Toda la información será tratada de manera confidencial.' : 'Fill out the form below to file your complaint. All information will be treated confidentially.'}
                    </p>

                    {/* Anonymous Option */}
                    <div className="flex items-center gap-3 bg-gray-50 rounded-xl px-4 py-3 border border-gray-200" data-id="element-1368">
                      <input type="checkbox" id="complaint-anonymous" checked={complaintAnonymous} onChange={e => {
                  setComplaintAnonymous(e.target.checked);
                  if (e.target.checked) {
                    setComplaintName('');
                    setComplaintPhone('');
                    setComplaintEmail('');
                  }
                }} className="w-4 h-4 rounded border-gray-300 text-haa-blue focus:ring-haa-blue/20 cursor-pointer" data-id="element-1369" />
                      <label htmlFor="complaint-anonymous" className="font-nunito font-semibold text-sm text-gray-700 cursor-pointer select-none" data-id="element-1370">
                        {isEs ? 'Enviar de forma anónima' : 'Submit anonymously'}
                      </label>
                    </div>

                    {/* Full Name */}
                    {!complaintAnonymous && <div data-id="element-1371">
                        <label className="block font-nunito font-semibold text-sm text-gray-700 mb-1.5" data-id="element-1372">
                          {isEs ? 'Nombre Completo' : 'Full Name'}
                        </label>
                        <input type="text" value={complaintName} onChange={e => setComplaintName(e.target.value)} placeholder={isEs ? 'Ingrese su nombre completo' : 'Enter your full name'} className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:border-haa-blue focus:ring-2 focus:ring-haa-blue/20 outline-none transition-all font-nunito text-sm" data-id="element-1373" />
                      </div>}

                    {/* Phone and Email Row */}
                    {!complaintAnonymous && <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1374">
                        <div data-id="element-1375">
                          <label className="block font-nunito font-semibold text-sm text-gray-700 mb-1.5" data-id="element-1376">
                            {isEs ? 'Número de Teléfono' : 'Phone Number'}
                          </label>
                          <input type="tel" value={complaintPhone} onChange={e => setComplaintPhone(e.target.value)} placeholder={isEs ? '(555) 123-4567' : '(555) 123-4567'} className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:border-haa-blue focus:ring-2 focus:ring-haa-blue/20 outline-none transition-all font-nunito text-sm" data-id="element-1377" />
                        </div>
                        <div data-id="element-1378">
                          <label className="block font-nunito font-semibold text-sm text-gray-700 mb-1.5" data-id="element-1379">
                            {isEs ? 'Correo Electrónico' : 'Email'}
                          </label>
                          <input type="email" value={complaintEmail} onChange={e => setComplaintEmail(e.target.value)} placeholder={isEs ? 'su@correo.com' : 'your@email.com'} className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:border-haa-blue focus:ring-2 focus:ring-haa-blue/20 outline-none transition-all font-nunito text-sm" data-id="element-1380" />
                        </div>
                      </div>}

                    {/* Rating */}
                    <div data-id="element-1381">
                      <label className="block font-nunito font-semibold text-sm text-gray-700 mb-1.5" data-id="element-1382">
                        {isEs ? 'Calificación del Servicio (1-10)' : 'Service Rating (1-10)'}{' '}
                        <span className="text-red-500" data-id="element-1383">*</span>
                      </label>
                      <p className="font-nunito text-xs text-gray-400 mb-2" data-id="element-1384">
                        {isEs ? '1 = Muy malo, 10 = Excelente' : '1 = Very poor, 10 = Excellent'}
                      </p>
                      <div className="flex flex-wrap gap-2" data-id="element-1385">
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(num => <button key={num} type="button" onClick={() => setComplaintRating(num)} className={`w-11 h-11 rounded-lg font-nunito font-bold text-sm border-2 transition-all ${complaintRating === num ? getRatingColor(num) : 'border-gray-200 text-gray-500 hover:border-gray-300 hover:bg-gray-50'}`} data-id="element-1386">
                            {num}
                          </button>)}
                      </div>
                    </div>

                    {/* Consulate Dropdown */}
                    <div data-id="element-1387">
                      <label className="block font-nunito font-semibold text-sm text-gray-700 mb-1.5" data-id="element-1388">
                        {isEs ? 'Consulado de la Queja' : 'Complaint Consulate'}{' '}
                        <span className="text-red-500" data-id="element-1389">*</span>
                      </label>
                      <select value={complaintConsulate} onChange={e => setComplaintConsulate(e.target.value)} className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:border-haa-blue focus:ring-2 focus:ring-haa-blue/20 outline-none transition-all font-nunito text-sm bg-white" data-id="element-1390">
                        <option value="" data-id="element-1391">
                          {isEs ? '-- Seleccione un consulado --' : '-- Select a consulate --'}
                        </option>
                        {consulateOptions.map((consulate, idx) => <option key={idx} value={isEs && consulate.nameEs ? consulate.nameEs : consulate.name} data-id="element-1392">
                            {isEs && consulate.nameEs ? consulate.nameEs : consulate.name}
                          </option>)}
                      </select>
                    </div>

                    {/* Date of Service and Agent Name Row */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1393">
                      <div data-id="element-1394">
                        <label className="block font-nunito font-semibold text-sm text-gray-700 mb-1.5" data-id="element-1395">
                          {isEs ? 'Fecha del Servicio' : 'Date of Service'}{' '}
                          <span className="text-red-500" data-id="element-1396">*</span>
                        </label>
                        <input type="date" value={complaintDate} onChange={e => setComplaintDate(e.target.value)} className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:border-haa-blue focus:ring-2 focus:ring-haa-blue/20 outline-none transition-all font-nunito text-sm" data-id="element-1397" />
                      </div>
                      <div data-id="element-1398">
                        <label className="block font-nunito font-semibold text-sm text-gray-700 mb-1.5" data-id="element-1399">
                          {isEs ? 'Nombre del Agente Consular' : 'Name of Consular Agent'}
                          <span className="text-gray-400 font-normal text-xs ml-1" data-id="element-1400">
                            ({isEs ? 'si lo sabe' : 'if known'})
                          </span>
                        </label>
                        <input type="text" value={complaintAgentName} onChange={e => setComplaintAgentName(e.target.value)} placeholder={isEs ? 'Si lo sabe' : 'If known'} className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:border-haa-blue focus:ring-2 focus:ring-haa-blue/20 outline-none transition-all font-nunito text-sm" data-id="element-1401" />
                      </div>
                    </div>

                    {/* Time Spent at Consulate */}
                    <div data-id="element-1402">
                      <label className="block font-nunito font-semibold text-sm text-gray-700 mb-1.5" data-id="element-1403">
                        {isEs ? 'Tiempo en el Consulado' : 'Time Spent at Consulate'}
                      </label>
                      <select value={complaintTimeSpent} onChange={e => setComplaintTimeSpent(e.target.value)} className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:border-haa-blue focus:ring-2 focus:ring-haa-blue/20 outline-none transition-all font-nunito text-sm bg-white" data-id="element-1404">
                        <option value="" data-id="element-1405">
                          {isEs ? '-- Seleccione --' : '-- Select --'}
                        </option>
                        <option value={isEs ? '0-1 horas' : '0-1 hours'} data-id="element-1406">
                          {isEs ? '0-1 horas' : '0-1 hours'}
                        </option>
                        <option value={isEs ? '1-2 horas' : '1-2 hours'} data-id="element-1407">
                          {isEs ? '1-2 horas' : '1-2 hours'}
                        </option>
                        <option value={isEs ? '2-3 horas' : '2-3 hours'} data-id="element-1408">
                          {isEs ? '2-3 horas' : '2-3 hours'}
                        </option>
                        <option value={isEs ? '3-4 horas' : '3-4 hours'} data-id="element-1409">
                          {isEs ? '3-4 horas' : '3-4 hours'}
                        </option>
                        <option value={isEs ? '4-5 horas' : '4-5 hours'} data-id="element-1410">
                          {isEs ? '4-5 horas' : '4-5 hours'}
                        </option>
                        <option value={isEs ? '5+ horas' : '5+ hours'} data-id="element-1411">
                          {isEs ? '5+ horas' : '5+ hours'}
                        </option>
                      </select>
                    </div>

                    {/* Experience Description */}
                    <div data-id="element-1412">
                      <label className="block font-nunito font-semibold text-sm text-gray-700 mb-1.5" data-id="element-1413">
                        {isEs ? 'Descripción de la Queja' : 'Complaint Description'}
                      </label>
                      <textarea value={complaintText} onChange={e => setComplaintText(e.target.value)} placeholder={isEs ? 'Describa su experiencia en detalle. Incluya la fecha de la visita, el nombre del funcionario (si lo sabe), y cualquier otra información relevante.' : 'Describe your experience in detail. Include the date of visit, the name of the official (if known), and any other relevant information.'} rows={5} className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:border-haa-blue focus:ring-2 focus:ring-haa-blue/20 outline-none transition-all font-nunito text-sm resize-none min-h-[140px]" data-id="element-1414" />
                    </div>
                  </div>}
              </div>

              {/* Footer */}
              <div className="px-6 py-4 border-t border-gray-100 bg-gray-50/50 flex items-center justify-between gap-3" data-id="element-1415">
                {complaintSubmitted ? <button onClick={() => {
              setComplaintModalOpen(false);
              resetComplaintForm();
            }} className="w-full py-2.5 bg-haa-navy hover:bg-haa-blue text-white font-nunito font-bold text-sm rounded-xl transition-colors" data-id="element-1416">
                    {isEs ? 'Cerrar' : 'Close'}
                  </button> : <>
                    <button onClick={() => setComplaintModalOpen(false)} className="flex-1 py-2.5 border border-gray-200 text-gray-600 hover:bg-gray-100 font-nunito font-bold text-sm rounded-xl transition-colors" data-id="element-1417">
                      {isEs ? 'Cancelar' : 'Cancel'}
                    </button>
                    <button onClick={handleComplaintSubmit} disabled={!complaintAnonymous && (!complaintName || !complaintPhone || !complaintEmail) || !complaintRating || !complaintConsulate || !complaintDate || !complaintText} className="flex-1 py-2.5 bg-gradient-to-r from-red-500 to-red-700 hover:from-red-600 hover:to-red-800 text-white font-nunito font-bold text-sm rounded-xl transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:from-red-500 disabled:hover:to-red-700" data-id="element-1418">
                      {isEs ? 'Enviar Queja' : 'Submit Complaint'}
                    </button>
                  </>}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
      {/* Positive Feedback Form Modal */}
      <AnimatePresence data-id="element-1419">
        {positiveFeedbackModalOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => {
        setPositiveFeedbackModalOpen(false);
        if (positiveSubmitted) resetPositiveFeedbackForm();
      }} data-id="element-1420">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: [0.16, 1, 0.3, 1]
        }} className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-1421">
              {/* Header */}
              <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100" data-id="element-1422">
                <div className="flex items-center gap-3" data-id="element-1423">
                  <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-emerald-500 to-emerald-700 flex items-center justify-center shadow-sm text-lg" data-id="element-1424">
                    🌟
                  </div>
                  <h2 className="font-bebas text-2xl sm:text-3xl text-haa-navy tracking-wider" data-id="element-1425">
                    {isEs ? 'Experiencia Consular Positiva' : 'Positive Consular Experience'}
                  </h2>
                </div>
                <button onClick={() => {
              setPositiveFeedbackModalOpen(false);
              if (positiveSubmitted) resetPositiveFeedbackForm();
            }} className="p-2 rounded-lg hover:bg-gray-100 transition-colors text-gray-400 hover:text-gray-600" aria-label="Close" data-id="element-1426">
                  <XIcon className="w-5 h-5" data-id="element-1427" />
                </button>
              </div>

              {/* Content */}
              <div className="flex-1 overflow-y-auto px-6 py-5" data-id="element-1428">
                {positiveSubmitted ? <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} className="flex flex-col items-center justify-center py-10 text-center" data-id="element-1429">
                    <div className="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center mb-4" data-id="element-1430">
                      <svg className="w-8 h-8 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} data-id="element-1431">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-1432" />
                      </svg>
                    </div>
                    <h3 className="font-bebas text-2xl text-haa-navy tracking-wider mb-2" data-id="element-1433">
                      {isEs ? '¡Gracias por Compartir!' : 'Thank You for Sharing!'}
                    </h3>
                    <p className="font-nunito text-gray-600 text-sm max-w-md" data-id="element-1434">
                      {isEs ? 'Su experiencia positiva ha sido enviada exitosamente. Periódicamente compartiremos los comentarios recibidos con el liderazgo consular para reconocer el buen servicio.' : 'Your positive experience has been submitted successfully. We will periodically share feedback with consular leadership to recognize good service.'}
                    </p>
                    <p className="font-nunito text-gray-500 text-xs max-w-md mt-3" data-id="element-1435">
                      🔒{' '}
                      {isEs ? 'Su privacidad es de suma importancia para nosotros.' : 'Your privacy is of the utmost importance to us.'}
                    </p>
                  </motion.div> : <div className="space-y-5" data-id="element-1436">
                    <p className="font-nunito text-gray-500 text-sm" data-id="element-1437">
                      {isEs ? '¡Nos encanta escuchar sobre experiencias positivas! Complete el formulario a continuación para reconocer un servicio excepcional.' : 'We love hearing about positive experiences! Fill out the form below to recognize exceptional service.'}
                    </p>

                    {/* Anonymous Option */}
                    <div className="flex items-center gap-3 bg-gray-50 rounded-xl px-4 py-3 border border-gray-200" data-id="element-1438">
                      <input type="checkbox" id="positive-anonymous" checked={positiveAnonymous} onChange={e => {
                  setPositiveAnonymous(e.target.checked);
                  if (e.target.checked) {
                    setPositiveName('');
                    setPositivePhone('');
                    setPositiveEmail('');
                  }
                }} className="w-4 h-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-500/20 cursor-pointer" data-id="element-1439" />
                      <label htmlFor="positive-anonymous" className="font-nunito font-semibold text-sm text-gray-700 cursor-pointer select-none" data-id="element-1440">
                        {isEs ? 'Enviar de forma anónima' : 'Submit anonymously'}
                      </label>
                    </div>

                    {/* Full Name */}
                    {!positiveAnonymous && <div data-id="element-1441">
                        <label className="block font-nunito font-semibold text-sm text-gray-700 mb-1.5" data-id="element-1442">
                          {isEs ? 'Nombre Completo' : 'Full Name'}
                          <span className="text-gray-400 font-normal text-xs ml-1" data-id="element-1443">
                            ({isEs ? 'opcional' : 'optional'})
                          </span>
                        </label>
                        <input type="text" value={positiveName} onChange={e => setPositiveName(e.target.value)} placeholder={isEs ? 'Ingrese su nombre completo' : 'Enter your full name'} className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all font-nunito text-sm" data-id="element-1444" />
                      </div>}

                    {/* Phone and Email Row */}
                    {!positiveAnonymous && <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1445">
                        <div data-id="element-1446">
                          <label className="block font-nunito font-semibold text-sm text-gray-700 mb-1.5" data-id="element-1447">
                            {isEs ? 'Número de Teléfono' : 'Phone Number'}
                            <span className="text-gray-400 font-normal text-xs ml-1" data-id="element-1448">
                              ({isEs ? 'opcional' : 'optional'})
                            </span>
                          </label>
                          <input type="tel" value={positivePhone} onChange={e => setPositivePhone(e.target.value)} placeholder="(555) 123-4567" className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all font-nunito text-sm" data-id="element-1449" />
                        </div>
                        <div data-id="element-1450">
                          <label className="block font-nunito font-semibold text-sm text-gray-700 mb-1.5" data-id="element-1451">
                            {isEs ? 'Correo Electrónico' : 'Email'}
                            <span className="text-gray-400 font-normal text-xs ml-1" data-id="element-1452">
                              ({isEs ? 'opcional' : 'optional'})
                            </span>
                          </label>
                          <input type="email" value={positiveEmail} onChange={e => setPositiveEmail(e.target.value)} placeholder={isEs ? 'su@correo.com' : 'your@email.com'} className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all font-nunito text-sm" data-id="element-1453" />
                        </div>
                      </div>}

                    {/* Rating */}
                    <div data-id="element-1454">
                      <label className="block font-nunito font-semibold text-sm text-gray-700 mb-1.5" data-id="element-1455">
                        {isEs ? 'Calificación del Servicio (1-10)' : 'Service Rating (1-10)'}{' '}
                        <span className="text-red-500" data-id="element-1456">*</span>
                      </label>
                      <p className="font-nunito text-xs text-gray-400 mb-2" data-id="element-1457">
                        {isEs ? '1 = Muy malo, 10 = Excelente' : '1 = Very poor, 10 = Excellent'}
                      </p>
                      <div className="flex flex-wrap gap-2" data-id="element-1458">
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(num => <button key={num} type="button" onClick={() => setPositiveRating(num)} className={`w-11 h-11 rounded-lg font-nunito font-bold text-sm border-2 transition-all ${positiveRating === num ? getRatingColor(num) : 'border-gray-200 text-gray-500 hover:border-gray-300 hover:bg-gray-50'}`} data-id="element-1459">
                            {num}
                          </button>)}
                      </div>
                    </div>

                    {/* Consulate Dropdown */}
                    <div data-id="element-1460">
                      <label className="block font-nunito font-semibold text-sm text-gray-700 mb-1.5" data-id="element-1461">
                        {isEs ? 'Consulado' : 'Consulate'}{' '}
                        <span className="text-red-500" data-id="element-1462">*</span>
                      </label>
                      <select value={positiveConsulate} onChange={e => setPositiveConsulate(e.target.value)} className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all font-nunito text-sm bg-white" data-id="element-1463">
                        <option value="" data-id="element-1464">
                          {isEs ? '-- Seleccione un consulado --' : '-- Select a consulate --'}
                        </option>
                        {consulateOptions.map((consulate, idx) => <option key={idx} value={isEs && consulate.nameEs ? consulate.nameEs : consulate.name} data-id="element-1465">
                            {isEs && consulate.nameEs ? consulate.nameEs : consulate.name}
                          </option>)}
                      </select>
                    </div>

                    {/* Date and Agent Name */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1466">
                      <div data-id="element-1467">
                        <label className="block font-nunito font-semibold text-sm text-gray-700 mb-1.5" data-id="element-1468">
                          {isEs ? 'Fecha de la Visita' : 'Date of Visit'}{' '}
                          <span className="text-red-500" data-id="element-1469">*</span>
                        </label>
                        <input type="date" value={positiveDate} onChange={e => setPositiveDate(e.target.value)} className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all font-nunito text-sm" data-id="element-1470" />
                      </div>
                      <div data-id="element-1471">
                        <label className="block font-nunito font-semibold text-sm text-gray-700 mb-1.5" data-id="element-1472">
                          {isEs ? 'Nombre del Funcionario' : 'Name of Official'}
                          <span className="text-gray-400 font-normal text-xs ml-1" data-id="element-1473">
                            ({isEs ? 'si lo sabe' : 'if known'})
                          </span>
                        </label>
                        <input type="text" value={positiveAgentName} onChange={e => setPositiveAgentName(e.target.value)} placeholder={isEs ? 'Si lo sabe' : 'If known'} className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all font-nunito text-sm" data-id="element-1474" />
                      </div>
                    </div>

                    {/* Time Spent at Consulate */}
                    <div data-id="element-1475">
                      <label className="block font-nunito font-semibold text-sm text-gray-700 mb-1.5" data-id="element-1476">
                        {isEs ? 'Tiempo en el Consulado' : 'Time Spent at Consulate'}
                      </label>
                      <select value={positiveTimeSpent} onChange={e => setPositiveTimeSpent(e.target.value)} className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:border-haa-blue focus:ring-2 focus:ring-haa-blue/20 outline-none transition-all font-nunito text-sm bg-white" data-id="element-1477">
                        <option value="" data-id="element-1478">
                          {isEs ? '-- Seleccione --' : '-- Select --'}
                        </option>
                        <option value={isEs ? '0-1 horas' : '0-1 hours'} data-id="element-1479">
                          {isEs ? '0-1 horas' : '0-1 hours'}
                        </option>
                        <option value={isEs ? '1-2 horas' : '1-2 hours'} data-id="element-1480">
                          {isEs ? '1-2 horas' : '1-2 hours'}
                        </option>
                        <option value={isEs ? '2-3 horas' : '2-3 hours'} data-id="element-1481">
                          {isEs ? '2-3 horas' : '2-3 hours'}
                        </option>
                        <option value={isEs ? '3-4 horas' : '3-4 hours'} data-id="element-1482">
                          {isEs ? '3-4 horas' : '3-4 hours'}
                        </option>
                        <option value={isEs ? '4-5 horas' : '4-5 hours'} data-id="element-1483">
                          {isEs ? '4-5 horas' : '4-5 hours'}
                        </option>
                        <option value={isEs ? '5+ horas' : '5+ hours'} data-id="element-1484">
                          {isEs ? '5+ horas' : '5+ hours'}
                        </option>
                      </select>
                    </div>

                    {/* Experience Description */}
                    <div data-id="element-1485">
                      <label className="block font-nunito font-semibold text-sm text-gray-700 mb-1.5" data-id="element-1486">
                        {isEs ? 'Descripción de la Experiencia' : 'Experience Description'}{' '}
                        <span className="text-gray-400 font-normal text-xs ml-1" data-id="element-1487">
                          ({isEs ? 'opcional' : 'optional'})
                        </span>
                      </label>
                      <textarea value={positiveText} onChange={e => setPositiveText(e.target.value)} placeholder={isEs ? 'Cuéntenos qué hizo que su experiencia fuera positiva. ¿Qué servicio recibió? ¿Cómo fue el trato del funcionario?' : "Tell us what made your experience positive. What service did you receive? How was the official's treatment?"} rows={5} className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:border-haa-blue focus:ring-2 focus:ring-haa-blue/20 outline-none transition-all font-nunito text-sm resize-none min-h-[140px]" data-id="element-1488" />
                    </div>
                  </div>}
              </div>

              {/* Footer */}
              <div className="px-6 py-4 border-t border-gray-100 bg-gray-50/50 flex items-center justify-between gap-3" data-id="element-1489">
                {positiveSubmitted ? <button onClick={() => {
              setPositiveFeedbackModalOpen(false);
              resetPositiveFeedbackForm();
            }} className="w-full py-2.5 bg-haa-navy hover:bg-haa-blue text-white font-nunito font-bold text-sm rounded-xl transition-colors" data-id="element-1490">
                    {isEs ? 'Cerrar' : 'Close'}
                  </button> : <>
                    <button onClick={() => setPositiveFeedbackModalOpen(false)} className="flex-1 py-2.5 border border-gray-200 text-gray-600 hover:bg-gray-100 font-nunito font-bold text-sm rounded-xl transition-colors" data-id="element-1491">
                      {isEs ? 'Cancelar' : 'Cancel'}
                    </button>
                    <button onClick={handlePositiveFeedbackSubmit} disabled={!positiveRating || !positiveConsulate || !positiveDate} className="flex-1 py-2.5 bg-gradient-to-r from-emerald-500 to-emerald-700 hover:from-emerald-600 hover:to-emerald-800 text-white font-nunito font-bold text-sm rounded-xl transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:from-emerald-500 disabled:hover:to-emerald-700" data-id="element-1492">
                      {isEs ? 'Enviar Experiencia' : 'Submit Experience'}
                    </button>
                  </>}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
      {/* Invite Official Modal */}
      <AnimatePresence data-id="element-1493">
        {inviteModalOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => {
        setInviteModalOpen(false);
        if (inviteSubmitted) resetInviteForm();
      }} data-id="element-1494">
            <motion.div initial={{
          scale: 0.95,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.95,
          opacity: 0
        }} transition={{
          duration: 0.2
        }} onClick={e => e.stopPropagation()} className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto" data-id="element-1495">
              {/* Header */}
              <div className="bg-gradient-to-r from-indigo-500 to-indigo-700 p-5 rounded-t-2xl" data-id="element-1496">
                <div className="flex items-center justify-between" data-id="element-1497">
                  <h3 className="font-bebas text-2xl text-white tracking-wider" data-id="element-1498">
                    📩 {isEs ? 'Invitar a un Oficial' : 'Invite an Official'}
                  </h3>
                  <button onClick={() => {
                setInviteModalOpen(false);
                if (inviteSubmitted) resetInviteForm();
              }} className="text-white/80 hover:text-white transition-colors" data-id="element-1499">
                    <XIcon className="w-5 h-5" data-id="element-1500" />
                  </button>
                </div>
                <p className="font-nunito text-white/80 text-sm mt-1" data-id="element-1501">
                  {isEs ? 'Nos encantaría ayudarle a conectar con su oficial consular local o la Embajada para eventos de mayor perfil. Complete el formulario y finalice a través de WhatsApp.' : 'We would love to help you connect with your local consular official or the Embassy for bigger profile events. Complete the form and finalize via WhatsApp.'}
                </p>
              </div>

              {inviteSubmitted ? <div className="p-6 text-center space-y-4" data-id="element-1502">
                  <div className="w-16 h-16 rounded-full bg-indigo-100 flex items-center justify-center mx-auto" data-id="element-1503">
                    <span className="text-3xl" data-id="element-1504">✅</span>
                  </div>
                  <h4 className="font-bebas text-2xl text-indigo-700 tracking-wider" data-id="element-1505">
                    {isEs ? '¡Solicitud Enviada!' : 'Request Sent!'}
                  </h4>
                  <p className="font-nunito text-gray-600 text-sm" data-id="element-1506">
                    {isEs ? 'Su solicitud ha sido enviada por WhatsApp. Nos pondremos en contacto con usted pronto para coordinar los detalles.' : 'Your request has been sent via WhatsApp. We will get in touch with you soon to coordinate the details.'}
                  </p>
                </div> : <div className="p-5 space-y-4" data-id="element-1507">
                  {/* Name */}
                  <div data-id="element-1508">
                    <label className="font-nunito text-xs font-bold text-gray-700 uppercase tracking-wide block mb-1" data-id="element-1509">
                      {isEs ? 'Nombre Completo' : 'Full Name'} *
                    </label>
                    <input type="text" value={inviteName} onChange={e => setInviteName(e.target.value)} placeholder={isEs ? 'Su nombre completo' : 'Your full name'} className="w-full px-3 py-2.5 border border-gray-200 rounded-xl font-nunito text-sm focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-transparent" data-id="element-1510" />
                  </div>
                  {/* Organization */}
                  <div data-id="element-1511">
                    <label className="font-nunito text-xs font-bold text-gray-700 uppercase tracking-wide block mb-1" data-id="element-1512">
                      {isEs ? 'Organización' : 'Organization'} *
                    </label>
                    <input type="text" value={inviteOrg} onChange={e => setInviteOrg(e.target.value)} placeholder={isEs ? 'Nombre de su organización' : 'Your organization name'} className="w-full px-3 py-2.5 border border-gray-200 rounded-xl font-nunito text-sm focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-transparent" data-id="element-1513" />
                  </div>
                  {/* Phone */}
                  <div data-id="element-1514">
                    <label className="font-nunito text-xs font-bold text-gray-700 uppercase tracking-wide block mb-1" data-id="element-1515">
                      {isEs ? 'Teléfono' : 'Phone Number'} *
                    </label>
                    <input type="tel" value={invitePhone} onChange={e => setInvitePhone(e.target.value)} placeholder={isEs ? 'Su número de teléfono' : 'Your phone number'} className="w-full px-3 py-2.5 border border-gray-200 rounded-xl font-nunito text-sm focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-transparent" data-id="element-1516" />
                  </div>
                  {/* Email */}
                  <div data-id="element-1517">
                    <label className="font-nunito text-xs font-bold text-gray-700 uppercase tracking-wide block mb-1" data-id="element-1518">
                      {isEs ? 'Correo Electrónico' : 'Email'} *
                    </label>
                    <input type="email" value={inviteEmail} onChange={e => setInviteEmail(e.target.value)} placeholder={isEs ? 'Su correo electrónico' : 'Your email address'} className="w-full px-3 py-2.5 border border-gray-200 rounded-xl font-nunito text-sm focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-transparent" data-id="element-1519" />
                  </div>
                  {/* Event Date */}
                  <div data-id="element-1520">
                    <label className="font-nunito text-xs font-bold text-gray-700 uppercase tracking-wide block mb-1" data-id="element-1521">
                      {isEs ? 'Fecha del Evento' : 'Event Date'} *
                    </label>
                    <input type="date" value={inviteDate} onChange={e => setInviteDate(e.target.value)} className="w-full px-3 py-2.5 border border-gray-200 rounded-xl font-nunito text-sm focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-transparent" data-id="element-1522" />
                  </div>
                  {/* Description */}
                  <div data-id="element-1523">
                    <label className="font-nunito text-xs font-bold text-gray-700 uppercase tracking-wide block mb-1" data-id="element-1524">
                      {isEs ? 'Descripción del Evento o Solicitud' : 'Event Description or Request'}{' '}
                      *
                    </label>
                    <textarea value={inviteDescription} onChange={e => setInviteDescription(e.target.value)} placeholder={isEs ? 'Describa su evento y lo que necesita...' : 'Describe your event and what you need...'} rows={4} className="w-full px-3 py-2.5 border border-gray-200 rounded-xl font-nunito text-sm focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-transparent resize-none" data-id="element-1525" />
                  </div>
                </div>}

              {/* Footer buttons */}
              <div className="flex gap-3 p-5 pt-0" data-id="element-1526">
                {inviteSubmitted ? <button onClick={() => {
              setInviteModalOpen(false);
              resetInviteForm();
            }} className="w-full py-2.5 bg-haa-navy hover:bg-haa-blue text-white font-nunito font-bold text-sm rounded-xl transition-colors" data-id="element-1527">
                    {isEs ? 'Cerrar' : 'Close'}
                  </button> : <>
                    <button onClick={() => setInviteModalOpen(false)} className="flex-1 py-2.5 border border-gray-200 text-gray-600 hover:bg-gray-100 font-nunito font-bold text-sm rounded-xl transition-colors" data-id="element-1528">
                      {isEs ? 'Cancelar' : 'Cancel'}
                    </button>
                    <button onClick={handleInviteSubmit} disabled={!inviteName || !inviteOrg || !invitePhone || !inviteEmail || !inviteDate || !inviteDescription} className="flex-1 py-2.5 bg-gradient-to-r from-indigo-500 to-indigo-700 hover:from-indigo-600 hover:to-indigo-800 text-white font-nunito font-bold text-sm rounded-xl transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2" data-id="element-1529">
                      <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor" data-id="element-1530">
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413-1.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-1531" />
                      </svg>
                      {isEs ? 'Enviar por WhatsApp' : 'Send via WhatsApp'}
                    </button>
                  </>}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
      {/* Expanded Card Modal */}
      <AnimatePresence data-id="element-1532">
        {expandedModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6 bg-black/60 backdrop-blur-sm" onClick={() => setExpandedModal(false)} data-id="element-1533">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: [0.16, 1, 0.3, 1]
        }} className={`bg-white rounded-2xl shadow-2xl w-full max-w-3xl max-h-[90vh] overflow-hidden flex flex-col border-l-4 ${tip.borderColor}`} onClick={e => e.stopPropagation()} data-id="element-1534">
              {/* Header */}
              <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 bg-white" data-id="element-1535">
                <div className="flex items-center gap-3" data-id="element-1536">
                  <div className={`w-10 h-10 rounded-xl bg-gradient-to-br ${tip.gradient} flex items-center justify-center shadow-sm`} data-id="element-1537">
                    <Icon className="w-5 h-5 text-white" data-id="element-1538" />
                  </div>
                  <h2 className={`font-bebas text-2xl sm:text-3xl tracking-wider ${tip.accentColor}`} data-id="element-1539">
                    {t(tip.titleKey)}
                  </h2>
                  {tip.flag && <span className="text-2xl" data-id="element-1540">{tip.flag}</span>}
                </div>
                <button onClick={() => setExpandedModal(false)} className="p-2 rounded-lg hover:bg-gray-100 transition-colors text-gray-400 hover:text-gray-600" aria-label="Close" data-id="element-1541">
                  <XIcon className="w-6 h-6" data-id="element-1542" />
                </button>
              </div>

              {/* Scrollable Content */}
              <div className="flex-1 overflow-y-auto p-6" data-id="element-1543">
                <p className="font-nunito text-gray-500 text-sm leading-relaxed mb-2" data-id="element-1544">
                  {t(tip.descriptionKey)}
                </p>
                {tip.titleKey === 'consular.card4.title' && <ul className="list-disc list-inside mb-4 space-y-0.5 text-gray-500 text-sm font-nunito" data-id="element-1545">
                    <li data-id="element-1546">{t('consular.card4.bullet1')}</li>
                    <li data-id="element-1547">{t('consular.card4.bullet2')}</li>
                    <li data-id="element-1548">{t('consular.card4.bullet4')}</li>
                  </ul>}

                {tip.links && tip.links.length > 0 && <div className="flex flex-col gap-3" data-id="element-1549">
                    {tip.titleKey === 'consular.card4.title' && tip.links.filter(l => l.info === 'fees').map((l, _idx) => {
                const feeIndex = tip.links.findIndex(link => link.info === 'fees');
                return <div key="fees-modal-top" className="bg-amber-50 rounded-xl p-3 border border-amber-200 mb-1" data-id="element-1550">
                              <p className="font-semibold text-amber-700 mb-1.5 text-sm" data-id="element-1551">
                                {isEs ? 'Aranceles Consulares' : 'Consular Fees'}
                              </p>
                              <p className="text-xs text-gray-600 leading-relaxed mb-3" data-id="element-1552">
                                {isEs ? 'Tarifas oficiales para servicios consulares' : 'Official fees for consular services'}
                              </p>
                              <div className="rounded-xl border overflow-hidden border-gray-200" data-id="element-1553">
                                <div className="flex items-center justify-between px-4 py-3 bg-gray-50" onClick={() => setOpenLinkInfo(openLinkInfo === feeIndex ? null : feeIndex)} role="button" data-id="element-1554">
                                  <span className={`inline-flex items-center gap-1 font-semibold text-sm ${tip.accentColor}`} data-id="element-1555">
                                    {isEs && l.labelEs ? l.labelEs : l.label}
                                  </span>
                                  <button onClick={() => setOpenLinkInfo(openLinkInfo === feeIndex ? null : feeIndex)} className="ml-2 flex items-center gap-1 transition-colors text-gray-400 hover:text-gray-600" aria-label="More info" data-id="element-1556">
                                    <span className="text-sm font-medium" data-id="element-1557">
                                      {t('consular.info.button')}
                                    </span>
                                    <motion.div animate={{
                          rotate: openLinkInfo === feeIndex ? 180 : 0
                        }} transition={{
                          duration: 0.2
                        }} data-id="element-1558">
                                      <ChevronDownIcon className="w-4 h-4" data-id="element-1559" />
                                    </motion.div>
                                  </button>
                                </div>
                                <AnimatePresence initial={false} data-id="element-1560">
                                  {openLinkInfo === feeIndex && <motion.div initial={{
                        height: 0,
                        opacity: 0
                      }} animate={{
                        height: 'auto',
                        opacity: 1
                      }} exit={{
                        height: 0,
                        opacity: 0
                      }} transition={{
                        duration: 0.25,
                        ease: [0.16, 1, 0.3, 1]
                      }} className="overflow-hidden" data-id="element-1561">
                                      <div className="px-4 py-3 bg-white border-t border-gray-100" data-id="element-1562">
                                        <div className="space-y-1" data-id="element-1563">
                                          <p className="text-xs font-bold text-center py-1.5 px-2 bg-green-100 text-green-700 rounded-lg mb-2" data-id="element-1564">
                                            {isEs ? 'ℹ️ Aranceles vigentes a partir de 2026.' : 'ℹ️ Fees current as of 2026.'}
                                          </p>
                                          {feeItems.map((item, idx) => <div key={idx} className="border-b border-gray-50 last:border-none" data-id="element-1565">
                                              <div className={`flex items-center justify-between py-1.5 ${item.subContent ? 'cursor-pointer hover:bg-gray-50 rounded-lg px-1 -mx-1 transition-colors' : ''}`} onClick={item.subContent ? () => setOpenFeeSubItem(openFeeSubItem === idx ? null : idx) : undefined} role={item.subContent ? 'button' : undefined} tabIndex={item.subContent ? 0 : undefined} onKeyDown={item.subContent ? e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                  e.preventDefault();
                                  setOpenFeeSubItem(openFeeSubItem === idx ? null : idx);
                                }
                              } : undefined} data-id="element-1566">
                                                <span className="text-sm text-gray-600 pr-2" data-id="element-1567">
                                                  {item.service}
                                                </span>
                                                <div className="flex items-center gap-1 flex-shrink-0" data-id="element-1568">
                                                  <span className={`text-sm font-bold ${tip.accentColor}`} data-id="element-1569">
                                                    {item.price}
                                                  </span>
                                                  {item.subContent && <motion.div animate={{
                                    rotate: openFeeSubItem === idx ? 180 : 0
                                  }} transition={{
                                    duration: 0.2
                                  }} className="ml-1 text-gray-400" data-id="element-1570">
                                                      <ChevronDownIcon className="w-3.5 h-3.5" data-id="element-1571" />
                                                    </motion.div>}
                                                </div>
                                              </div>
                                              {item.subContent && <AnimatePresence initial={false} data-id="element-1572">
                                                  {openFeeSubItem === idx && <motion.div initial={{
                                  height: 0,
                                  opacity: 0
                                }} animate={{
                                  height: 'auto',
                                  opacity: 1
                                }} exit={{
                                  height: 0,
                                  opacity: 0
                                }} transition={{
                                  duration: 0.25,
                                  ease: [0.16, 1, 0.3, 1]
                                }} className="overflow-hidden" data-id="element-1573">
                                                      <div className="pb-2 pt-1 pl-1 pr-1 bg-gray-50 rounded-lg mb-1" data-id="element-1574">
                                                        {item.subContent}
                                                      </div>
                                                    </motion.div>}
                                                </AnimatePresence>}
                                            </div>)}
                                        </div>
                                      </div>
                                    </motion.div>}
                                </AnimatePresence>
                              </div>
                            </div>;
              })}
                    {tip.titleKey === 'consular.card4.title' && <div className="bg-emerald-50 rounded-xl p-3 border border-emerald-200 mb-1" data-id="element-1575">
                        <p className="font-semibold text-emerald-700 mb-1.5 text-sm" data-id="element-1576">
                          {isEs ? 'Plataforma de Citas SRECI' : 'SRECI Appointment Platform'}
                        </p>
                        <p className="text-xs text-gray-600 leading-relaxed mb-3" data-id="element-1577">
                          {isEs ? 'Para los siguientes consulados:' : 'For the following consulates:'}{' '}
                          Atlanta · Aurora · Boston · Charlotte · Chicago ·
                          Dallas · Houston · McAllen · Miami · New Orleans · New
                          York · Oakland · Seattle · Washington DC
                        </p>
                        {/* Consular Appointments dropdown nested inside */}
                        {tip.links.filter(l => l.info === 'appointments').map((l, idx) => {
                  const originalIndex = tip.links.findIndex(link => link.info === 'appointments');
                  return <div key={`appt-${idx}`} className="rounded-xl border overflow-hidden border-gray-200" data-id="element-1578">
                                <div className="flex items-center justify-between px-4 py-3 bg-gray-50 cursor-pointer" onClick={() => setOpenLinkInfo(openLinkInfo === originalIndex ? null : originalIndex)} role="button" data-id="element-1579">
                                  <span className={`inline-flex items-center gap-1 font-semibold text-sm ${tip.accentColor}`} data-id="element-1580">
                                    {isEs && l.labelEs ? l.labelEs : l.label}
                                  </span>
                                  <motion.div animate={{
                        rotate: openLinkInfo === originalIndex ? 180 : 0
                      }} transition={{
                        duration: 0.2
                      }} data-id="element-1581">
                                    <ChevronDownIcon className="w-4 h-4 text-gray-400" data-id="element-1582" />
                                  </motion.div>
                                </div>
                                <AnimatePresence initial={false} data-id="element-1583">
                                  {openLinkInfo === originalIndex && <motion.div initial={{
                        height: 0,
                        opacity: 0
                      }} animate={{
                        height: 'auto',
                        opacity: 1
                      }} exit={{
                        height: 0,
                        opacity: 0
                      }} transition={{
                        duration: 0.25,
                        ease: [0.16, 1, 0.3, 1]
                      }} className="overflow-hidden" data-id="element-1584">
                                      <div className="px-4 py-3 bg-white border-t border-gray-100 space-y-3 text-sm text-gray-600" data-id="element-1585">
                                        <a href="https://citaconsular.sreci.gob.hn/citaconsular/pages/layout/CitaConsular.php" target="_blank" rel="noopener noreferrer" className="w-full inline-flex items-center justify-center gap-2 py-3 px-4 bg-gradient-to-r from-emerald-500 to-haa-skyblue text-white font-nunito font-bold text-sm rounded-xl shadow-md hover:shadow-lg transition-shadow" data-id="element-1586">
                                          📅{' '}
                                          {isEs ? 'Hacer una Cita' : 'Make an Appointment'}
                                        </a>
                                        <p className="text-xs text-gray-400 italic mt-1" data-id="element-1587">
                                          *
                                          {isEs ? 'Para Tampa, Pittsburgh, Phoenix, Colorado, Los Ángeles y Kansas — ver guía ACOS abajo' : 'For Tampa, Pittsburgh, Phoenix, Colorado, Los Angeles & Kansas — see ACOS guide below'}
                                        </p>
                                        <div className="space-y-3" data-id="element-1588">
                                          <div className="bg-blue-50 rounded-lg p-3" data-id="element-1589">
                                            <p className="font-semibold text-haa-blue mb-1.5" data-id="element-1590">
                                              {isEs ? 'Paso 1 — Buscar su identidad' : 'Step 1 — Search Your Identity'}
                                            </p>
                                            <ul className="list-disc list-inside pl-1 space-y-1 text-gray-600" data-id="element-1591">
                                              <li data-id="element-1592">
                                                {isEs ? 'Ingrese su Número de Identidad Nacional' : 'Enter your National Identification Number'}
                                              </li>
                                              <li data-id="element-1593">
                                                {isEs ? 'Haga clic en "Buscar"' : 'Click "Search"'}
                                              </li>
                                            </ul>
                                          </div>
                                          <div className="bg-blue-50 rounded-lg p-3" data-id="element-1594">
                                            <p className="font-semibold text-haa-blue mb-1.5" data-id="element-1595">
                                              {isEs ? 'Paso 2 — Seleccionar consulado y servicio' : 'Step 2 — Select Consulate & Service'}
                                            </p>
                                            <ul className="list-disc list-inside pl-1 space-y-1 text-gray-600" data-id="element-1596">
                                              <li data-id="element-1597">
                                                {isEs ? 'En Ubicación, seleccione "Estados Unidos"' : 'Under Location, select "United States"'}
                                              </li>
                                              <li data-id="element-1598">
                                                {isEs ? 'En Seleccionar Consulado, elija el consulado donde desea completar su servicio' : 'Under Select Consulate, choose the consulate where you want to complete your service'}
                                              </li>
                                              <li data-id="element-1599">
                                                {isEs ? 'En Tipo de Servicio, seleccione el servicio que desea' : 'Under Type of Service, select the service you want'}
                                              </li>
                                            </ul>
                                          </div>
                                          <div className="bg-blue-50 rounded-lg p-3" data-id="element-1600">
                                            <p className="font-semibold text-haa-blue mb-1.5" data-id="element-1601">
                                              {isEs ? 'Paso 3 — Información personal' : 'Step 3 — Personal Information'}
                                            </p>
                                            <ul className="list-disc list-inside pl-1 space-y-1 text-gray-600" data-id="element-1602">
                                              <li data-id="element-1603">
                                                {isEs ? 'Ingrese su ciudad, código postal, correo electrónico, número de teléfono y dirección' : 'Enter your city, ZIP code, email address, phone number, and address'}
                                              </li>
                                              <li data-id="element-1604">
                                                {isEs ? 'Haga clic en "Seleccionar"' : 'Click "Select"'}
                                              </li>
                                            </ul>
                                          </div>
                                          <div className="bg-blue-50 rounded-lg p-3" data-id="element-1605">
                                            <p className="font-semibold text-haa-blue mb-1.5" data-id="element-1606">
                                              {isEs ? 'Paso 4 — Seleccionar una fecha' : 'Step 4 — Select a Date'}
                                            </p>
                                            <ul className="list-disc list-inside pl-1 space-y-1 text-gray-600" data-id="element-1607">
                                              <li data-id="element-1608">
                                                {isEs ? 'Se abrirá la página del calendario' : 'The calendar page will open'}
                                              </li>
                                              <li data-id="element-1609">
                                                {isEs ? 'Seleccione un día disponible en el calendario:' : 'Select an available day on the calendar:'}
                                                <ul className="list-disc list-inside pl-3 mt-0.5 space-y-0.5 text-gray-500" data-id="element-1610">
                                                  <li data-id="element-1611">
                                                    {isEs ? 'Días en blanco = disponibles' : 'Days in white = available'}
                                                  </li>
                                                  <li data-id="element-1612">
                                                    {isEs ? 'Días en morado = sin citas disponibles' : 'Days in purple = no appointments available'}
                                                  </li>
                                                  <li data-id="element-1613">
                                                    {isEs ? 'Días en rojo = el consulado no ofrece servicios' : 'Days in red = consulate does not offer services'}
                                                  </li>
                                                </ul>
                                              </li>
                                            </ul>
                                          </div>
                                          <div className="bg-blue-50 rounded-lg p-3" data-id="element-1614">
                                            <p className="font-semibold text-haa-blue mb-1.5" data-id="element-1615">
                                              {isEs ? 'Paso 5 — Confirmar su cita' : 'Step 5 — Confirm Your Appointment'}
                                            </p>
                                            <ul className="list-disc list-inside pl-1 space-y-1 text-gray-600" data-id="element-1616">
                                              <li data-id="element-1617">
                                                {isEs ? 'Una vez que seleccione un día, aparecerán todos los detalles de su cita' : 'Once you select a day, all of your appointment details will appear'}
                                              </li>
                                              <li data-id="element-1618">
                                                {isEs ? 'Desplácese hacia abajo y haga clic en "Ver Requisitos"' : 'Scroll down and click "View Requirements"'}
                                              </li>
                                              <li data-id="element-1619">
                                                {isEs ? 'Luego desplácese hacia abajo nuevamente y haga clic en "Programar Cita"' : 'Then scroll down again and click "Schedule Appointment"'}
                                              </li>
                                              <li data-id="element-1620">
                                                {isEs ? 'Aparecerá la confirmación de su cita' : 'Your appointment confirmation will appear'}
                                              </li>
                                              <li data-id="element-1621">
                                                {isEs ? 'Tome una captura de pantalla de la confirmación como prueba de su cita' : 'Take a screenshot of the confirmation to keep as proof of your appointment'}
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                    </motion.div>}
                                </AnimatePresence>
                              </div>;
                })}
                      </div>}
                    {tip.titleKey === 'consular.card4.title' && <div className="bg-blue-50 rounded-xl p-3 border border-blue-200 mb-1" data-id="element-1622">
                        <p className="font-semibold text-haa-blue mb-1.5 text-sm" data-id="element-1623">
                          {isEs ? 'Plataforma de Citas ACOS' : 'ACOS Appointment Platform'}
                        </p>
                        <p className="text-xs text-gray-600 leading-relaxed mb-3" data-id="element-1624">
                          {isEs ? 'Para los siguientes consulados:' : 'For the following consulates:'}{' '}
                          Tampa · Pittsburgh · Phoenix · Colorado · Los Angeles
                          · Kansas
                        </p>
                        {/* ACOS Appointment Guide dropdown nested inside */}
                        {tip.links.filter(l => l.info === 'la-appointments').map((l, idx) => {
                  const originalIndex = tip.links.findIndex(link => link.info === 'la-appointments');
                  return <div key={`acos-${idx}`} className="rounded-xl border overflow-hidden border-gray-200" data-id="element-1625">
                                <div className="flex items-center justify-between px-4 py-3 bg-gray-50 cursor-pointer" onClick={() => setOpenLinkInfo(openLinkInfo === originalIndex ? null : originalIndex)} role="button" data-id="element-1626">
                                  <span className={`inline-flex items-center gap-1 font-semibold text-sm ${tip.accentColor}`} data-id="element-1627">
                                    {isEs && l.labelEs ? l.labelEs : l.label}
                                  </span>
                                  <motion.div animate={{
                        rotate: openLinkInfo === originalIndex ? 180 : 0
                      }} transition={{
                        duration: 0.2
                      }} data-id="element-1628">
                                    <ChevronDownIcon className="w-4 h-4 text-gray-400" data-id="element-1629" />
                                  </motion.div>
                                </div>
                                <AnimatePresence initial={false} data-id="element-1630">
                                  {openLinkInfo === originalIndex && <motion.div initial={{
                        height: 0,
                        opacity: 0
                      }} animate={{
                        height: 'auto',
                        opacity: 1
                      }} exit={{
                        height: 0,
                        opacity: 0
                      }} transition={{
                        duration: 0.25,
                        ease: [0.16, 1, 0.3, 1]
                      }} className="overflow-hidden" data-id="element-1631">
                                      <div className="px-4 py-3 bg-white border-t border-gray-100 space-y-3 text-sm text-gray-600" data-id="element-1632">
                                        <p className="font-bold text-haa-blue" data-id="element-1633">
                                          {isEs ? '¿Deseas realizar una cita? Te explicamos paso a paso.' : "Want to make an appointment? Here's a step-by-step guide."}
                                        </p>
                                        <a href="https://asuntosconsulares.inm.gob.hn/#openModal" target="_blank" rel="noopener noreferrer" className="w-full inline-flex items-center justify-center gap-2 py-3 px-4 bg-gradient-to-r from-haa-blue to-haa-midblue text-white font-nunito font-bold text-sm rounded-xl shadow-md hover:shadow-lg transition-shadow" data-id="element-1634">
                                          📅 ACOS Appointment Platform{' '}
                                          <span className="text-xs font-normal opacity-80" data-id="element-1635">
                                            (Click Here)
                                          </span>
                                        </a>
                                        <div className="space-y-3" data-id="element-1636">
                                          <div className="bg-blue-50 rounded-lg p-3" data-id="element-1637">
                                            <p className="font-semibold text-haa-blue mb-1.5" data-id="element-1638">
                                              {isEs ? 'Paso 1 — Acceso a la plataforma' : 'Step 1 — Access the Platform'}
                                            </p>
                                            <ul className="list-disc list-inside pl-1 space-y-1 text-gray-600" data-id="element-1639">
                                              <li data-id="element-1640">
                                                {isEs ? 'Busca en Google: "Asuntos Consulares Honduras", haz clic en el primer resultado, o haz clic en el botón azul de arriba' : 'Search Google for: "Asuntos Consulares Honduras", click on the first result, or click on the blue button above'}
                                              </li>
                                              <li data-id="element-1641">
                                                {isEs ? 'Haz clic en "Acepto términos y condiciones"' : 'Click "I accept terms and conditions"'}
                                              </li>
                                              <li data-id="element-1642">
                                                {isEs ? 'Luego selecciona "Registrarse"' : 'Then select "Register"'}
                                              </li>
                                            </ul>
                                          </div>
                                          <div className="bg-blue-50 rounded-lg p-3" data-id="element-1643">
                                            <p className="font-semibold text-haa-blue mb-1.5" data-id="element-1644">
                                              {isEs ? 'Paso 2 — Creación de perfil' : 'Step 2 — Create Your Profile'}
                                            </p>
                                            <ul className="list-disc list-inside pl-1 space-y-1 text-gray-600" data-id="element-1645">
                                              <li data-id="element-1646">
                                                {isEs ? 'Haz clic en la bandera de Honduras 🇭🇳' : 'Click on the Honduras flag 🇭🇳'}
                                              </li>
                                              <li data-id="element-1647">
                                                {isEs ? 'Llena todos los datos de la persona que realizará el trámite (DNI, correo electrónico, etc.)' : 'Fill in all the information for the person who will be completing the process (DNI, email, etc.)'}
                                              </li>
                                              <li data-id="element-1648">
                                                {isEs ? 'Recuerda guardar tu contraseña' : 'Remember to save your password'}
                                              </li>
                                              <li data-id="element-1649">
                                                {isEs ? 'Haz clic en "Registrarse"' : 'Click "Register"'}
                                              </li>
                                            </ul>
                                          </div>
                                          <div className="bg-blue-50 rounded-lg p-3" data-id="element-1650">
                                            <p className="font-semibold text-haa-blue mb-1.5" data-id="element-1651">
                                              {isEs ? 'Paso 3 — Activación de perfil' : 'Step 3 — Activate Your Profile'}
                                            </p>
                                            <ul className="list-disc list-inside pl-1 space-y-1 text-gray-600" data-id="element-1652">
                                              <li data-id="element-1653">
                                                {isEs ? 'Abre el correo electrónico que registraste' : 'Open the email you registered with'}
                                              </li>
                                              <li data-id="element-1654">
                                                {isEs ? 'Recibirás un email de "ACOS"' : 'You will receive an email from "ACOS"'}
                                              </li>
                                              <li data-id="element-1655">
                                                {isEs ? 'Haz clic en la frase "Haz click aquí" para activar tu cuenta' : 'Click on "Click here" to activate your account'}
                                              </li>
                                            </ul>
                                          </div>
                                          <div className="bg-blue-50 rounded-lg p-3" data-id="element-1656">
                                            <p className="font-semibold text-haa-blue mb-1.5" data-id="element-1657">
                                              {isEs ? 'Paso 4 — Ingresar a tu perfil' : 'Step 4 — Log Into Your Profile'}
                                            </p>
                                            <ul className="list-disc list-inside pl-1 space-y-1 text-gray-600" data-id="element-1658">
                                              <li data-id="element-1659">
                                                {isEs ? 'Vuelve a ingresar a la plataforma' : 'Go back to the platform'}
                                              </li>
                                              <li data-id="element-1660">
                                                {isEs ? 'Ingresa tu correo electrónico y haz clic en "Siguiente"' : 'Enter your email and click "Next"'}
                                              </li>
                                              <li data-id="element-1661">
                                                {isEs ? 'Ingresa tu contraseña y haz clic en "Ingresar"' : 'Enter your password and click "Log In"'}
                                              </li>
                                              <li data-id="element-1662">
                                                {isEs ? 'Haz clic en "Nueva Cita"' : 'Click "New Appointment"'}
                                              </li>
                                            </ul>
                                          </div>
                                          <div className="bg-blue-50 rounded-lg p-3" data-id="element-1663">
                                            <p className="font-semibold text-haa-blue mb-1.5" data-id="element-1664">
                                              {isEs ? 'Paso 5 — Creación de cita' : 'Step 5 — Create Your Appointment'}
                                            </p>
                                            <ul className="list-disc list-inside pl-1 space-y-1 text-gray-600" data-id="element-1665">
                                              <li data-id="element-1666">
                                                {isEs ? 'Selecciona tu consulado' : 'Select your consulate'}
                                              </li>
                                              <li data-id="element-1667">
                                                {isEs ? 'Elige el servicio que deseas (Pasaporte, Carta poder, etc.)' : 'Choose the service you need (Passport, Power of Attorney, etc.)'}
                                              </li>
                                              <li data-id="element-1668">
                                                {isEs ? 'Haz clic en "Agregar Servicio"' : 'Click "Add Service"'}
                                              </li>
                                              <li data-id="element-1669">
                                                {isEs ? 'Selecciona una fecha disponible' : 'Select an available date'}
                                              </li>
                                              <li data-id="element-1670">
                                                {isEs ? 'Marca los servicios agregados' : 'Check the added services'}
                                              </li>
                                              <li data-id="element-1671">
                                                {isEs ? 'Haz clic en "Pagar" y sigue los pasos indicados' : 'Click "Pay" and follow the indicated steps'}
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                    </motion.div>}
                                </AnimatePresence>
                              </div>;
                })}
                      </div>}
                    {tip.links.map((l, i) => l.info === 'appointments' || l.info === 'la-appointments' || l.info === 'fees' || l.info === 'state-offices' ? null : l.info ? <div key={i} className={`rounded-xl border overflow-hidden ${l.info === 'complaint' ? 'border-red-300 shadow-sm' : l.info === 'positive-feedback' ? 'border-emerald-300 shadow-sm' : l.info === 'invite-official' ? 'border-indigo-300 shadow-sm' : l.info === 'detainee-locator' ? 'border-amber-300 shadow-sm' : l.info === 'migrant-protection' ? 'border-purple-300 shadow-sm' : l.info === 'repatriation' ? 'border-gray-500 shadow-sm' : l.info === 'dni-locator' ? 'border-sky-300 shadow-sm' : 'border-gray-200'}`} data-id="element-1672">
                          <div className={`flex items-center justify-between px-4 py-3 ${l.info === 'complaint' ? 'bg-gradient-to-r from-red-500 to-red-700 cursor-pointer' : l.info === 'positive-feedback' ? 'bg-gradient-to-r from-emerald-500 to-emerald-700 cursor-pointer' : l.info === 'invite-official' ? 'bg-gradient-to-r from-indigo-500 to-indigo-700 cursor-pointer' : l.info === 'detainee-locator' ? 'bg-gradient-to-r from-amber-500 to-orange-600 cursor-pointer' : l.info === 'migrant-protection' ? 'bg-gradient-to-r from-purple-400 to-purple-600 cursor-pointer' : l.info === 'repatriation' ? 'bg-gradient-to-r from-gray-700 to-gray-900 cursor-pointer' : l.info === 'dni-locator' ? 'bg-gradient-to-r from-sky-400 to-sky-600 cursor-pointer' : 'bg-gray-50'}`} onClick={() => setOpenLinkInfo(openLinkInfo === i ? null : i)} role="button" data-id="element-1673">
                            {l.info === 'complaint' ? <span className="inline-flex items-center gap-1.5 font-bold text-sm text-white uppercase tracking-wide" data-id="element-1674">
                                <ClipboardListIcon className="w-4 h-4" data-id="element-1675" />
                                {isEs && l.labelEs ? l.labelEs : l.label}
                              </span> : l.info === 'positive-feedback' ? <span className="inline-flex items-center gap-1.5 font-bold text-sm text-white uppercase tracking-wide" data-id="element-1676">
                                🌟 {isEs && l.labelEs ? l.labelEs : l.label}
                              </span> : l.info === 'invite-official' ? <span className="inline-flex items-center gap-1.5 font-bold text-sm text-white uppercase tracking-wide" data-id="element-1677">
                                📩 {isEs && l.labelEs ? l.labelEs : l.label}
                              </span> : l.info === 'detainee-locator' ? <span className="inline-flex items-center gap-1.5 font-bold text-sm text-white uppercase tracking-wide" data-id="element-1678">
                                🔍 {isEs && l.labelEs ? l.labelEs : l.label}
                              </span> : l.info === 'migrant-protection' ? <span className="inline-flex items-center gap-1.5 font-bold text-sm text-white uppercase tracking-wide" data-id="element-1679">
                                🛡️ {isEs && l.labelEs ? l.labelEs : l.label}
                              </span> : l.info === 'repatriation' ? <span className="inline-flex items-center gap-1.5 font-bold text-sm text-white uppercase tracking-wide" data-id="element-1680">
                                ✈️ {isEs && l.labelEs ? l.labelEs : l.label}
                              </span> : l.info === 'dni-locator' ? <span className="inline-flex items-center gap-1.5 font-bold text-sm text-white uppercase tracking-wide" data-id="element-1681">
                                🪪 {isEs && l.labelEs ? l.labelEs : l.label}
                              </span> : <span className={`inline-flex items-center gap-1 font-semibold text-sm ${tip.accentColor}`} data-id="element-1682">
                                {isEs && l.labelEs ? l.labelEs : l.label}
                              </span>}
                            <motion.div animate={{
                    rotate: openLinkInfo === i ? 180 : 0
                  }} transition={{
                    duration: 0.2
                  }} data-id="element-1683">
                              <ChevronDownIcon className={`w-4 h-4 ${l.info === 'complaint' || l.info === 'positive-feedback' || l.info === 'invite-official' || l.info === 'migrant-protection' || l.info === 'repatriation' || l.info === 'detainee-locator' || l.info === 'dni-locator' ? 'text-white' : 'text-gray-400'}`} data-id="element-1684" />
                            </motion.div>
                          </div>
                          <AnimatePresence initial={false} data-id="element-1685">
                            {openLinkInfo === i && <motion.div initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.25,
                    ease: [0.16, 1, 0.3, 1]
                  }} className="overflow-hidden" data-id="element-1686">
                                <div className="px-4 py-4 bg-white border-t border-gray-100" data-id="element-1687">
                                  {l.info === 'fees' ? <div className="space-y-1" data-id="element-1688">
                                      <p className="text-sm font-bold text-center py-2 px-3 bg-green-100 text-green-700 rounded-lg mb-3" data-id="element-1689">
                                        {isEs ? 'ℹ️ Aranceles vigentes a partir de 2026.' : 'ℹ️ Fees current as of 2026.'}
                                      </p>
                                      {feeItems.map((item, idx) => <div key={idx} className="border-b border-gray-50 last:border-none" data-id="element-1690">
                                          <div className={`flex items-center justify-between py-2 ${item.subContent ? 'cursor-pointer hover:bg-gray-50 rounded-lg px-2 -mx-2 transition-colors' : ''}`} onClick={item.subContent ? () => setOpenFeeSubItem(openFeeSubItem === idx ? null : idx) : undefined} role={item.subContent ? 'button' : undefined} data-id="element-1691">
                                            <span className="text-sm text-gray-600 pr-2" data-id="element-1692">
                                              {item.service}
                                            </span>
                                            <div className="flex items-center gap-1 flex-shrink-0" data-id="element-1693">
                                              <span className={`text-sm font-bold ${tip.accentColor}`} data-id="element-1694">
                                                {item.price}
                                              </span>
                                              {item.subContent && <motion.div animate={{
                                rotate: openFeeSubItem === idx ? 180 : 0
                              }} transition={{
                                duration: 0.2
                              }} className="ml-1 text-gray-400" data-id="element-1695">
                                                  <ChevronDownIcon className="w-3.5 h-3.5" data-id="element-1696" />
                                                </motion.div>}
                                            </div>
                                          </div>
                                          {item.subContent && <AnimatePresence initial={false} data-id="element-1697">
                                              {openFeeSubItem === idx && <motion.div initial={{
                              height: 0,
                              opacity: 0
                            }} animate={{
                              height: 'auto',
                              opacity: 1
                            }} exit={{
                              height: 0,
                              opacity: 0
                            }} transition={{
                              duration: 0.25,
                              ease: [0.16, 1, 0.3, 1]
                            }} className="overflow-hidden" data-id="element-1698">
                                                  <div className="pb-3 pt-2 px-2 bg-gray-50 rounded-lg mb-1 text-sm" data-id="element-1699">
                                                    {item.subContent}
                                                  </div>
                                                </motion.div>}
                                            </AnimatePresence>}
                                        </div>)}
                                    </div> : l.info === 'la-appointments' ? <div className="space-y-3 text-sm text-gray-600" data-id="element-1700">
                                      <p className="font-bold text-haa-blue" data-id="element-1701">
                                        {isEs ? '¿Deseas realizar una cita en el Consulado General de Honduras en Los Ángeles? Te explicamos paso a paso.' : "Want to make an appointment at the Consulate General of Honduras in Los Angeles? Here's a step-by-step guide."}
                                      </p>
                                      <a href="https://asuntosconsulares.inm.gob.hn/#openModal" target="_blank" rel="noopener noreferrer" className="w-full inline-flex items-center justify-center gap-2 py-3 px-4 bg-gradient-to-r from-haa-blue to-haa-midblue text-white font-nunito font-bold text-sm rounded-xl shadow-md hover:shadow-lg transition-shadow" data-id="element-1702">
                                        📅{' '}
                                        {isEs ? 'Ir a la Plataforma de Citas' : 'Go to Appointment Platform'}
                                      </a>
                                      <div className="space-y-3" data-id="element-1703">
                                        <div className="bg-blue-50 rounded-lg p-3" data-id="element-1704">
                                          <p className="font-semibold text-haa-blue mb-1.5" data-id="element-1705">
                                            {isEs ? 'Paso 1 — Acceso a la plataforma' : 'Step 1 — Access the Platform'}
                                          </p>
                                          <ul className="list-disc list-inside pl-1 space-y-1 text-gray-600" data-id="element-1706">
                                            <li data-id="element-1707">
                                              {isEs ? 'Busca en Google: "Asuntos Consulares Honduras", haz clic en el primer resultado, o haz clic en el botón azul de arriba' : 'Search Google for: "Asuntos Consulares Honduras", click on the first result, or click on the blue button above'}
                                            </li>
                                            <li data-id="element-1708">
                                              {isEs ? 'Haz clic en "Acepto términos y condiciones"' : 'Click "I accept terms and conditions"'}
                                            </li>
                                            <li data-id="element-1709">
                                              {isEs ? 'Luego selecciona "Registrarse"' : 'Then select "Register"'}
                                            </li>
                                          </ul>
                                        </div>
                                        <div className="bg-blue-50 rounded-lg p-3" data-id="element-1710">
                                          <p className="font-semibold text-haa-blue mb-1.5" data-id="element-1711">
                                            {isEs ? 'Paso 2 — Creación de perfil' : 'Step 2 — Create Your Profile'}
                                          </p>
                                          <ul className="list-disc list-inside pl-1 space-y-1 text-gray-600" data-id="element-1712">
                                            <li data-id="element-1713">
                                              {isEs ? 'Haz clic en la bandera de Honduras 🇭🇳' : 'Click on the Honduras flag 🇭🇳'}
                                            </li>
                                            <li data-id="element-1714">
                                              {isEs ? 'Llena todos los datos de la persona que realizará el trámite (DNI, correo electrónico, etc.)' : 'Fill in all the information for the person who will be completing the process (DNI, email, etc.)'}
                                            </li>
                                            <li data-id="element-1715">
                                              {isEs ? 'Recuerda guardar tu contraseña' : 'Remember to save your password'}
                                            </li>
                                            <li data-id="element-1716">
                                              {isEs ? 'Haz clic en "Registrarse"' : 'Click "Register"'}
                                            </li>
                                          </ul>
                                        </div>
                                        <div className="bg-blue-50 rounded-lg p-3" data-id="element-1717">
                                          <p className="font-semibold text-haa-blue mb-1.5" data-id="element-1718">
                                            {isEs ? 'Paso 3 — Activación de perfil' : 'Step 3 — Activate Your Profile'}
                                          </p>
                                          <ul className="list-disc list-inside pl-1 space-y-1 text-gray-600" data-id="element-1719">
                                            <li data-id="element-1720">
                                              {isEs ? 'Abre el correo electrónico que registraste' : 'Open the email you registered with'}
                                            </li>
                                            <li data-id="element-1721">
                                              {isEs ? 'Recibirás un email de "ACOS"' : 'You will receive an email from "ACOS"'}
                                            </li>
                                            <li data-id="element-1722">
                                              {isEs ? 'Haz clic en la frase "Haz click aquí" para activar tu cuenta' : 'Click on "Click here" to activate your account'}
                                            </li>
                                          </ul>
                                        </div>
                                        <div className="bg-blue-50 rounded-lg p-3" data-id="element-1723">
                                          <p className="font-semibold text-haa-blue mb-1.5" data-id="element-1724">
                                            {isEs ? 'Paso 4 — Ingresar a tu perfil' : 'Step 4 — Log Into Your Profile'}
                                          </p>
                                          <ul className="list-disc list-inside pl-1 space-y-1 text-gray-600" data-id="element-1725">
                                            <li data-id="element-1726">
                                              {isEs ? 'Vuelve a ingresar a la plataforma' : 'Go back to the platform'}
                                            </li>
                                            <li data-id="element-1727">
                                              {isEs ? 'Ingresa tu correo electrónico y haz clic en "Siguiente"' : 'Enter your email and click "Next"'}
                                            </li>
                                            <li data-id="element-1728">
                                              {isEs ? 'Ingresa tu contraseña y haz clic en "Ingresar"' : 'Enter your password and click "Log In"'}
                                            </li>
                                            <li data-id="element-1729">
                                              {isEs ? 'Haz clic en "Nueva Cita"' : 'Click "New Appointment"'}
                                            </li>
                                          </ul>
                                        </div>
                                        <div className="bg-blue-50 rounded-lg p-3" data-id="element-1730">
                                          <p className="font-semibold text-haa-blue mb-1.5" data-id="element-1731">
                                            {isEs ? 'Paso 5 — Creación de cita' : 'Step 5 — Create Your Appointment'}
                                          </p>
                                          <ul className="list-disc list-inside pl-1 space-y-1 text-gray-600" data-id="element-1732">
                                            <li data-id="element-1733">
                                              {isEs ? 'Selecciona el Consulado de Los Ángeles' : 'Select the Los Angeles Consulate'}
                                            </li>
                                            <li data-id="element-1734">
                                              {isEs ? 'Elige el servicio que deseas (Pasaporte, Carta poder, etc.)' : 'Choose the service you need (Passport, Power of Attorney, etc.)'}
                                            </li>
                                            <li data-id="element-1735">
                                              {isEs ? 'Haz clic en "Agregar Servicio"' : 'Click "Add Service"'}
                                            </li>
                                            <li data-id="element-1736">
                                              {isEs ? 'Selecciona una fecha disponible' : 'Select an available date'}
                                            </li>
                                            <li data-id="element-1737">
                                              {isEs ? 'Marca los servicios agregados' : 'Check the added services'}
                                            </li>
                                            <li data-id="element-1738">
                                              {isEs ? 'Haz clic en "Pagar" y sigue los pasos indicados' : 'Click "Pay" and follow the indicated steps'}
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div> : l.info === 'complaint' ? <div className="space-y-3 text-sm text-gray-600" data-id="element-1739">
                                      <p className="leading-relaxed" data-id="element-1740">
                                        {isEs ? 'Si tuvo una experiencia negativa con un servicio consular, puede reportarla a la Asociación Hondureño-Americana.' : 'If you had a negative experience with a consular service, you can report it to the Honduran-American Association.'}
                                      </p>
                                      <motion.button onClick={() => {
                          setExpandedModal(false);
                          setTimeout(() => setComplaintModalOpen(true), 200);
                        }} whileHover={{
                          scale: 1.02
                        }} whileTap={{
                          scale: 0.98
                        }} className="w-full mt-2 py-3 px-4 bg-gradient-to-r from-red-500 to-red-700 text-white font-nunito font-bold text-sm rounded-xl shadow-md hover:shadow-lg transition-shadow flex items-center justify-center gap-2" data-id="element-1741">
                                        <ClipboardListIcon className="w-4 h-4" data-id="element-1742" />
                                        {isEs ? 'Presentar una Queja' : 'File a Complaint'}
                                      </motion.button>
                                    </div> : l.info === 'positive-feedback' ? <div className="space-y-3 text-sm text-gray-600" data-id="element-1743">
                                      <p className="leading-relaxed" data-id="element-1744">
                                        {isEs ? '¡Nos encanta escuchar sobre experiencias positivas!' : 'We love hearing about positive experiences!'}
                                      </p>
                                      <motion.button onClick={() => {
                          setExpandedModal(false);
                          setTimeout(() => setPositiveFeedbackModalOpen(true), 200);
                        }} whileHover={{
                          scale: 1.02
                        }} whileTap={{
                          scale: 0.98
                        }} className="w-full mt-2 py-3 px-4 bg-gradient-to-r from-emerald-500 to-emerald-700 text-white font-nunito font-bold text-sm rounded-xl shadow-md hover:shadow-lg transition-shadow flex items-center justify-center gap-2" data-id="element-1745">
                                        🌟{' '}
                                        {isEs ? 'Compartir Experiencia Positiva' : 'Share Positive Experience'}
                                      </motion.button>
                                    </div> : l.info === 'invite-official' ? <div className="space-y-3 text-sm text-gray-600" data-id="element-1746">
                                      <p className="leading-relaxed" data-id="element-1747">
                                        {isEs ? 'Nos encantaría ayudarle a conectar con su oficial consular local o la Embajada para eventos de mayor perfil. Complete el formulario y finalice a través de WhatsApp.' : 'We would love to help you connect with your local consular official or the Embassy for bigger profile events. Submit the form and finalize via WhatsApp.'}
                                      </p>
                                      <motion.button onClick={() => {
                          setExpandedModal(false);
                          setTimeout(() => setInviteModalOpen(true), 200);
                        }} whileHover={{
                          scale: 1.02
                        }} whileTap={{
                          scale: 0.98
                        }} className="w-full mt-2 py-3 px-4 bg-gradient-to-r from-indigo-500 to-indigo-700 text-white font-nunito font-bold text-sm rounded-xl shadow-md hover:shadow-lg transition-shadow flex items-center justify-center gap-2" data-id="element-1748">
                                        📩{' '}
                                        {isEs ? 'Enviar Solicitud de Invitación' : 'Submit Invitation Request'}
                                      </motion.button>
                                    </div> : l.info === 'detainee-locator' ? <div className="space-y-3 text-sm text-gray-600" data-id="element-1749">
                                      <p className="leading-relaxed" data-id="element-1750">
                                        {isEs ? 'Si un familiar o amigo ha sido detenido por el Servicio de Inmigración y Control de Aduanas (ICE), puede usar el Sistema de Localización de Detenidos en Línea para buscar su ubicación y estado de detención. Necesitará el nombre completo y país de nacimiento de la persona, o su número de registro de extranjero (A-Number).' : "If a family member or friend has been detained by U.S. Immigration and Customs Enforcement (ICE), you can use the Online Detainee Locator System to search for their location and detention status. You will need the person's full name and country of birth, or their Alien Registration Number (A-Number)."}
                                      </p>
                                      <a href="https://locator.ice.gov/odls/#/search" target="_blank" rel="noopener noreferrer" className="w-full mt-2 inline-flex items-center justify-center gap-2 py-3 px-4 bg-gradient-to-r from-amber-500 to-orange-600 text-white font-nunito font-bold text-sm rounded-xl shadow-md hover:shadow-lg transition-shadow" data-id="element-1751">
                                        🔍{' '}
                                        {isEs ? 'Buscar a un Detenido' : 'Search for a Detainee'}
                                      </a>
                                      <div className="bg-blue-50 rounded-lg p-3 border border-blue-200 mt-2" data-id="element-1752">
                                        <p className="text-gray-600 leading-relaxed" data-id="element-1753">
                                          {isEs ? '📞 Si no puede comunicarse con su consulado local, envíe un mensaje al +1-703-313-1465 con una explicación de su situación.' : '📞 If you are not able to get in contact with your local consulate, please send a message to +1-703-313-1465 with an explanation of your situation.'}
                                        </p>
                                      </div>
                                    </div> : l.info === 'migrant-protection' ? <div className="space-y-3 text-sm text-gray-600" data-id="element-1754">
                                      <p className="font-bold text-purple-700 uppercase tracking-wide" data-id="element-1755">
                                        {isEs ? '🛡️ Servicio de Protección al Migrante' : '🛡️ Immigrant Protection Services'}
                                      </p>
                                      <p className="leading-relaxed" data-id="element-1756">
                                        {isEs ? 'Los consulados hondureños ofrecen servicios de protección y asistencia a connacionales en situaciones migratorias. A continuación se detallan los principales servicios disponibles:' : 'Honduran consulates provide protection and assistance services to nationals facing immigration-related situations. Below are the key services available:'}
                                      </p>
                                      <ul className="space-y-2.5 pl-1" data-id="element-1757">
                                        <li className="flex items-start gap-2" data-id="element-1758">
                                          <span className="text-purple-500 mt-0.5" data-id="element-1759">
                                            •
                                          </span>
                                          <span data-id="element-1760">
                                            <strong className="text-gray-700" data-id="element-1761">
                                              {isEs ? 'Visitas a centros migratorios' : 'Immigration Detention Center Visits'}
                                            </strong>
                                            <br data-id="element-1762" />
                                            <span className="text-gray-500" data-id="element-1763">
                                              {isEs ? 'Personal consular realiza visitas periódicas a centros de detención migratoria para verificar el bienestar de connacionales detenidos.' : 'Consular staff conduct regular visits to immigration detention facilities to verify the well-being of detained Honduran nationals.'}
                                            </span>
                                          </span>
                                        </li>
                                        <li className="flex items-start gap-2" data-id="element-1764">
                                          <span className="text-purple-500 mt-0.5" data-id="element-1765">
                                            •
                                          </span>
                                          <span data-id="element-1766">
                                            <strong className="text-gray-700" data-id="element-1767">
                                              {isEs ? 'Verificación de detenidos por ICE' : 'ICE Detainee Verification'}
                                            </strong>
                                            <br data-id="element-1768" />
                                            <span className="text-gray-500" data-id="element-1769">
                                              {isEs ? 'Asistencia para localizar y confirmar la situación de connacionales bajo custodia del Servicio de Inmigración y Control de Aduanas (ICE).' : 'Assistance in locating and confirming the status of nationals held in U.S. Immigration and Customs Enforcement (ICE) custody.'}
                                            </span>
                                          </span>
                                        </li>
                                        <li className="flex items-start gap-2" data-id="element-1770">
                                          <span className="text-purple-500 mt-0.5" data-id="element-1771">
                                            •
                                          </span>
                                          <span data-id="element-1772">
                                            <strong className="text-gray-700" data-id="element-1773">
                                              {isEs ? 'Reunificaciones familiares' : 'Family Reunification'}
                                            </strong>
                                            <br data-id="element-1774" />
                                            <span className="text-gray-500" data-id="element-1775">
                                              {isEs ? 'Apoyo en la coordinación y gestión de procesos de reunificación familiar para connacionales separados durante procedimientos migratorios.' : 'Support in coordinating and managing family reunification processes for nationals separated during immigration proceedings.'}
                                            </span>
                                          </span>
                                        </li>
                                        <li className="flex items-start gap-2" data-id="element-1776">
                                          <span className="text-purple-500 mt-0.5" data-id="element-1777">
                                            •
                                          </span>
                                          <span data-id="element-1778">
                                            <strong className="text-gray-700" data-id="element-1779">
                                              {isEs ? 'Representación de menores en audiencias' : 'Legal Representation for Minors in Hearings'}
                                            </strong>
                                            <br data-id="element-1780" />
                                            <span className="text-gray-500" data-id="element-1781">
                                              {isEs ? 'Gestión de representación consular para menores no acompañados que enfrentan audiencias migratorias.' : 'Consular representation for unaccompanied minors facing immigration court hearings.'}
                                            </span>
                                          </span>
                                        </li>
                                        <li className="flex items-start gap-2" data-id="element-1782">
                                          <span className="text-purple-500 mt-0.5" data-id="element-1783">
                                            •
                                          </span>
                                          <span data-id="element-1784">
                                            <strong className="text-gray-700" data-id="element-1785">
                                              {isEs ? 'Apoyo a connacionales enfermos' : 'Assistance for Ill Nationals'}
                                            </strong>
                                            <br data-id="element-1786" />
                                            <span className="text-gray-500" data-id="element-1787">
                                              {isEs ? 'Asistencia y acompañamiento a connacionales hospitalizados o que enfrentan emergencias médicas en Estados Unidos.' : 'Assistance and support for Honduran nationals who are hospitalized or facing medical emergencies in the United States.'}
                                            </span>
                                          </span>
                                        </li>
                                      </ul>
                                      <div className="bg-purple-50 rounded-lg p-3 border border-purple-200 mt-2" data-id="element-1788">
                                        <p className="font-semibold text-purple-700 mb-1" data-id="element-1789">
                                          {isEs ? '⚠️ Importante' : '⚠️ Important'}
                                        </p>
                                        <p className="text-gray-600 leading-relaxed" data-id="element-1790">
                                          {isEs ? 'Los consulados no tienen autoridad para intervenir en procedimientos legales migratorios ni en decisiones de las cortes de inmigración. Los servicios de protección se limitan a asistencia consular, verificación de bienestar y apoyo humanitario.' : 'Consulates do not have the authority to intervene in immigration legal proceedings or immigration court decisions. Protection services are limited to consular assistance, welfare verification, and humanitarian support.'}
                                        </p>
                                      </div>
                                      <div className="bg-blue-50 rounded-lg p-3 border border-blue-200 mt-2" data-id="element-1791">
                                        <p className="text-gray-600 leading-relaxed" data-id="element-1792">
                                          {isEs ? '📞 Si no puede comunicarse con su consulado local, envíe un mensaje al +1-703-313-1465 con una explicación de su situación.' : '📞 If you are not able to get in contact with your local consulate, please send a message to +1-703-313-1465 with an explanation of your situation.'}
                                        </p>
                                      </div>
                                    </div> : l.info === 'repatriation' ? <div className="space-y-3 text-sm text-gray-600" data-id="element-1793">
                                      <p className="font-bold text-gray-800 uppercase tracking-wide" data-id="element-1794">
                                        {isEs ? '✈️ Servicios de Repatriación' : '✈️ Repatriation Services'}
                                      </p>
                                      <p className="leading-relaxed" data-id="element-1795">
                                        {isEs ? 'En caso de fallecimiento de un connacional en Estados Unidos, los consulados hondureños coordinan el proceso de repatriación de restos mortales a Honduras. El servicio cubre los siguientes aspectos:' : 'In the event of a Honduran national passing away in the United States, Honduran consulates coordinate the repatriation of remains to Honduras. The service covers the following:'}
                                      </p>
                                      <div className="bg-gray-100 rounded-lg p-3 border border-gray-300" data-id="element-1796">
                                        <p className="font-semibold text-gray-800 mb-2 uppercase tracking-wide" data-id="element-1797">
                                          {isEs ? 'Cobertura del Servicio' : 'Service Coverage'}
                                        </p>
                                        <ul className="space-y-2" data-id="element-1798">
                                          <li className="flex items-start gap-2" data-id="element-1799">
                                            <span className="text-gray-600 mt-0.5" data-id="element-1800">
                                              •
                                            </span>
                                            <span data-id="element-1801">
                                              <strong className="text-gray-700" data-id="element-1802">
                                                {isEs ? 'Preparación del cuerpo' : 'Body Preparation'}
                                              </strong>
                                              <br data-id="element-1803" />
                                              <span className="text-gray-500" data-id="element-1804">
                                                {isEs ? 'Coordinación de los servicios funerarios necesarios para la preparación y preservación de los restos.' : 'Coordination of funeral services required for the preparation and preservation of remains.'}
                                              </span>
                                            </span>
                                          </li>
                                          <li className="flex items-start gap-2" data-id="element-1805">
                                            <span className="text-gray-600 mt-0.5" data-id="element-1806">
                                              •
                                            </span>
                                            <span data-id="element-1807">
                                              <strong className="text-gray-700" data-id="element-1808">
                                                {isEs ? 'Retiro del cuerpo de la morgue' : 'Removal of Remains from the Morgue'}
                                              </strong>
                                              <br data-id="element-1809" />
                                              <span className="text-gray-500" data-id="element-1810">
                                                {isEs ? 'Gestión y coordinación del retiro de los restos de la morgue o institución correspondiente.' : 'Management and coordination of the removal of remains from the morgue or corresponding institution.'}
                                              </span>
                                            </span>
                                          </li>
                                          <li className="flex items-start gap-2" data-id="element-1811">
                                            <span className="text-gray-600 mt-0.5" data-id="element-1812">
                                              •
                                            </span>
                                            <span data-id="element-1813">
                                              <strong className="text-gray-700" data-id="element-1814">
                                                {isEs ? 'Tramitación de documentos' : 'Document Processing'}
                                              </strong>
                                              <br data-id="element-1815" />
                                              <span className="text-gray-500" data-id="element-1816">
                                                {isEs ? 'Procesamiento de toda la documentación legal y consular requerida para la repatriación, incluyendo certificados de defunción y permisos de traslado.' : 'Processing of all legal and consular documentation required for repatriation, including death certificates and transfer permits.'}
                                              </span>
                                            </span>
                                          </li>
                                          <li className="flex items-start gap-2" data-id="element-1817">
                                            <span className="text-gray-600 mt-0.5" data-id="element-1818">
                                              •
                                            </span>
                                            <span data-id="element-1819">
                                              <strong className="text-gray-700" data-id="element-1820">
                                                {isEs ? 'Envío del cuerpo a Honduras' : 'Shipment of Remains to Honduras'}
                                              </strong>
                                              <br data-id="element-1821" />
                                              <span className="text-gray-500" data-id="element-1822">
                                                {isEs ? 'Coordinación del traslado aéreo de los restos mortales hasta Honduras para su entrega a los familiares.' : 'Coordination of the air transport of remains to Honduras for delivery to family members.'}
                                              </span>
                                            </span>
                                          </li>
                                        </ul>
                                      </div>
                                      <div className="bg-amber-50 rounded-lg p-3 border border-amber-200 mt-1" data-id="element-1823">
                                        <p className="font-semibold text-amber-700 mb-1" data-id="element-1824">
                                          {isEs ? 'ℹ️ Nota' : 'ℹ️ Note'}
                                        </p>
                                        <p className="text-gray-600 leading-relaxed" data-id="element-1825">
                                          {isEs ? 'El servicio de repatriación cubre únicamente los aspectos mencionados anteriormente. Para más información o para iniciar el proceso, comuníquese directamente con el consulado más cercano.' : 'The repatriation service covers only the aspects listed above. For more information or to initiate the process, please contact your nearest consulate directly.'}
                                        </p>
                                      </div>
                                      <div className="bg-blue-50 rounded-lg p-3 border border-blue-200 mt-2" data-id="element-1826">
                                        <p className="text-gray-600 leading-relaxed" data-id="element-1827">
                                          {isEs ? '📞 Si no puede comunicarse con su consulado local, envíe un mensaje al +1-703-313-1465 con una explicación de su situación.' : '📞 If you are not able to get in contact with your local consulate, please send a message to +1-703-313-1465 with an explanation of your situation.'}
                                        </p>
                                      </div>
                                    </div> : l.info === 'dni-locator' ? <div className="space-y-3 text-sm text-gray-600" data-id="element-1828">
                                      <p className="font-bold text-sky-700 uppercase tracking-wide" data-id="element-1829">
                                        {isEs ? '🪪 Búsqueda de Entrega de DNI' : '🪪 DNI Locator Search'}
                                      </p>
                                      <p className="leading-relaxed" data-id="element-1830">
                                        {isEs ? 'Utilice esta herramienta del Registro Nacional de las Personas (RNP) para verificar el estado de entrega de su Documento Nacional de Identidad (DNI) y localizar dónde recogerlo.' : 'Use this tool from the National Registry of Persons (RNP) to check the delivery status of your National Identification Card (DNI) and locate where to pick it up.'}
                                      </p>
                                      <a href="https://entregadni.rnp.hn/dni/#/" target="_blank" rel="noopener noreferrer" className="w-full inline-flex items-center justify-center gap-2 py-3 px-4 bg-gradient-to-r from-sky-500 to-sky-600 text-white font-nunito font-bold text-sm rounded-xl shadow-md hover:shadow-lg transition-shadow" data-id="element-1831">
                                        🪪{' '}
                                        {isEs ? 'Buscar Estado de DNI' : 'Search DNI Status'}
                                      </a>
                                    </div> : l.info === 'state-offices' ? <div className="space-y-2 text-sm" data-id="element-1832">
                                      <p className="font-bold text-gray-700 uppercase tracking-wide mb-2" data-id="element-1833">
                                        {isEs ? 'Oficinas de Apostilla por Estado' : 'State Apostille Offices'}
                                      </p>
                                      {[{
                          state: 'U.S. Department of State Apostille Office',
                          addresses: ['600 19th Street NW, Washington, DC 20006'],
                          phone: '(202) 485-8000'
                        }, {
                          state: 'Arizona',
                          addresses: ['1700 W Washington St, Phoenix, AZ 85007', '400 West Congress Street, Suite 221, Tucson, AZ 85701'],
                          phone: '(602) 542-4285'
                        }, {
                          state: 'Arkansas',
                          addresses: ['1401 W Capitol Ave #250, Little Rock, AR 72201'],
                          phone: '(501) 682-3409'
                        }, {
                          state: 'California',
                          addresses: ['1500 11th Street, 3rd Floor, Sacramento, CA 95814', '300 South Spring Street, Room 12513, Los Angeles, CA 90013'],
                          phones: [{
                            label: 'Sacramento',
                            number: '(916) 653-6814'
                          }, {
                            label: 'Los Angeles',
                            number: '(213) 897-5310'
                          }]
                        }, {
                          state: 'Colorado',
                          addresses: ['1700 Broadway, Suite 550, Denver, CO 80290'],
                          phone: '(303) 894-2200'
                        }, {
                          state: 'Connecticut',
                          addresses: ['165 Capitol Ave #1000, Hartford, CT 06106'],
                          phone: '(860) 509-6002'
                        }, {
                          state: 'Delaware',
                          addresses: ['401 Federal Street - Suite 4, Dover, DE 19901'],
                          phone: '(302) 739-3073'
                        }, {
                          state: 'Florida',
                          addresses: ['2415 N. Monroe Street, Suite 810, Tallahassee, FL 32303'],
                          phone: '(850) 245-6000'
                        }, {
                          state: 'Georgia',
                          addresses: ['1875 Century Boulevard, Suite 100, Atlanta, GA 30345'],
                          phone: '(404) 327-6023'
                        }, {
                          state: 'Illinois',
                          addresses: ['69 W. Washington St., Suite 1240, Chicago, IL 60602', '2701 S. Dirksen Parkway, Springfield, IL 62723'],
                          phones: [{
                            label: 'Chicago',
                            number: '(312) 814-8218'
                          }, {
                            label: 'Springfield',
                            number: '(217) 782-7017'
                          }]
                        }, {
                          state: 'Kansas',
                          addresses: ['915 SW Harrison Street, Topeka, KS 66612'],
                          phone: '(785) 296-4564'
                        }, {
                          state: 'Louisiana',
                          addresses: ['8585 Archives Ave., Baton Rouge, LA 70809'],
                          phone: '(225) 922-0330'
                        }, {
                          state: 'Maryland',
                          addresses: ['Wineland Building, 1st Fl., Annapolis, MD 21401'],
                          phone: '(410) 974-5521'
                        }, {
                          state: 'Massachusetts',
                          addresses: ['One Ashburton Place, Room 1719, Boston, MA 02108'],
                          phone: '(617) 727-2836'
                        }, {
                          state: 'Nevada',
                          addresses: ['101 N Carson Street, Suite 3, Carson City, NV 89701'],
                          phone: '(775) 684-5708'
                        }, {
                          state: 'New Jersey',
                          addresses: ['33 West State Street, 5th Floor, Trenton, NJ 08608-1214'],
                          phone: '(609) 292-9292'
                        }, {
                          state: 'New York',
                          addresses: ['123 William St #2, New York, NY 10038'],
                          phone: '(518) 474-4429'
                        }, {
                          state: 'North Carolina',
                          addresses: ['2 South Salisbury Street, Raleigh, NC 27601'],
                          phone: '(919) 814-5400'
                        }, {
                          state: 'Pennsylvania',
                          addresses: ['210 North Office Building, Harrisburg, PA 17120'],
                          phone: '(717) 787-5280'
                        }, {
                          state: 'Texas',
                          addresses: ['1019 Brazos, Austin, TX 78701'],
                          phone: '(512) 463-5705'
                        }, {
                          state: 'Virginia',
                          addresses: ['1111 East Broad Street, Richmond, VA 23219'],
                          phone: '(804) 692-0114'
                        }, {
                          state: 'Washington D.C.',
                          addresses: ['899 North Capitol Street, NE, Suite 8100'],
                          phone: '(202) 727-3117'
                        }].map((entry: any, si: number) => <div key={si} className="border-b border-gray-50 last:border-none pb-1.5 last:pb-0" data-id="element-1834">
                                          <p className="font-semibold text-emerald-600 mb-0.5" data-id="element-1835">
                                            {entry.state}
                                          </p>
                                          {entry.addresses.length > 0 ? <ul className="space-y-0.5" data-id="element-1836">
                                              {entry.addresses.map((addr: string, ai: number) => <li key={ai} className="flex items-start gap-1 text-gray-500" data-id="element-1837">
                                                    <MapPinIcon className="w-3 h-3 text-gray-300 flex-shrink-0 mt-0.5" data-id="element-1838" />
                                                    <span data-id="element-1839">{addr}</span>
                                                  </li>)}
                                            </ul> : <p className="text-gray-400 italic pl-1" data-id="element-1840">
                                              {isEs ? 'Dirección próximamente' : 'Address coming soon'}
                                            </p>}
                                          {entry.phone && <div className="flex items-center gap-1 text-gray-500 mt-0.5" data-id="element-1841">
                                              <PhoneIcon className="w-3 h-3 text-gray-400 flex-shrink-0" data-id="element-1842" />
                                              <a href={`tel:${entry.phone.replace(/[^0-9+]/g, '')}`} className="text-emerald-600 font-semibold hover:underline" data-id="element-1843">
                                                {entry.phone}
                                              </a>
                                            </div>}
                                          {entry.phones && entry.phones.map((p: {
                            label: string;
                            number: string;
                          }, pi: number) => <div key={pi} className="flex items-center gap-1 text-gray-500 mt-0.5" data-id="element-1844">
                                                  <PhoneIcon className="w-3 h-3 text-gray-400 flex-shrink-0" data-id="element-1845" />
                                                  <a href={`tel:${p.number.replace(/[^0-9+]/g, '')}`} className="text-emerald-600 font-semibold hover:underline" data-id="element-1846">
                                                    {p.label}: {p.number}
                                                  </a>
                                                </div>)}
                                        </div>)}
                                    </div> : null}
                                </div>
                              </motion.div>}
                          </AnimatePresence>
                        </div> : <a key={i} href={l.url} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center gap-1 font-semibold text-sm ${tip.accentColor} hover:underline`} data-id="element-1847">
                          {isEs && l.labelEs ? l.labelEs : l.label} →
                        </a>)}
                  </div>}

                {tip.consulates && tip.consulates.length > 0 && <div className="mt-4 flex flex-col gap-3" data-id="element-1848">
                    {/* Consulate Map */}
                    <div className="rounded-xl overflow-hidden border border-gray-200 shadow-sm" data-id="element-1849">
                      <ConsulateMap consulates={tip.consulates} accentColor={tip.accentColor} expanded={true} data-id="element-1850" />
                    </div>
                    <p className="font-nunito text-gray-400 text-xs text-center -mt-1" data-id="element-1851">
                      {isEs ? 'Haga clic en los marcadores para ver detalles' : 'Click markers for details'}
                    </p>

                    {tip.consulates.filter(c => c.isEmbassy).map((consulate, i) => <div key={`exp-embassy-${i}`} className="rounded-xl border border-gray-200 overflow-hidden" data-id="element-1852">
                          <button onClick={() => setOpenConsulate(openConsulate === i ? null : i)} className="w-full flex items-center justify-between px-4 py-3 bg-gray-50 hover:bg-gray-100 transition-colors text-left" data-id="element-1853">
                            <span className={`font-semibold text-sm ${tip.accentColor} uppercase tracking-wide`} data-id="element-1854">
                              {isEs && consulate.nameEs ? consulate.nameEs : consulate.name}
                            </span>
                            <motion.div animate={{
                    rotate: openConsulate === i ? 180 : 0
                  }} transition={{
                    duration: 0.2
                  }} data-id="element-1855">
                              <ChevronDownIcon className={`w-4 h-4 ${tip.accentColor}`} data-id="element-1856" />
                            </motion.div>
                          </button>
                          <AnimatePresence initial={false} data-id="element-1857">
                            {openConsulate === i && <motion.div initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.25,
                    ease: [0.16, 1, 0.3, 1]
                  }} className="overflow-hidden" data-id="element-1858">
                                <div className="px-4 py-3 flex flex-col gap-2 bg-white border-t border-gray-100 text-sm" data-id="element-1859">
                                  <div className="flex items-start gap-2" data-id="element-1860">
                                    <MapPinIcon className="w-4 h-4 text-gray-400 flex-shrink-0 mt-0.5" data-id="element-1861" />
                                    <span className="text-gray-600" data-id="element-1862">
                                      {consulate.address}
                                    </span>
                                  </div>
                                  <div className="flex items-center gap-2" data-id="element-1863">
                                    <PhoneIcon className="w-4 h-4 text-gray-400 flex-shrink-0" data-id="element-1864" />
                                    <a href={`tel:${consulate.phone.replace(/-/g, '')}`} className={`font-semibold ${tip.accentColor} hover:underline`} data-id="element-1865">
                                      {consulate.phone}
                                    </a>
                                  </div>
                                  {consulate.email && <div className="flex items-center gap-2" data-id="element-1866">
                                      <MailIcon className="w-4 h-4 text-gray-400 flex-shrink-0" data-id="element-1867" />
                                      <a href={`mailto:${consulate.email}`} className={`font-semibold ${tip.accentColor} hover:underline`} data-id="element-1868">
                                        {consulate.email}
                                      </a>
                                    </div>}
                                </div>
                              </motion.div>}
                          </AnimatePresence>
                        </div>)}
                    <div className="rounded-xl border border-gray-200 overflow-hidden" data-id="element-1869">
                      <button onClick={() => {
                  setConsulateLocationsOpen(!consulateLocationsOpen);
                  setOpenNestedConsulate(null);
                }} className="w-full flex items-center justify-between px-4 py-3 bg-gray-50 hover:bg-gray-100 transition-colors text-left" data-id="element-1870">
                        <span className={`font-semibold text-sm ${tip.accentColor} uppercase tracking-wide`} data-id="element-1871">
                          {isEs ? 'Ubicaciones de Consulados' : 'Consulate Locations'}
                        </span>
                        <motion.div animate={{
                    rotate: consulateLocationsOpen ? 180 : 0
                  }} transition={{
                    duration: 0.2
                  }} data-id="element-1872">
                          <ChevronDownIcon className={`w-4 h-4 ${tip.accentColor}`} data-id="element-1873" />
                        </motion.div>
                      </button>
                      <AnimatePresence initial={false} data-id="element-1874">
                        {consulateLocationsOpen && <motion.div initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.25,
                    ease: [0.16, 1, 0.3, 1]
                  }} className="overflow-hidden" data-id="element-1875">
                            <div className="bg-white border-t border-gray-100 flex flex-col gap-1 p-3" data-id="element-1876">
                              {tip.consulates.filter(c => !c.isEmbassy).map((consulate, ni) => <div key={`exp-nested-${ni}`} className="rounded-lg border border-gray-100 overflow-hidden" data-id="element-1877">
                                    <button onClick={() => setOpenNestedConsulate(openNestedConsulate === ni ? null : ni)} className="w-full flex items-center justify-between px-3 py-2.5 bg-gray-50 hover:bg-gray-100 transition-colors text-left" data-id="element-1878">
                                      <span className={`font-semibold text-sm ${tip.accentColor}`} data-id="element-1879">
                                        {isEs && consulate.nameEs ? consulate.nameEs : consulate.name}
                                      </span>
                                      <motion.div animate={{
                            rotate: openNestedConsulate === ni ? 180 : 0
                          }} transition={{
                            duration: 0.2
                          }} data-id="element-1880">
                                        <ChevronDownIcon className={`w-3.5 h-3.5 ${tip.accentColor}`} data-id="element-1881" />
                                      </motion.div>
                                    </button>
                                    <AnimatePresence initial={false} data-id="element-1882">
                                      {openNestedConsulate === ni && <motion.div initial={{
                            height: 0,
                            opacity: 0
                          }} animate={{
                            height: 'auto',
                            opacity: 1
                          }} exit={{
                            height: 0,
                            opacity: 0
                          }} transition={{
                            duration: 0.2,
                            ease: [0.16, 1, 0.3, 1]
                          }} className="overflow-hidden" data-id="element-1883">
                                          <div className="px-3 py-2 flex flex-col gap-1.5 bg-white border-t border-gray-100 text-sm" data-id="element-1884">
                                            <div className="flex items-start gap-2" data-id="element-1885">
                                              <MapPinIcon className="w-3.5 h-3.5 text-gray-400 flex-shrink-0 mt-0.5" data-id="element-1886" />
                                              <span className="text-gray-600" data-id="element-1887">
                                                {consulate.address}
                                              </span>
                                            </div>
                                            <div className="flex items-center gap-2" data-id="element-1888">
                                              <PhoneIcon className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" data-id="element-1889" />
                                              <a href={`tel:${consulate.phone.replace(/-/g, '')}`} className={`font-semibold ${tip.accentColor} hover:underline`} data-id="element-1890">
                                                {consulate.phone}
                                              </a>
                                            </div>
                                            {consulate.facebook && <div className="flex items-center gap-2" data-id="element-1891">
                                                <span className="text-gray-400 text-xs" data-id="element-1892">
                                                  FB
                                                </span>
                                                <a href={consulate.facebook} target="_blank" rel="noopener noreferrer" className={`font-semibold ${tip.accentColor} hover:underline`} data-id="element-1893">
                                                  Facebook
                                                </a>
                                              </div>}
                                          </div>
                                        </motion.div>}
                                    </AnimatePresence>
                                  </div>)}
                            </div>
                          </motion.div>}
                      </AnimatePresence>
                    </div>
                  </div>}
                {/* State Apostille Offices — rendered after consulate locations in modal */}
                {tip.links && tip.links.filter(l => l.info === 'state-offices').map((l, _idx) => {
              const stateOfficeIndex = tip.links!.findIndex(link => link.info === 'state-offices');
              return <div key="state-offices-modal" className="mt-3 rounded-xl border overflow-hidden border-gray-200" data-id="element-1894">
                          <div className="flex items-center justify-between px-4 py-3 bg-gray-50" onClick={() => setOpenLinkInfo(openLinkInfo === stateOfficeIndex ? null : stateOfficeIndex)} role="button" data-id="element-1895">
                            <span className={`inline-flex items-center gap-1 font-semibold text-sm ${tip.accentColor}`} data-id="element-1896">
                              {isEs && l.labelEs ? l.labelEs : l.label}
                            </span>
                            <button onClick={e => {
                    e.stopPropagation();
                    setOpenLinkInfo(openLinkInfo === stateOfficeIndex ? null : stateOfficeIndex);
                  }} className="ml-2 flex items-center gap-1 transition-colors text-gray-400 hover:text-gray-600" aria-label="More info" data-id="element-1897">
                              <span className="text-sm font-medium" data-id="element-1898">
                                {t('consular.info.button')}
                              </span>
                              <motion.div animate={{
                      rotate: openLinkInfo === stateOfficeIndex ? 180 : 0
                    }} transition={{
                      duration: 0.2
                    }} data-id="element-1899">
                                <ChevronDownIcon className="w-4 h-4" data-id="element-1900" />
                              </motion.div>
                            </button>
                          </div>
                          <AnimatePresence initial={false} data-id="element-1901">
                            {openLinkInfo === stateOfficeIndex && <motion.div initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.25,
                    ease: [0.16, 1, 0.3, 1]
                  }} className="overflow-hidden" data-id="element-1902">
                                <div className="px-4 py-3 bg-white border-t border-gray-100" data-id="element-1903">
                                  <div className="space-y-3 text-xs text-gray-600" data-id="element-1904">
                                    <p className="font-bold text-gray-800 uppercase tracking-wide" data-id="element-1905">
                                      {isEs ? 'Oficinas de Apostilla por Estado' : 'State Apostille Offices'}
                                    </p>
                                    <div data-id="element-1906">
                                      <p className="font-semibold text-gray-700 mb-0.5" data-id="element-1907">
                                        {isEs ? '🏛️ Oficina Federal' : '🏛️ Federal Office'}
                                      </p>
                                      <p className="pl-2 text-gray-500" data-id="element-1908">
                                        U.S. Department of State Apostille
                                        Office
                                      </p>
                                      <p className="pl-2 text-gray-500" data-id="element-1909">
                                        Office of Authentications
                                      </p>
                                      <p className="pl-2 text-gray-500" data-id="element-1910">
                                        600 19th Street NW, Washington, DC 20006
                                      </p>
                                      <p className="pl-2 text-gray-500" data-id="element-1911">
                                        (202) 485-8000
                                      </p>
                                    </div>
                                    <div className="border-t border-gray-200 pt-2" data-id="element-1912">
                                      <p className="font-bold text-gray-800 mb-2 uppercase tracking-wide text-xs" data-id="element-1913">
                                        {isEs ? 'Oficinas Estatales' : 'State Offices'}
                                      </p>
                                      {[{
                            state: 'Arizona',
                            addresses: ['1700 W Washington St, Phoenix, AZ 85007', '400 West Congress Street, Suite 221, Tucson, AZ 85701'],
                            phone: '(602) 542-4285'
                          }, {
                            state: 'California',
                            addresses: ['1500 11th Street, 3rd Floor, Sacramento, CA 95814', '300 South Spring Street, Room 12513, Los Angeles, CA 90013'],
                            phones: [{
                              label: 'Sacramento',
                              number: '(916) 653-6814'
                            }, {
                              label: 'Los Angeles',
                              number: '(213) 897-5310'
                            }]
                          }, {
                            state: 'Florida',
                            addresses: ['R.A. Gray Building, 500 South Bronough Street, Tallahassee, FL 32399'],
                            phone: '(850) 245-6500'
                          }, {
                            state: 'Georgia',
                            addresses: ['214 State Capitol, Atlanta, GA 30334'],
                            phone: '(470) 312-2808'
                          }, {
                            state: 'Illinois',
                            addresses: ['69 W. Washington St., Suite 1240, Chicago, IL 60602', '2701 S. Dirksen Parkway, Springfield, IL 62723'],
                            phones: [{
                              label: 'Chicago',
                              number: '(312) 814-8218'
                            }, {
                              label: 'Springfield',
                              number: '(217) 782-7017'
                            }]
                          }, {
                            state: 'Louisiana',
                            addresses: ['8585 Archives Ave, Baton Rouge, LA 70809'],
                            phone: '(225) 922-0433'
                          }, {
                            state: 'Maryland',
                            addresses: ['16 Francis Street, Annapolis, MD 21401'],
                            phone: '(410) 974-5521'
                          }, {
                            state: 'Massachusetts',
                            addresses: ['One Ashburton Place, Room 1719, Boston, MA 02108'],
                            phone: '(617) 727-9180'
                          }, {
                            state: 'New Jersey',
                            addresses: ['33 West State Street, 5th Floor, Trenton, NJ 08608'],
                            phone: '(609) 292-4925'
                          }, {
                            state: 'New York',
                            addresses: ['99 Washington Avenue, Albany, NY 12231', '123 William St #2, New York, NY 10038'],
                            phone: '(518) 474-4429'
                          }, {
                            state: 'North Carolina',
                            addresses: ['2 South Salisbury Street, Raleigh, NC 27601'],
                            phone: '(919) 814-5400'
                          }, {
                            state: 'Pennsylvania',
                            addresses: ['210 North Office Building, Harrisburg, PA 17120'],
                            phone: '(717) 787-5280'
                          }, {
                            state: 'Texas',
                            addresses: ['1019 Brazos, Austin, TX 78701'],
                            phone: '(512) 463-5705'
                          }, {
                            state: 'Virginia',
                            addresses: ['1111 East Broad Street, Richmond, VA 23219'],
                            phone: '(804) 786-2441'
                          }, {
                            state: 'Washington D.C.',
                            addresses: ['899 North Capitol Street, NE, Suite 8100'],
                            phone: '(202) 727-3117'
                          }].map((entry, si) => <div key={si} className="bg-blue-50 rounded-lg p-2 mb-1.5" data-id="element-1914">
                                          <p className="font-semibold text-haa-blue text-xs mb-0.5" data-id="element-1915">
                                            {entry.state}
                                          </p>
                                          {entry.addresses.length > 1 ? <ul className="space-y-0.5 pl-1" data-id="element-1916">
                                              {entry.addresses.map((addr, ai) => <li key={ai} className="flex items-start gap-1.5 text-gray-500" data-id="element-1917">
                                                    <span className="text-gray-400 mt-0.5 flex-shrink-0" data-id="element-1918">
                                                      •
                                                    </span>
                                                    <span data-id="element-1919">{addr}</span>
                                                  </li>)}
                                            </ul> : entry.addresses.map((addr, ai) => <p key={ai} className="pl-1 text-gray-500" data-id="element-1920">
                                                {addr}
                                              </p>)}
                                          {entry.phones ? entry.phones.map((p: {
                              label: string;
                              number: string;
                            }, pi: number) => <div key={pi} className="flex items-center gap-1 mt-0.5 pl-1" data-id="element-1921">
                                                  <PhoneIcon className="w-3 h-3 text-gray-400 flex-shrink-0" data-id="element-1922" />
                                                  <a href={`tel:${p.number.replace(/[^0-9+]/g, '')}`} className="text-emerald-600 font-semibold hover:underline" data-id="element-1923">
                                                    {p.label}: {p.number}
                                                  </a>
                                                </div>) : entry.phone ? <div className="flex items-center gap-1 mt-0.5 pl-1" data-id="element-1924">
                                              <PhoneIcon className="w-3 h-3 text-gray-400 flex-shrink-0" data-id="element-1925" />
                                              <a href={`tel:${entry.phone.replace(/[^0-9+]/g, '')}`} className="text-emerald-600 font-semibold hover:underline" data-id="element-1926">
                                                {entry.phone}
                                              </a>
                                            </div> : null}
                                        </div>)}
                                    </div>
                                  </div>
                                </div>
                              </motion.div>}
                          </AnimatePresence>
                        </div>;
            })}

                {tip.link && <div className="mt-4 flex flex-col gap-3" data-id="element-1927">
                    {/* Emergency Assistance Dropdown */}
                    <div className="rounded-xl border border-gray-200 overflow-hidden" data-id="element-1928">
                      <button onClick={() => setEmergencyOpen(!emergencyOpen)} className="w-full flex items-center justify-between px-4 py-3 bg-gray-50 hover:bg-gray-100 transition-colors text-left" data-id="element-1929">
                        <span className={`font-semibold text-sm ${tip.accentColor} uppercase tracking-wide`} data-id="element-1930">
                          {isEs ? '🚨 Asistencia de Emergencia' : '🚨 Emergency Assistance'}
                        </span>
                        <motion.div animate={{
                    rotate: emergencyOpen ? 180 : 0
                  }} transition={{
                    duration: 0.2
                  }} data-id="element-1931">
                          <ChevronDownIcon className={`w-4 h-4 ${tip.accentColor}`} data-id="element-1932" />
                        </motion.div>
                      </button>
                      <AnimatePresence initial={false} data-id="element-1933">
                        {emergencyOpen && <motion.div initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.25,
                    ease: [0.16, 1, 0.3, 1]
                  }} className="overflow-hidden" data-id="element-1934">
                            <div className="px-4 py-3 bg-white border-t border-gray-100 text-sm text-gray-600 space-y-2" data-id="element-1935">
                              <img src="https://cdn.magicpatterns.com/uploads/hLxF4YHQUyJak43UqQtdRn/Tegucigalpa_MCACView_Resized-2-1024x753.jpg" alt={isEs ? 'Embajada de los Estados Unidos de América en Tegucigalpa' : 'Embassy of the United States of America in Tegucigalpa'} className="w-full rounded-xl object-cover mb-3" data-id="element-1936" />
                              <p className="leading-relaxed" data-id="element-1937">
                                {isEs ? 'Para emergencias en Honduras, los ciudadanos estadounidenses deben llamar al ' : 'For emergencies in Honduras, U.S. citizens should call '}
                                <strong data-id="element-1938">911</strong>
                                {isEs ? ' para policía local, bomberos o asistencia médica.' : ' for local police, fire, or medical assistance.'}
                              </p>
                              <div className="flex items-center gap-2" data-id="element-1939">
                                <PhoneIcon className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" data-id="element-1940" />
                                <span data-id="element-1941">
                                  {isEs ? 'Embajada de EE.UU. Emergencias:' : 'U.S. Embassy Emergency:'}
                                </span>
                                <a href="tel:+50422385114" className={`font-semibold ${tip.accentColor} hover:underline`} data-id="element-1942">
                                  +504 2238-5114
                                </a>
                              </div>
                              <div className="flex items-center gap-2" data-id="element-1943">
                                <PhoneIcon className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" data-id="element-1944" />
                                <span data-id="element-1945">
                                  {isEs ? 'Fuera de Horario:' : 'After Hours:'}
                                </span>
                                <a href="tel:+50422369320" className={`font-semibold ${tip.accentColor} hover:underline`} data-id="element-1946">
                                  +504 2236-9320
                                </a>
                              </div>
                              <div className="flex items-center gap-2" data-id="element-1947">
                                <PhoneIcon className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" data-id="element-1948" />
                                <span data-id="element-1949">
                                  {isEs ? 'Consulta General (Tegucigalpa):' : 'General Inquiries (Tegucigalpa):'}
                                </span>
                                <a href="tel:+50422175000" className={`font-semibold ${tip.accentColor} hover:underline`} data-id="element-1950">
                                  +504 2217-5000
                                </a>
                              </div>
                            </div>
                          </motion.div>}
                      </AnimatePresence>
                    </div>

                    <a href="https://prechequeo.inm.gob.hn/" target="_blank" rel="noopener noreferrer" className={`inline-flex items-center gap-1 font-semibold text-sm ${tip.accentColor} hover:underline`} data-id="element-1951">
                      {isEs ? 'Pre-chequeo Migratorio de Honduras' : 'Honduras Immigration Pre-check'}{' '}
                      →
                    </a>
                    <a href="https://sisglobal.aduanas.gob.hn/Pech/#/plataforma/otra_gestiones/formularioDJRV" target="_blank" rel="noopener noreferrer" className={`inline-flex items-center gap-1 font-semibold text-sm ${tip.accentColor} hover:underline`} data-id="element-1952">
                      {isEs ? 'Formulario de Viaje de Aduanas de Honduras' : 'Honduras Customs Travel Form'}{' '}
                      →
                    </a>
                    <a href={tip.link.url} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center gap-1 font-semibold text-sm ${tip.accentColor} hover:underline`} data-id="element-1953">
                      {isEs ? 'Aviso de Viaje para Honduras' : tip.link.label} →
                    </a>
                    <a href="https://mytravel.state.gov/s/step" target="_blank" rel="noopener noreferrer" className={`inline-flex items-center gap-1 font-semibold text-sm ${tip.accentColor} hover:underline`} data-id="element-1954">
                      {isEs ? 'STEP – Programa de Inscripción para Viajeros Inteligentes' : 'STEP – Smart Traveler Enrollment Program'}{' '}
                      →
                    </a>
                    <a href="https://www.instagram.com/usembassyhn/" target="_blank" rel="noopener noreferrer" className={`inline-flex items-center gap-1 font-semibold text-sm ${tip.accentColor} hover:underline`} data-id="element-1955">
                      {isEs ? 'Embajada de EE.UU. en Honduras (Instagram)' : 'US Embassy Honduras (Instagram)'}{' '}
                      →
                    </a>
                    <a href="https://hn.usembassy.gov/" target="_blank" rel="noopener noreferrer" className={`inline-flex items-center gap-1 font-semibold text-sm ${tip.accentColor} hover:underline`} data-id="element-1956">
                      {isEs ? 'Embajada de EE.UU. en Honduras (Página Principal)' : 'US Embassy Honduras (Homepage)'}{' '}
                      →
                    </a>
                    <a href="https://hn.usembassy.gov/education/" target="_blank" rel="noopener noreferrer" className={`inline-flex items-center gap-1 font-semibold text-sm ${tip.accentColor} hover:underline`} data-id="element-1957">
                      {isEs ? 'Embajada de EE.UU. en Honduras (Educación)' : 'US Embassy Honduras (Education)'}{' '}
                      →
                    </a>
                    <a href="https://www.uscis.gov/" target="_blank" rel="noopener noreferrer" className={`inline-flex items-center gap-1 font-semibold text-sm ${tip.accentColor} hover:underline`} data-id="element-1958">
                      {isEs ? 'USCIS — Servicios de Ciudadanía e Inmigración de EE.UU.' : 'USCIS — U.S. Citizenship and Immigration Services'}{' '}
                      →
                    </a>
                  </div>}
              </div>

              {/* Footer */}
              <div className="px-6 py-4 border-t border-gray-100 bg-gray-50/50 flex justify-end" data-id="element-1959">
                <button onClick={() => setExpandedModal(false)} className="px-6 py-2.5 bg-haa-navy hover:bg-haa-blue text-white font-nunito font-bold text-sm rounded-xl transition-colors" data-id="element-1960">
                  {isEs ? 'Cerrar' : 'Close'}
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </motion.article>;
}
function ImportantNoticeDropdown({
  isEs
}: {
  isEs: boolean;
}) {
  const [open, setOpen] = useState(false);
  return <div className="mt-6 max-w-3xl mx-auto bg-amber-50 border-2 border-amber-300 rounded-2xl overflow-hidden" data-id="element-1961">
      <button onClick={() => setOpen(!open)} aria-expanded={open} className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-amber-100/50 transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400" data-id="element-1962">
        <p className="font-nunito text-amber-900 text-sm font-bold" data-id="element-1963">
          ⚠️ {isEs ? 'AVISO IMPORTANTE' : 'IMPORTANT NOTICE'}
        </p>
        <motion.div animate={{
        rotate: open ? 180 : 0
      }} transition={{
        duration: 0.25,
        ease: [0.16, 1, 0.3, 1]
      }} className="flex-shrink-0 ml-2" data-id="element-1964">
          <ChevronDownIcon className="w-5 h-5 text-amber-700" data-id="element-1965" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-1966">
        {open && <motion.div key="notice-content" initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: [0.16, 1, 0.3, 1]
      }} className="overflow-hidden" data-id="element-1967">
            <div className="px-5 pb-5 pt-1" data-id="element-1968">
              <ul className="font-nunito text-amber-800 text-sm leading-relaxed space-y-2 list-disc list-inside pl-1" data-id="element-1969">
                <li data-id="element-1970">
                  {isEs ? 'Ningún funcionario consular le pedirá ni aceptará dinero a cambio de ayuda para hacer citas, obtener acceso especial o acelerar trámites.' : 'No consular official will ever ask for or accept money in exchange for help making appointments, gaining special access, or expediting services.'}
                </li>
                <li data-id="element-1971">
                  {isEs ? 'Si alguien le pide que pague por estos servicios, es una estafa e ilegal.' : 'If someone asks you to pay for these services, it is a scam and illegal.'}
                </li>
                <li data-id="element-1972">
                  {isEs ? 'Hay muchos estafadores que intentan aprovecharse de nuestra comunidad.' : 'There are many scammers who try to take advantage of our community.'}
                </li>
                <li data-id="element-1973">
                  {isEs ? 'Llame directamente a su consulado local para obtener información actualizada.' : 'Call your local consulate directly for up-to-date information.'}
                </li>
              </ul>
              <p className="font-nunito text-amber-800 text-sm mt-3" data-id="element-1974">
                {isEs ? 'Contáctenos:' : 'Contact us:'}{' '}
                <a href="mailto:info@honduranamerican.org" className="text-amber-900 underline hover:text-amber-700 transition-colors font-semibold" data-id="element-1975">
                  info@honduranamerican.org
                </a>{' '}
                {isEs ? 'o por WhatsApp al' : 'or WhatsApp'}{' '}
                <a href="https://wa.me/17033131465" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-amber-900 underline hover:text-amber-700 transition-colors font-semibold" data-id="element-1976">
                  <svg className="w-4 h-4 inline-block" viewBox="0 0 24 24" fill="currentColor" data-id="element-1977">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413-1.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-1978" />
                  </svg>
                  +1-703-313-1465
                </a>
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
function ScamAlertDropdown({
  isEs
}: {
  isEs: boolean;
}) {
  const [open, setOpen] = useState(false);
  return <div className="mt-4 max-w-3xl mx-auto bg-red-50 border-2 border-red-400 rounded-2xl overflow-hidden" data-id="element-1979">
      <button onClick={() => setOpen(!open)} aria-expanded={open} className="w-full flex items-center justify-between gap-3 p-5 text-left hover:bg-red-100/50 transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-400" data-id="element-1980">
        <div className="flex items-center gap-3" data-id="element-1981">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-red-500 to-red-700 flex items-center justify-center flex-shrink-0 shadow-md" data-id="element-1982">
            <AlertTriangleIcon className="w-5 h-5 text-white" data-id="element-1983" />
          </div>
          <div data-id="element-1984">
            <p className="font-nunito text-red-800 text-sm font-bold uppercase tracking-wide" data-id="element-1985">
              🚨{' '}
              {isEs ? 'ALERTA URGENTE — AVISO IMPORTANTE' : 'URGENT ALERT — IMPORTANT NOTICE'}
            </p>
            <p className="font-nunito text-red-700 text-sm mt-1" data-id="element-1986">
              {isEs ? 'Actualmente existen varias estafas relacionadas con Servicios de Consulados Móviles. No sea víctima de estas estafas.' : 'There are currently several scams regarding Mobile Consulate Services. Do not fall victim to these scams.'}
            </p>
          </div>
        </div>
        <motion.div animate={{
        rotate: open ? 180 : 0
      }} transition={{
        duration: 0.25,
        ease: [0.16, 1, 0.3, 1]
      }} className="flex-shrink-0" data-id="element-1987">
          <ChevronDownIcon className="w-5 h-5 text-red-500" data-id="element-1988" />
        </motion.div>
      </button>

      <AnimatePresence initial={false} data-id="element-1989">
        {open && <motion.div key="scam-content" initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: [0.16, 1, 0.3, 1]
      }} className="overflow-hidden" data-id="element-1990">
            <div className="px-5 pb-5 border-t border-red-200" data-id="element-1991">
              <div className="mt-4 rounded-xl overflow-hidden shadow-lg" data-id="element-1992">
                <img src="https://cdn.magicpatterns.com/uploads/avvfwGr9GFgPjgcpLD7X7r/Consulado_Moviles_Aviso.jpg" alt={isEs ? 'Aviso oficial sobre consulados móviles' : 'Official notice about mobile consulates'} loading="lazy" className="w-full h-auto" data-id="element-1993" />
              </div>
              <div className="mt-4 space-y-3" data-id="element-1994">
                <p className="font-nunito text-red-800 text-sm font-bold text-center" data-id="element-1995">
                  {isEs ? '⚠️ Aclaración Importante de la Secretaría de Relaciones Exteriores:' : '⚠️ Important Clarification from the Ministry of Foreign Affairs:'}
                </p>
                <ul className="font-nunito text-red-800 text-sm leading-relaxed space-y-2 list-disc list-inside pl-1" data-id="element-1996">
                  <li data-id="element-1997">
                    {isEs ? 'Hasta el momento NO se tiene en el calendario la realización de Consulados Móviles.' : 'There are currently NO Mobile Consulates scheduled on the calendar.'}
                  </li>
                  <li data-id="element-1998">
                    {isEs ? 'Estas jornadas requieren planificación y coordinación con instituciones como INM y RNP.' : 'These events require planning and coordination with institutions such as INM and RNP.'}
                  </li>
                  <li data-id="element-1999">
                    {isEs ? 'Cualquier actividad relacionada será anunciada únicamente a través de los canales oficiales de Cancillería y Consulados.' : 'Any related activity will be announced only through the official channels of the Ministry of Foreign Affairs and Consulates.'}
                  </li>
                  <li data-id="element-2000">
                    {isEs ? 'No existe intermediación con terceros para la gestión de estos servicios.' : 'There is no intermediation with third parties for the management of these services.'}
                  </li>
                </ul>
                <div className="bg-red-100 rounded-xl p-4 border border-red-300 mt-3" data-id="element-2001">
                  <p className="font-nunito text-red-900 text-sm font-bold text-center" data-id="element-2002">
                    {isEs ? '🛑 Si alguien le pide dinero para servicios de consulado móvil, es una ESTAFA.' : '🛑 If someone asks you for money for mobile consulate services, it is a SCAM.'}
                  </p>
                  <p className="font-nunito text-red-800 text-sm mt-2 text-center" data-id="element-2003">
                    {isEs ? 'Repórtelo a:' : 'Report it to:'}{' '}
                    <a href="mailto:info@honduranamerican.org" className="text-red-900 underline hover:text-red-700 transition-colors font-semibold" data-id="element-2004">
                      info@honduranamerican.org
                    </a>{' '}
                    {isEs ? 'o por WhatsApp al' : 'or WhatsApp'}{' '}
                    <a href="https://wa.me/17033131465" target="_blank" rel="noopener noreferrer" className="text-red-900 underline hover:text-red-700 transition-colors font-semibold" data-id="element-2005">
                      +1-703-313-1465
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function ConsularAffairs() {
  const titleRef = useRef<HTMLDivElement>(null);
  const titleInView = useInView(titleRef, {
    once: true
  });
  const {
    t,
    language
  } = useLanguage();
  const isEs = language === 'ES';
  return <section id="consular-affairs" className="bg-white py-16 lg:py-24" aria-labelledby="consular-heading" data-id="element-2006">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2007">
        <div ref={titleRef} className="text-center mb-14" data-id="element-2008">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={titleInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6
        }} data-id="element-2009">
            <span className="font-nunito text-haa-blue text-sm uppercase tracking-[0.3em] font-semibold" data-id="element-2010">
              {t('consular.label')}
            </span>
            <h2 id="consular-heading" className="font-bebas text-6xl sm:text-7xl lg:text-8xl text-haa-navy tracking-wider mt-2" data-id="element-2011">
              {t('consular.heading')}
            </h2>
            <div className="flex items-center justify-center gap-3 mt-4" data-id="element-2012">
              <div className="w-12 h-1 bg-haa-blue rounded-full" data-id="element-2013" />
              <div className="w-3 h-3 rounded-full bg-haa-skyblue" data-id="element-2014" />
              <div className="w-12 h-1 bg-haa-midblue rounded-full" data-id="element-2015" />
            </div>
            <p className="font-nunito text-gray-600 text-lg mt-6 max-w-2xl mx-auto" data-id="element-2016">
              {t('consular.description')}
            </p>
            <div className="mt-5 max-w-2xl mx-auto bg-gradient-to-r from-haa-blue/5 via-haa-skyblue/10 to-haa-blue/5 border border-haa-skyblue/30 rounded-2xl p-4 text-center" data-id="element-2017">
              <p className="font-nunito text-gray-600 text-sm leading-relaxed" data-id="element-2018">
                ⭐ Special thanks to{' '}
                <span className="font-bold text-haa-navy" data-id="element-2019">
                  Guillermo Matuty, Consul General of Washington D.C.
                </span>
                , for allowing us to learn firsthand about the consular
                processes through hundreds of hours of volunteering and many
                discussions on the consular needs of our compatriots. ⭐
              </p>
            </div>
            <ImportantNoticeDropdown isEs={isEs} data-id="element-2020" />

            <ScamAlertDropdown isEs={isEs} data-id="element-2021" />
          </motion.div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-6" data-id="element-2022">
          {tips.map((tip, i) => <TipCard key={tip.titleKey + i} tip={tip} index={i} data-id="element-2023" />)}
        </div>
      </div>
    </section>;
}